var items = {
  "block.minecraft.acacia_button": "Akasiahboton",
  "block.minecraft.acacia_door": "Akasiahkaltēntli",
  "block.minecraft.acacia_fence": "Akasiahchināmitl",
  "block.minecraft.acacia_fence_gate": "Akasiahchināntēntli",
  "block.minecraft.acacia_hanging_sign": "Akasiahkwatlahkwilōlli wiyōnkētl",
  "block.minecraft.acacia_leaves": "Akasiahxiwiyōtl",
  "block.minecraft.acacia_log": "Akasiahkwatomaktli",
  "block.minecraft.acacia_planks": "Akasiahwapalli",
  "block.minecraft.acacia_pressure_plate": "Akasiahtlakomaltektli",
  "block.minecraft.acacia_sapling": "Akasiahchamānkētl",
  "block.minecraft.acacia_shelf": "Akasiahākōmitl",
  "block.minecraft.acacia_sign": "Akasiahkwatlahkwilōlli",
  "block.minecraft.acacia_slab": "Akasiahitstapalli",
  "block.minecraft.acacia_stairs": "Akasiahtlehkōlli",
  "block.minecraft.acacia_trapdoor": "Akasiahtlaketstēntli",
  "block.minecraft.acacia_wall_hanging_sign": "Akasiahtepankwatlahkwilōlli wiyōnkētl",
  "block.minecraft.acacia_wall_sign": "Akasiahtepankwatlahkwilōlli",
  "block.minecraft.acacia_wood": "Akasiahkwawitl",
  "block.minecraft.activator_rail": "Teposohtli tlahsiwitihkētl",
  "block.minecraft.air": "Ehēkatl",
  "block.minecraft.allium": "Āxoxxōchitl",
  "block.minecraft.amethyst_block": "Ayohpāltewilōxamixtli",
  "block.minecraft.amethyst_cluster": "Mātstik ayohpāltewilōtl",
  "block.minecraft.ancient_debris": "Wēwētki tlāltepewalistli",
  "block.minecraft.andesite": "Antesitah",
  "block.minecraft.andesite_slab": "Antesitahitstapalli",
  "block.minecraft.andesite_stairs": "Antesitahtlehkōlli",
  "block.minecraft.andesite_wall": "Antesitahtepantli",
  "block.minecraft.anvil": "Tepōstlatsonalōni",
  "block.minecraft.attached_melon_stem": "Tlasēntīlilli santiahkwayōtl",
  "block.minecraft.attached_pumpkin_stem": "Tlasēntīlilli tamalayohkwayōtl",
  "block.minecraft.azalea": "Asaleah",
  "block.minecraft.azalea_leaves": "Asaleahxiwiyōtl",
  "block.minecraft.azure_bluet": "Istāltik xōchitl",
  "block.minecraft.bamboo": "Chīmalākatl",
  "block.minecraft.bamboo_block": "Chīmalākaxamixtli",
  "block.minecraft.bamboo_button": "Chīmalākaboton",
  "block.minecraft.bamboo_door": "Chīmalākakaltēntli",
  "block.minecraft.bamboo_fence": "Chīmalākachināmitl",
  "block.minecraft.bamboo_fence_gate": "Chīmalākachināntēntli",
  "block.minecraft.bamboo_hanging_sign": "Chīmalākakwatlahkwilōlli wiyōnkētl",
  "block.minecraft.bamboo_mosaic": "Chīmalākasālolistli",
  "block.minecraft.bamboo_mosaic_slab": "Chīmalākasālolisitstapalli",
  "block.minecraft.bamboo_mosaic_stairs": "Chīmalākasālolistlehkōlli",
  "block.minecraft.bamboo_planks": "Chīmalākawapalli",
  "block.minecraft.bamboo_pressure_plate": "Chīmalākatlakomaltektli",
  "block.minecraft.bamboo_sapling": "Chīmalākatoktli",
  "block.minecraft.bamboo_shelf": "Chīmalākaākōmitl",
  "block.minecraft.bamboo_sign": "Chīmalākakwatlahkwilōlli",
  "block.minecraft.bamboo_slab": "Chīmalākastapalli",
  "block.minecraft.bamboo_stairs": "Chīmalākatlehkōlli",
  "block.minecraft.bamboo_trapdoor": "Chīmalākatlaketstēntli",
  "block.minecraft.bamboo_wall_hanging_sign": "Chīmalākatepankwatlahkwilōlli wiyōnkētl",
  "block.minecraft.bamboo_wall_sign": "Chīmalākatepankwatlahkwilōlli",
  "block.minecraft.banner.base.black": "Nelliya yāyāwik yoyōmitl",
  "block.minecraft.banner.base.blue": "Nelliya āsoltik yoyōmitl",
  "block.minecraft.banner.base.brown": "Nelliya kafēntik yoyōmitl",
  "block.minecraft.banner.base.cyan": "Nelliya xiwtik yoyōmitl",
  "block.minecraft.banner.base.gray": "Nelliya tenextik yoyōmitl",
  "block.minecraft.banner.base.green": "Nelliya xoxoktik yoyōmitl",
  "block.minecraft.banner.base.light_blue": "Nelliya tsiktik yoyōmitl",
  "block.minecraft.banner.base.light_gray": "Nelliya ātenextik yoyōmitl",
  "block.minecraft.banner.base.lime": "Nelliya xoxōwik yoyōmitl",
  "block.minecraft.banner.base.magenta": "Chīltik yoyōmitl",
  "block.minecraft.banner.base.orange": "Nelliya chīlkōstik yoyōmitl",
  "block.minecraft.banner.base.pink": "Nelliya iselik yoyōmitl",
  "block.minecraft.banner.base.purple": "Nelliya kamohtik yoyōmitl",
  "block.minecraft.banner.base.red": "Nelliya chīltik yoyōmitl",
  "block.minecraft.banner.base.white": "Nelliya chipāwak yoyōmitl",
  "block.minecraft.banner.base.yellow": "Nelliya kōstik yoyōmitl",
  "block.minecraft.banner.border.black": "Yāyāwik tēnyōtl",
  "block.minecraft.banner.border.blue": "Āsoltik tēnyōtl",
  "block.minecraft.banner.border.brown": "Kafēntik tēnyōtl",
  "block.minecraft.banner.border.cyan": "Xiwtik tēnyōtl",
  "block.minecraft.banner.border.gray": "Tenextik tēnyōtl",
  "block.minecraft.banner.border.green": "Xoxoktik tēnyōtl",
  "block.minecraft.banner.border.light_blue": "Tsiktik tēnyōtl",
  "block.minecraft.banner.border.light_gray": "Ātenextik tēnyōtl",
  "block.minecraft.banner.border.lime": "Xoxōwik tēnyōtl",
  "block.minecraft.banner.border.magenta": "Ayohpāltik tēnyōtl",
  "block.minecraft.banner.border.orange": "Chīlkōstik tēnyōtl",
  "block.minecraft.banner.border.pink": "Iselik tēnyōtl",
  "block.minecraft.banner.border.purple": "Kamohtik tēnyōtl",
  "block.minecraft.banner.border.red": "Chīltik tēnyōtl",
  "block.minecraft.banner.border.white": "Chipāwak tēnyōtl",
  "block.minecraft.banner.border.yellow": "Kōstik tēnyōtl",
  "block.minecraft.banner.bricks.black": "Yāyāwik kalxamixxōtl",
  "block.minecraft.banner.bricks.blue": "Āsoltik kalxamixxōtl",
  "block.minecraft.banner.bricks.brown": "Kafēntik kalxamixxōtl",
  "block.minecraft.banner.bricks.cyan": "Xiwtik kalxamixxōtl",
  "block.minecraft.banner.bricks.gray": "Tenextik kalxamixxōtl",
  "block.minecraft.banner.bricks.green": "Xoxoktik kalxamixxōtl",
  "block.minecraft.banner.bricks.light_blue": "Tsiktik kalxamixxōtl",
  "block.minecraft.banner.bricks.light_gray": "Ātenextik kalxamixxōtl",
  "block.minecraft.banner.bricks.lime": "Xoxōwik kalxamixxōtl",
  "block.minecraft.banner.bricks.magenta": "Ayohpāltik kalxamixxōtl",
  "block.minecraft.banner.bricks.orange": "Chīlkōstik kalxamixxōtl",
  "block.minecraft.banner.bricks.pink": "Iselik kalxamixxōtl",
  "block.minecraft.banner.bricks.purple": "Kamohtik kalxamixxōtl",
  "block.minecraft.banner.bricks.red": "Chīltik kalxamixxōtl",
  "block.minecraft.banner.bricks.white": "Chipāwak kalxamixxōtl",
  "block.minecraft.banner.bricks.yellow": "Kōstik kalxamixxōtl",
  "block.minecraft.banner.circle.black": "Yāyāwik ololli",
  "block.minecraft.banner.circle.blue": "Āsoltik ololli",
  "block.minecraft.banner.circle.brown": "Kafēntik ololli",
  "block.minecraft.banner.circle.cyan": "Xiwtik ololli",
  "block.minecraft.banner.circle.gray": "Tenextik ololli",
  "block.minecraft.banner.circle.green": "Xoxoktik ololli",
  "block.minecraft.banner.circle.light_blue": "Tsiktik ololli",
  "block.minecraft.banner.circle.light_gray": "Ātenextik ololli",
  "block.minecraft.banner.circle.lime": "Xoxōwik ololli",
  "block.minecraft.banner.circle.magenta": "Ayohpāltik ololli",
  "block.minecraft.banner.circle.orange": "Chīlkōstik ololli",
  "block.minecraft.banner.circle.pink": "Iselik ololli",
  "block.minecraft.banner.circle.purple": "Kamohtik ololli",
  "block.minecraft.banner.circle.red": "Chīltik ololli",
  "block.minecraft.banner.circle.white": "Chipāwak ololli",
  "block.minecraft.banner.circle.yellow": "Kōstik ololli",
  "block.minecraft.banner.creeper.black": "Yāyāwik creeper",
  "block.minecraft.banner.creeper.blue": "Āsoltik creeper",
  "block.minecraft.banner.creeper.brown": "Kafēntik creeper",
  "block.minecraft.banner.creeper.cyan": "Xiwtik creeper",
  "block.minecraft.banner.creeper.gray": "Tenextik creeper",
  "block.minecraft.banner.creeper.green": "Xoxoktik creeper",
  "block.minecraft.banner.creeper.light_blue": "Tsiktik creeper",
  "block.minecraft.banner.creeper.light_gray": "Ātenextik creeper",
  "block.minecraft.banner.creeper.lime": "Xoxōwik creeper",
  "block.minecraft.banner.creeper.magenta": "Ayohpāltik creeper",
  "block.minecraft.banner.creeper.orange": "Chīlkōstik creeper",
  "block.minecraft.banner.creeper.pink": "Iselik creeper",
  "block.minecraft.banner.creeper.purple": "Kamohtik creeper",
  "block.minecraft.banner.creeper.red": "Chīltik creeper",
  "block.minecraft.banner.creeper.white": "Chipāwak creeper",
  "block.minecraft.banner.creeper.yellow": "Kōstik creeper",
  "block.minecraft.banner.cross.black": "Yāyāwik sohter",
  "block.minecraft.banner.cross.blue": "Āsoltik sohter",
  "block.minecraft.banner.cross.brown": "Kafēntik sohter",
  "block.minecraft.banner.cross.cyan": "Xiwtik sohter",
  "block.minecraft.banner.cross.gray": "Tenextik sowter",
  "block.minecraft.banner.cross.green": "Xoxoktik sohter",
  "block.minecraft.banner.cross.light_blue": "Tsiktik sohter",
  "block.minecraft.banner.cross.light_gray": "Ātenextik sohter",
  "block.minecraft.banner.cross.lime": "Xoxōwik sohter",
  "block.minecraft.banner.cross.magenta": "Ayohpāltik sohter",
  "block.minecraft.banner.cross.orange": "Chīlkōstik sohter",
  "block.minecraft.banner.cross.pink": "Iselik sohter",
  "block.minecraft.banner.cross.purple": "Kamohtik sohter",
  "block.minecraft.banner.cross.red": "Chīltik sohter",
  "block.minecraft.banner.cross.white": "Chipāwak sohter",
  "block.minecraft.banner.cross.yellow": "Kōstik sohter",
  "block.minecraft.banner.curly_border.black": "Tsitsikiltik yāyāwik tēnyōtl",
  "block.minecraft.banner.curly_border.blue": "Tsitsikiltik āsoltik tēnyōtl",
  "block.minecraft.banner.curly_border.brown": "Tsitsikiltik kafēntik tēnyōtl",
  "block.minecraft.banner.curly_border.cyan": "Tsitsikiltik xiwtik tēnyōtl",
  "block.minecraft.banner.curly_border.gray": "Tsitsikiltik tenextik tēnyōtl",
  "block.minecraft.banner.curly_border.green": "Tsitsikiltik xoxoktik tēnyōtl",
  "block.minecraft.banner.curly_border.light_blue": "Tsitsikiltik tsiktik tēnyōtl",
  "block.minecraft.banner.curly_border.light_gray": "Tsitsikiltik ātenextik tēnyōtl",
  "block.minecraft.banner.curly_border.lime": "Tsitsikiltik xoxōwik tēnyōtl",
  "block.minecraft.banner.curly_border.magenta": "Tsitsikiltik ayohpāltik tēnyōtl",
  "block.minecraft.banner.curly_border.orange": "Tsitsikiltik chīlkōstik tēnyōtl",
  "block.minecraft.banner.curly_border.pink": "Tsitsikiltik iselik tēnyōtl",
  "block.minecraft.banner.curly_border.purple": "Tsitsikiltik kamohtik tēnyōtl",
  "block.minecraft.banner.curly_border.red": "Tsitsikiltik chīltik tēnyōtl",
  "block.minecraft.banner.curly_border.white": "Tsitsikiltik chipāwak tēnyōtl",
  "block.minecraft.banner.curly_border.yellow": "Tsitsikiltik kōstik tēnyōtl",
  "block.minecraft.banner.diagonal_left.black": "Yāyāwik tlatehtektli",
  "block.minecraft.banner.diagonal_left.blue": "Āsoltik tlatehtektli",
  "block.minecraft.banner.diagonal_left.brown": "Kafēntik tlatehtektli",
  "block.minecraft.banner.diagonal_left.cyan": "Xiwtik tlatehtektli",
  "block.minecraft.banner.diagonal_left.gray": "Tenextik tlatehtektli",
  "block.minecraft.banner.diagonal_left.green": "Xoxoktik tlatehtektli",
  "block.minecraft.banner.diagonal_left.light_blue": "Tsiktik tlatehtektli",
  "block.minecraft.banner.diagonal_left.light_gray": "Ātenextik tlatehtektli",
  "block.minecraft.banner.diagonal_left.lime": "Xoxōwik tlatehtektli",
  "block.minecraft.banner.diagonal_left.magenta": "Ayohpāltik tlatehtektli",
  "block.minecraft.banner.diagonal_left.orange": "Chīlkōstik tlatehtektli",
  "block.minecraft.banner.diagonal_left.pink": "Iselik tlatehtektli",
  "block.minecraft.banner.diagonal_left.purple": "Kamohtik tlatehtektli",
  "block.minecraft.banner.diagonal_left.red": "Chīltik tlatehtektli",
  "block.minecraft.banner.diagonal_left.white": "Chipāwak tlatehtektli",
  "block.minecraft.banner.diagonal_left.yellow": "Kōstik tlatehtektli",
  "block.minecraft.banner.diagonal_right.black": "Yāyāwik tlaalaxolli",
  "block.minecraft.banner.diagonal_right.blue": "Āsoltik tlaalaxolli",
  "block.minecraft.banner.diagonal_right.brown": "Kafēntik tlaalaxolli",
  "block.minecraft.banner.diagonal_right.cyan": "Xiwtik tlaalaxolli",
  "block.minecraft.banner.diagonal_right.gray": "Tenextik tlaalaxolli",
  "block.minecraft.banner.diagonal_right.green": "Xoxoktik tlaalaxolli",
  "block.minecraft.banner.diagonal_right.light_blue": "Tsiktik tlaalaxolli",
  "block.minecraft.banner.diagonal_right.light_gray": "Ātenextik tlaalaxolli",
  "block.minecraft.banner.diagonal_right.lime": "Xoxōwik tlaalaxolli",
  "block.minecraft.banner.diagonal_right.magenta": "Ayohpāltik tlaalaxolli",
  "block.minecraft.banner.diagonal_right.orange": "Chīlkōstik tlaalaxolli",
  "block.minecraft.banner.diagonal_right.pink": "Iselik tlaalaxolli",
  "block.minecraft.banner.diagonal_right.purple": "Kamohtik tlaalaxolli",
  "block.minecraft.banner.diagonal_right.red": "Chīltik tlaalaxolli",
  "block.minecraft.banner.diagonal_right.white": "Chipāwak tlaalaxolli",
  "block.minecraft.banner.diagonal_right.yellow": "Kōstik tlaalaxolli",
  "block.minecraft.banner.diagonal_up_left.black": "Īxkwaptok yāyāwik tlaalaxolli",
  "block.minecraft.banner.diagonal_up_left.blue": "Īxkwaptok āsoltik tlaalaxolli",
  "block.minecraft.banner.diagonal_up_left.brown": "Īxkwaptok kafēntik tlaalaxolli",
  "block.minecraft.banner.diagonal_up_left.cyan": "Īxkwaptok xiwtik tlaalaxolli",
  "block.minecraft.banner.diagonal_up_left.gray": "Īxkwaptok tenextik tlaalaxolli",
  "block.minecraft.banner.diagonal_up_left.green": "Īxkwaptok xoxoktik tlaalaxolli",
  "block.minecraft.banner.diagonal_up_left.light_blue": "Īxkwaptok tsiktik tlaalaxolli",
  "block.minecraft.banner.diagonal_up_left.light_gray": "Īxkwaptok ātenextik tlaalaxolli",
  "block.minecraft.banner.diagonal_up_left.lime": "Īxkwaptok xoxōwik tlaalaxolli",
  "block.minecraft.banner.diagonal_up_left.magenta": "Īxkwaptok ayohpāltik tlaalaxolli",
  "block.minecraft.banner.diagonal_up_left.orange": "Īxkwaptok chīlkōstik tlaalaxolli",
  "block.minecraft.banner.diagonal_up_left.pink": "Īxkwaptok iselik tlaalaxolli",
  "block.minecraft.banner.diagonal_up_left.purple": "Īxkwaptok kamohtik tlaalaxolli",
  "block.minecraft.banner.diagonal_up_left.red": "Īxkwaptok chīltik tlaalaxolli",
  "block.minecraft.banner.diagonal_up_left.white": "Īxkwaptok chipāwak tlaalaxolli",
  "block.minecraft.banner.diagonal_up_left.yellow": "Īxkwaptok kōstik tlaalaxolli",
  "block.minecraft.banner.diagonal_up_right.black": "Īxkwaptok yāyāwik tlatehtektli",
  "block.minecraft.banner.diagonal_up_right.blue": "Īxkwaptok āsoltik tlatehtektli",
  "block.minecraft.banner.diagonal_up_right.brown": "Īxkwaptok kafēntik tlatehtektli",
  "block.minecraft.banner.diagonal_up_right.cyan": "Īxkwaptok xiwtik tlatehtektli",
  "block.minecraft.banner.diagonal_up_right.gray": "Īxkwaptok tenextik tlatehtektli",
  "block.minecraft.banner.diagonal_up_right.green": "Īxkwaptok xoxoktik tlatehtektli",
  "block.minecraft.banner.diagonal_up_right.light_blue": "Īxkwaptok tsiktik tlatehtektli",
  "block.minecraft.banner.diagonal_up_right.light_gray": "Īxkwaptok ātenextik tlatehtektli",
  "block.minecraft.banner.diagonal_up_right.lime": "Īxkwaptok xoxōwik tlatehtektli",
  "block.minecraft.banner.diagonal_up_right.magenta": "Īxkwaptok ayohpāltik tlatehtektli",
  "block.minecraft.banner.diagonal_up_right.orange": "Īxkwaptok chīlkōstik tlatehtektli",
  "block.minecraft.banner.diagonal_up_right.pink": "Īxkwaptok iselik tlatehtektli",
  "block.minecraft.banner.diagonal_up_right.purple": "Īxkwaptok kamohtik tlatehtektli",
  "block.minecraft.banner.diagonal_up_right.red": "Īxkwaptok chīltik tlatehtektli",
  "block.minecraft.banner.diagonal_up_right.white": "Īxkwaptok chipāwak tlatehtektli",
  "block.minecraft.banner.diagonal_up_right.yellow": "Īxkwaptok kōstik tlatehtektli",
  "block.minecraft.banner.flow.black": "Tlīltik āmēyalli",
  "block.minecraft.banner.flow.blue": "Āsoltik āmēyalli",
  "block.minecraft.banner.flow.brown": "Kafēntik āmēyalli",
  "block.minecraft.banner.flow.cyan": "Xiwtik āmēyalli",
  "block.minecraft.banner.flow.gray": "Tenextik āmēyalli",
  "block.minecraft.banner.flow.green": "Xoxoktik āmēyalli",
  "block.minecraft.banner.flow.light_blue": "Tsiktik āmēyalli",
  "block.minecraft.banner.flow.light_gray": "Ātenextik āmēyalli",
  "block.minecraft.banner.flow.lime": "Xoxōwik āmēyalli",
  "block.minecraft.banner.flow.magenta": "Ayohpāltik āmēyalli",
  "block.minecraft.banner.flow.orange": "Chīlkōstik āmēyalli",
  "block.minecraft.banner.flow.pink": "Iselik āmēyalli",
  "block.minecraft.banner.flow.purple": "Kamohtik āmēyalli",
  "block.minecraft.banner.flow.red": "Chīltik āmēyalli",
  "block.minecraft.banner.flow.white": "Chipāwak āmēyalli",
  "block.minecraft.banner.flow.yellow": "Kōstik āmēyalli",
  "block.minecraft.banner.flower.black": "Yāyāwik xōchitl",
  "block.minecraft.banner.flower.blue": "Āsoltik xōchitl",
  "block.minecraft.banner.flower.brown": "Kafēntik xōchitl",
  "block.minecraft.banner.flower.cyan": "Xiwtik xōchitl",
  "block.minecraft.banner.flower.gray": "Tenextik xōchitl",
  "block.minecraft.banner.flower.green": "Xoxoktik xōchitl",
  "block.minecraft.banner.flower.light_blue": "Tsiktik xōchitl",
  "block.minecraft.banner.flower.light_gray": "Ātenextik xōchitl",
  "block.minecraft.banner.flower.lime": "Xoxōwik xōchitl",
  "block.minecraft.banner.flower.magenta": "Ayohpāltik xōchitl",
  "block.minecraft.banner.flower.orange": "Chīlkōstik xōchitl",
  "block.minecraft.banner.flower.pink": "Iselik xōchitl",
  "block.minecraft.banner.flower.purple": "Kamohtik xōchitl",
  "block.minecraft.banner.flower.red": "Chīltik xōchitl",
  "block.minecraft.banner.flower.white": "Chipāwak xōchitl",
  "block.minecraft.banner.flower.yellow": "Kōstik xōchitl",
  "block.minecraft.banner.globe.black": "Yāyāwik elwikatlayōlli",
  "block.minecraft.banner.globe.blue": "Āsoltik elwikatlayōlli",
  "block.minecraft.banner.globe.brown": "Kafēntik elwikatlayōlli",
  "block.minecraft.banner.globe.cyan": "Xiwtik elwikatlayōlli",
  "block.minecraft.banner.globe.gray": "Tenextik elwikatl",
  "block.minecraft.banner.globe.green": "Xoxoktik elwikatlayōlli",
  "block.minecraft.banner.globe.light_blue": "Tsiktik elwikatlayōlli",
  "block.minecraft.banner.globe.light_gray": "Ātenextik elwikatlayōlli",
  "block.minecraft.banner.globe.lime": "Xoxōwik elwikatlayōlli",
  "block.minecraft.banner.globe.magenta": "Ayohpāltik elwikatlayōlli",
  "block.minecraft.banner.globe.orange": "Chīlkōstik elwikatlayōlli",
  "block.minecraft.banner.globe.pink": "Iselik elwikatlayōlli",
  "block.minecraft.banner.globe.purple": "Kamohtik elwikatlayōlli",
  "block.minecraft.banner.globe.red": "Chīltik elwikatlayōlli",
  "block.minecraft.banner.globe.white": "Chipāwak elwikatlayōlli",
  "block.minecraft.banner.globe.yellow": "Kōstik elwikatlayōlli",
  "block.minecraft.banner.gradient.black": "Yāyāwik gratienteh",
  "block.minecraft.banner.gradient.blue": "Āsoltik gratienteh",
  "block.minecraft.banner.gradient.brown": "Kafēntik gratienteh",
  "block.minecraft.banner.gradient.cyan": "Xiwtik gratienteh",
  "block.minecraft.banner.gradient.gray": "Tenextik gratienteh",
  "block.minecraft.banner.gradient.green": "Xoxoktik gratienteh",
  "block.minecraft.banner.gradient.light_blue": "Tsiktik gratienteh",
  "block.minecraft.banner.gradient.light_gray": "Ātenextik gratienteh",
  "block.minecraft.banner.gradient.lime": "Xoxōwik gratienteh",
  "block.minecraft.banner.gradient.magenta": "Ayohpāltik gratienteh",
  "block.minecraft.banner.gradient.orange": "Chīlkōstik gratienteh",
  "block.minecraft.banner.gradient.pink": "Iselik gratienteh",
  "block.minecraft.banner.gradient.purple": "Kamohtik gratienteh",
  "block.minecraft.banner.gradient.red": "Chīltik gratienteh",
  "block.minecraft.banner.gradient.white": "Chipāwak gratienteh",
  "block.minecraft.banner.gradient.yellow": "Kōstik gratienteh",
  "block.minecraft.banner.gradient_up.black": "Yāyāwik gratienteh īpan tlatsīntlan",
  "block.minecraft.banner.gradient_up.blue": "Āsoltik gratienteh īpan tlatsīntlan",
  "block.minecraft.banner.gradient_up.brown": "Kafēntik gratienteh īpan tlatsīntlan",
  "block.minecraft.banner.gradient_up.cyan": "Xiwtik gratienteh īpan tlatsīntlan",
  "block.minecraft.banner.gradient_up.gray": "Tenextik gratienteh īpan tlatsīntlan",
  "block.minecraft.banner.gradient_up.green": "Xoxoktik gratienteh īpan tlatsīntlan",
  "block.minecraft.banner.gradient_up.light_blue": "Tsiktik gratienteh īpan tlatsīntlan",
  "block.minecraft.banner.gradient_up.light_gray": "Ātenextik gratienteh īpan tlatsīntlan",
  "block.minecraft.banner.gradient_up.lime": "Xoxōwik gratienteh īpan tlatsīntlan",
  "block.minecraft.banner.gradient_up.magenta": "Ayohpāltik gratienteh īpan tlatsīntlan",
  "block.minecraft.banner.gradient_up.orange": "Chīlkōstik gratienteh īpan tlatsīntlan",
  "block.minecraft.banner.gradient_up.pink": "Iselik gratienteh īpan tlatsīntlan",
  "block.minecraft.banner.gradient_up.purple": "Kamohtik gratienteh īpan tlatsīntlan",
  "block.minecraft.banner.gradient_up.red": "Chīltik gratienteh īpan tlatsīntlan",
  "block.minecraft.banner.gradient_up.white": "Chipāwak gratienteh īpan tlatsīntlan",
  "block.minecraft.banner.gradient_up.yellow": "Kōstik gratienteh īpan tlatsīntlan",
  "block.minecraft.banner.guster.black": "Tlīltik ehēkalistli",
  "block.minecraft.banner.guster.blue": "Āsoltik ehēkalistli",
  "block.minecraft.banner.guster.brown": "Kafēntik ehēkalistli",
  "block.minecraft.banner.guster.cyan": "Xiwtik ehēkalistli",
  "block.minecraft.banner.guster.gray": "Tenextik ehēkalistli",
  "block.minecraft.banner.guster.green": "Xoxoktik ehēkalistli",
  "block.minecraft.banner.guster.light_blue": "Tsiktik ehēkalistli",
  "block.minecraft.banner.guster.light_gray": "Ātenextik ehēkalistli",
  "block.minecraft.banner.guster.lime": "Xoxōwik ehēkalistli",
  "block.minecraft.banner.guster.magenta": "Ayohpāltik ehēkalistli",
  "block.minecraft.banner.guster.orange": "Chīlkōstik ehēkalistli",
  "block.minecraft.banner.guster.pink": "Iselik ehēkalistli",
  "block.minecraft.banner.guster.purple": "Kamohtik ehēkalistli",
  "block.minecraft.banner.guster.red": "Chīltik ehēkalistli",
  "block.minecraft.banner.guster.white": "Chipāwak ehēkalistli",
  "block.minecraft.banner.guster.yellow": "Kōstik ehēkalistli",
  "block.minecraft.banner.half_horizontal.black": "Yāyāwik tlatektli",
  "block.minecraft.banner.half_horizontal.blue": "Āsoltik tlatektli",
  "block.minecraft.banner.half_horizontal.brown": "Kafēntik tlatektli",
  "block.minecraft.banner.half_horizontal.cyan": "Xiwtik tlatektli",
  "block.minecraft.banner.half_horizontal.gray": "Tenextik tlatektli",
  "block.minecraft.banner.half_horizontal.green": "Xoxoktik tlatektli",
  "block.minecraft.banner.half_horizontal.light_blue": "Tsiktik tlatektli",
  "block.minecraft.banner.half_horizontal.light_gray": "Ātenextik tlatektli",
  "block.minecraft.banner.half_horizontal.lime": "Xoxōwik tlatektli",
  "block.minecraft.banner.half_horizontal.magenta": "Ayohpāltik tlatektli",
  "block.minecraft.banner.half_horizontal.orange": "Chīlkōstik tlatektli",
  "block.minecraft.banner.half_horizontal.pink": "Iselik tlatektli",
  "block.minecraft.banner.half_horizontal.purple": "Kamohtik tlatektli",
  "block.minecraft.banner.half_horizontal.red": "Chīltik tlatektli",
  "block.minecraft.banner.half_horizontal.white": "Chipāwak tlatektli",
  "block.minecraft.banner.half_horizontal.yellow": "Kōstik tlatektli",
  "block.minecraft.banner.half_horizontal_bottom.black": "Īxkwaptok yāyāwik tlatektli",
  "block.minecraft.banner.half_horizontal_bottom.blue": "Īxkwaptok āsoltik tlatektli",
  "block.minecraft.banner.half_horizontal_bottom.brown": "Īxkwaptok kafēntik tlatektli",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "Īxkwaptok xiwtik tlatektli",
  "block.minecraft.banner.half_horizontal_bottom.gray": "Īxkwaptok tenextik tlatektli",
  "block.minecraft.banner.half_horizontal_bottom.green": "Īxkwaptok xoxoktik tlatektli",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "Īxkwaptok tsiktik tlatektli",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "Īxkwaptok ātenextik tlatektli",
  "block.minecraft.banner.half_horizontal_bottom.lime": "Īxkwaptok xoxōwik tlatektli",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "Īxkwaptok ayohpāltik tlatektli",
  "block.minecraft.banner.half_horizontal_bottom.orange": "Īxkwaptok chīlkōstik tlatektli",
  "block.minecraft.banner.half_horizontal_bottom.pink": "Īxkwaptok iselik tlatektli",
  "block.minecraft.banner.half_horizontal_bottom.purple": "Īxkwaptok kamohtik tlatektli",
  "block.minecraft.banner.half_horizontal_bottom.red": "Īxkwaptok chīltik tlatektli",
  "block.minecraft.banner.half_horizontal_bottom.white": "Īxkwaptok chipāwak tlatektli",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "Īxkwaptok kōstik tlatektli",
  "block.minecraft.banner.half_vertical.black": "Yāyāwik tlatlahkotlapanalli",
  "block.minecraft.banner.half_vertical.blue": "Āsoltik tlatlahkotlapanalli",
  "block.minecraft.banner.half_vertical.brown": "Kafēntik tlatlahkotlapanalli",
  "block.minecraft.banner.half_vertical.cyan": "Xiwtik tlatlahkotlapanalli",
  "block.minecraft.banner.half_vertical.gray": "Tenextik tlatlahkotlapanalli",
  "block.minecraft.banner.half_vertical.green": "Xoxoktik tlatlahkotlapanalli",
  "block.minecraft.banner.half_vertical.light_blue": "Tsiktik tlatlahkotlapanalli",
  "block.minecraft.banner.half_vertical.light_gray": "Ātenextik tlatlahkotlapanalli",
  "block.minecraft.banner.half_vertical.lime": "Xoxōwik tlatlahkotlapanalli",
  "block.minecraft.banner.half_vertical.magenta": "Ayohpāltik tlatlahkotlapanalli",
  "block.minecraft.banner.half_vertical.orange": "Chīlkōstik tlatlahkotlapanalli",
  "block.minecraft.banner.half_vertical.pink": "Iselik tlatlahkotlapanalli",
  "block.minecraft.banner.half_vertical.purple": "Kamohtik tlatlahkotlapanalli",
  "block.minecraft.banner.half_vertical.red": "Chīltik tlatlahkotlapanalli",
  "block.minecraft.banner.half_vertical.white": "Chipāwak tlatlahkotlapanalli",
  "block.minecraft.banner.half_vertical.yellow": "Kōstik tlatlahkotlapanalli",
  "block.minecraft.banner.half_vertical_right.black": "Īxkwaptok yāyāwik tlatlahkotlapanalli",
  "block.minecraft.banner.half_vertical_right.blue": "Īxkwaptok āsoltik tlatlahkotlapanalli",
  "block.minecraft.banner.half_vertical_right.brown": "Īxkwaptok kafēntik tlatlahkotlapanalli",
  "block.minecraft.banner.half_vertical_right.cyan": "Īxkwaptok xiwtik tlatlahkotlapanalli",
  "block.minecraft.banner.half_vertical_right.gray": "Īxkwaptok tenextik tlatlahkotlapanalli",
  "block.minecraft.banner.half_vertical_right.green": "Īxkwaptok xoxoktik tlatlahkotlapanalli",
  "block.minecraft.banner.half_vertical_right.light_blue": "Īxkwaptok tsiktik tlatlahkotlapanalli",
  "block.minecraft.banner.half_vertical_right.light_gray": "Īxkwaptok ātenextik tlatlahkotlapanalli",
  "block.minecraft.banner.half_vertical_right.lime": "Īxkwaptok xoxōwik tlatlahkotlapanalli",
  "block.minecraft.banner.half_vertical_right.magenta": "Īxkwaptok ayohpāltik tlatlahkotlapanalli",
  "block.minecraft.banner.half_vertical_right.orange": "Īxkwaptok chīlkōstik tlatlahkotlapanalli",
  "block.minecraft.banner.half_vertical_right.pink": "Īxkwaptok iselik tlatlahkotlapanalli",
  "block.minecraft.banner.half_vertical_right.purple": "Īxkwaptok kamohtik tlatlahkotlapanalli",
  "block.minecraft.banner.half_vertical_right.red": "Īxkwaptok chīltik tlatlahkotlapanalli",
  "block.minecraft.banner.half_vertical_right.white": "Īxkwaptok chipāwak tlatlahkotlapanalli",
  "block.minecraft.banner.half_vertical_right.yellow": "Īxkwaptok kōstik tlatlahkotlapanalli",
  "block.minecraft.banner.mojang.black": "Yāyāwik tlamantli",
  "block.minecraft.banner.mojang.blue": "Āsoltik tlamantli",
  "block.minecraft.banner.mojang.brown": "Kafēntik tlamantli",
  "block.minecraft.banner.mojang.cyan": "Xiwtik tlamantli",
  "block.minecraft.banner.mojang.gray": "Tenextik tlamantli",
  "block.minecraft.banner.mojang.green": "Xoxoktik tlamantli",
  "block.minecraft.banner.mojang.light_blue": "Tsiktik tlamantli",
  "block.minecraft.banner.mojang.light_gray": "Ātenextik tlamantli",
  "block.minecraft.banner.mojang.lime": "Xoxōwik tlamantli",
  "block.minecraft.banner.mojang.magenta": "Ayohpāltik tlamantli",
  "block.minecraft.banner.mojang.orange": "Chīlkōstik tlamantli",
  "block.minecraft.banner.mojang.pink": "Iselik tlamantli",
  "block.minecraft.banner.mojang.purple": "Kamohtik tlamantli",
  "block.minecraft.banner.mojang.red": "Chīltik tlamantli",
  "block.minecraft.banner.mojang.white": "Chipāwak tlamantli",
  "block.minecraft.banner.mojang.yellow": "Kōstik tlamantli",
  "block.minecraft.banner.piglin.black": "Yāyāwik piglinkamaktli",
  "block.minecraft.banner.piglin.blue": "Āsoltik piglinkamaktli",
  "block.minecraft.banner.piglin.brown": "Kafēntik piglinkamaktli",
  "block.minecraft.banner.piglin.cyan": "Xiwtik piglinkamaktli",
  "block.minecraft.banner.piglin.gray": "Tenextik piglinkamaktli",
  "block.minecraft.banner.piglin.green": "Xoxoktik piglinkamaktli",
  "block.minecraft.banner.piglin.light_blue": "Tsiktik piglinkamaktli",
  "block.minecraft.banner.piglin.light_gray": "Ātenextik piglinkamaktli",
  "block.minecraft.banner.piglin.lime": "Xoxōwik piglinkamaktli",
  "block.minecraft.banner.piglin.magenta": "Ayohpāltik piglinkamaktli",
  "block.minecraft.banner.piglin.orange": "Chīlkōstik piglinkamaktli",
  "block.minecraft.banner.piglin.pink": "Iselik piglinkamaktli",
  "block.minecraft.banner.piglin.purple": "Kamohtik piglinkamaktli",
  "block.minecraft.banner.piglin.red": "Chīltik piglinkamaktli",
  "block.minecraft.banner.piglin.white": "Chipāwak piglinkamaktli",
  "block.minecraft.banner.piglin.yellow": "Kōstik piglinkamaktli",
  "block.minecraft.banner.rhombus.black": "Yāyāwik losanheh",
  "block.minecraft.banner.rhombus.blue": "Āsoltik losanheh",
  "block.minecraft.banner.rhombus.brown": "Kafēntik losanheh",
  "block.minecraft.banner.rhombus.cyan": "Xiwtik losanheh",
  "block.minecraft.banner.rhombus.gray": "Tenextik losanheh",
  "block.minecraft.banner.rhombus.green": "Xoxoktik losanheh",
  "block.minecraft.banner.rhombus.light_blue": "Tsiktik losanheh",
  "block.minecraft.banner.rhombus.light_gray": "Ātenextik losanheh",
  "block.minecraft.banner.rhombus.lime": "Xoxōwik losanheh",
  "block.minecraft.banner.rhombus.magenta": "Ayohpāltik losanheh",
  "block.minecraft.banner.rhombus.orange": "Chīlkōstik losanheh",
  "block.minecraft.banner.rhombus.pink": "Iselik losanheh",
  "block.minecraft.banner.rhombus.purple": "Kamohtik losanheh",
  "block.minecraft.banner.rhombus.red": "Chīltik losanheh",
  "block.minecraft.banner.rhombus.white": "Chipāwak losanheh",
  "block.minecraft.banner.rhombus.yellow": "Kōstik losanheh",
  "block.minecraft.banner.skull.black": "Yāyāwik kwāomiyōtl",
  "block.minecraft.banner.skull.blue": "Āsoltik kwāomiyōtl",
  "block.minecraft.banner.skull.brown": "Kafēntik kwāomiyōtl",
  "block.minecraft.banner.skull.cyan": "Xiwtik kwāomiyōtl",
  "block.minecraft.banner.skull.gray": "Tenextik kwāomiyōtl",
  "block.minecraft.banner.skull.green": "Xoxoktik kwāomiyōtl",
  "block.minecraft.banner.skull.light_blue": "Tsiktik kwāomiyōtl",
  "block.minecraft.banner.skull.light_gray": "Ātenextik kwāomiyōtl",
  "block.minecraft.banner.skull.lime": "Xoxōwik kwāomiyōtl",
  "block.minecraft.banner.skull.magenta": "Ayohpāltik kwāomiyōtl",
  "block.minecraft.banner.skull.orange": "Chīlkōstik kwāomiyōtl",
  "block.minecraft.banner.skull.pink": "Iselik kwāomiyōtl",
  "block.minecraft.banner.skull.purple": "Kamohtik kwāomiyōtl",
  "block.minecraft.banner.skull.red": "Chīltik kwāomiyōtl",
  "block.minecraft.banner.skull.white": "Chipāwak kwāomiyōtl",
  "block.minecraft.banner.skull.yellow": "Kōstik kwāomiyōtl",
  "block.minecraft.banner.small_stripes.black": "Yāyāwik kwatōpīllōtl",
  "block.minecraft.banner.small_stripes.blue": "Āsoltik kwatōpīllōtl",
  "block.minecraft.banner.small_stripes.brown": "Kafēntik kwatōpīllōtl",
  "block.minecraft.banner.small_stripes.cyan": "Xiwtik kwatōpīllōtl",
  "block.minecraft.banner.small_stripes.gray": "Tenextik kwatōpīllōtl",
  "block.minecraft.banner.small_stripes.green": "Xoxoktik kwatōpīllōtl",
  "block.minecraft.banner.small_stripes.light_blue": "Tsiktik kwatōpīllōtl",
  "block.minecraft.banner.small_stripes.light_gray": "Ātenextik kwatōpīllōtl",
  "block.minecraft.banner.small_stripes.lime": "Xoxōwik kwatōpīllōtl",
  "block.minecraft.banner.small_stripes.magenta": "Ayohpāltik kwatōpīllōtl",
  "block.minecraft.banner.small_stripes.orange": "Chīlkōstik kwatōpīllōtl",
  "block.minecraft.banner.small_stripes.pink": "Iselik kwatōpīllōtl",
  "block.minecraft.banner.small_stripes.purple": "Kamohtik kwatōpīllōtl",
  "block.minecraft.banner.small_stripes.red": "Chīltik kwatōpīllōtl",
  "block.minecraft.banner.small_stripes.white": "Chipāwak kwatōpīllōtl",
  "block.minecraft.banner.small_stripes.yellow": "Kōstik kwatōpīllōtl",
  "block.minecraft.banner.square_bottom_left.black": "Yāyāwik yēktlan kanton īpan tlatsīntlan",
  "block.minecraft.banner.square_bottom_left.blue": "Āsoltik yēktlan kanton īpan tlatsīntlan",
  "block.minecraft.banner.square_bottom_left.brown": "Kafēntik yēktlan kanton īpan tlatsīntlan",
  "block.minecraft.banner.square_bottom_left.cyan": "Xiwtik yēktlan kanton īpan tlatsīntlan",
  "block.minecraft.banner.square_bottom_left.gray": "Tenextik yēktlan kanton īpan tlatsīntlan",
  "block.minecraft.banner.square_bottom_left.green": "Xoxoktik yēktlan kanton īpan tlatsīntlan",
  "block.minecraft.banner.square_bottom_left.light_blue": "Tsiktik yēktlan kanton īpan tlatsīntlan",
  "block.minecraft.banner.square_bottom_left.light_gray": "Ātenextik yēktlan kanton īpan tlatsīntlan",
  "block.minecraft.banner.square_bottom_left.lime": "Xoxōwik yēktlan kanton īpan tlatsīntlan",
  "block.minecraft.banner.square_bottom_left.magenta": "Ayohpāltik yēktlan kanton īpan tlatsīntlan",
  "block.minecraft.banner.square_bottom_left.orange": "Chīlkōstik yēktlan kanton īpan tlatsīntlan",
  "block.minecraft.banner.square_bottom_left.pink": "Iselik yēktlan kanton īpan tlatsīntlan",
  "block.minecraft.banner.square_bottom_left.purple": "Kamohtik yēktlan kanton īpan tlatsīntlan",
  "block.minecraft.banner.square_bottom_left.red": "Chīltik yēktlan kanton īpan tlatsīntlan",
  "block.minecraft.banner.square_bottom_left.white": "Chipāwak yēktlan kanton īpan tlatsīntlan",
  "block.minecraft.banner.square_bottom_left.yellow": "Kōstik yēktlan kanton īpan tlatsīntlan",
  "block.minecraft.banner.square_bottom_right.black": "Yāyāwik ōpōchtlan kanton īpan tlatsīntlan",
  "block.minecraft.banner.square_bottom_right.blue": "Āsoltik ōpōchtlan kanton īpan tlatsīntlan",
  "block.minecraft.banner.square_bottom_right.brown": "Kafēntik ōpōchtlan kanton īpan tlatsīntlan",
  "block.minecraft.banner.square_bottom_right.cyan": "Xiwtik ōpōchtlan kanton īpan tlatsīntlan",
  "block.minecraft.banner.square_bottom_right.gray": "Tenextik ōpōchtlan kanton īpan tlatsīntlan",
  "block.minecraft.banner.square_bottom_right.green": "Xoxoktik ōpōchtlan kanton īpan tlatsīntlan",
  "block.minecraft.banner.square_bottom_right.light_blue": "Tsiktik ōpōchtlan kanton īpan tlatsīntlan",
  "block.minecraft.banner.square_bottom_right.light_gray": "Ātenextik ōpōchtlan kanton īpan tlatsīntlan",
  "block.minecraft.banner.square_bottom_right.lime": "Xoxōwik ōpōchtlan kanton īpan tlatsīntlan",
  "block.minecraft.banner.square_bottom_right.magenta": "Ayohpāltik ōpōchtlan kanton īpan tlatsīntlan",
  "block.minecraft.banner.square_bottom_right.orange": "Chīlkōstik ōpōchtlan kanton īpan tlatsīntlan",
  "block.minecraft.banner.square_bottom_right.pink": "Iselik ōpōchtlan kanton īpan tlatsīntlan",
  "block.minecraft.banner.square_bottom_right.purple": "Kamohtik ōpōchtlan kanton īpan tlatsīntlan",
  "block.minecraft.banner.square_bottom_right.red": "Chīltik ōpōchtlan kanton īpan tlatsīntlan",
  "block.minecraft.banner.square_bottom_right.white": "Chipāwak ōpōchtlan kanton īpan tlatsīntlan",
  "block.minecraft.banner.square_bottom_right.yellow": "Kōstik ōpōchtlan kanton īpan tlatsīntlan",
  "block.minecraft.banner.square_top_left.black": "Yāyāwik yēktlan kanton īkwāpān",
  "block.minecraft.banner.square_top_left.blue": "Āsoltik yēktlan kanton īkwāpān",
  "block.minecraft.banner.square_top_left.brown": "Kafēntik yēktlan kanton īkwāpān",
  "block.minecraft.banner.square_top_left.cyan": "Xiwtik yēktlan kanton īkwāpān",
  "block.minecraft.banner.square_top_left.gray": "Tenextik yēktlān kanton īkwāpān",
  "block.minecraft.banner.square_top_left.green": "Xoxoktik yēktlan kanton īkwāpān",
  "block.minecraft.banner.square_top_left.light_blue": "Tsiktik yēktlan kanton īkwāpān",
  "block.minecraft.banner.square_top_left.light_gray": "Ātenextik yēktlan kanton īkwāpān",
  "block.minecraft.banner.square_top_left.lime": "Xoxōwik yēktlan kanton īkwāpān",
  "block.minecraft.banner.square_top_left.magenta": "Ayohpaltik yēktlan kanton īkwāpān",
  "block.minecraft.banner.square_top_left.orange": "Chīlkōstik yēktlan kanton īkwāpān",
  "block.minecraft.banner.square_top_left.pink": "Iselik yēktlan kanton īkwāpān",
  "block.minecraft.banner.square_top_left.purple": "Kamohtik yēktlan kanton īkwāpān",
  "block.minecraft.banner.square_top_left.red": "Chīltik yēktlan kanton īkwāpān",
  "block.minecraft.banner.square_top_left.white": "Chipāwak yēktlan kanton īkwāpān",
  "block.minecraft.banner.square_top_left.yellow": "Kōstik yēktlan kanton īkwāpān",
  "block.minecraft.banner.square_top_right.black": "Yāyāwik ōpōchtlan kanton īkwāpān",
  "block.minecraft.banner.square_top_right.blue": "Āsoltik ōpōchtlan kanton īkwāpān",
  "block.minecraft.banner.square_top_right.brown": "Kafēntik ōpōchtlān kanton īkwāpān",
  "block.minecraft.banner.square_top_right.cyan": "Xiwtik ōpōchtlan kanton īkwāpān",
  "block.minecraft.banner.square_top_right.gray": "Tenextik ōpōchtlan kanton īkwāpān",
  "block.minecraft.banner.square_top_right.green": "Xoxoktik ōpōchtlan kanton īkwāpān",
  "block.minecraft.banner.square_top_right.light_blue": "Tsiktik ōpōchtlan kanton īkwāpān",
  "block.minecraft.banner.square_top_right.light_gray": "Ātenextik ōpōchtlan kanton īkwāpān",
  "block.minecraft.banner.square_top_right.lime": "Xoxōwik ōpōchtlan kanton īkwāpān",
  "block.minecraft.banner.square_top_right.magenta": "Ayohpaltik ōpōchtlan kanton īkwāpān",
  "block.minecraft.banner.square_top_right.orange": "Chīlkōstik ōpōchtlan kanton īkwāpān",
  "block.minecraft.banner.square_top_right.pink": "Iselik ōpōchtlan kanton īkwāpān",
  "block.minecraft.banner.square_top_right.purple": "Kamohtik ōpōchtlan kanton īkwāpān",
  "block.minecraft.banner.square_top_right.red": "Chīltik ōpōchtlan kanton īkwāpān",
  "block.minecraft.banner.square_top_right.white": "Chipāwak ōpōchtlan kanton īkwāpān",
  "block.minecraft.banner.square_top_right.yellow": "Kōstik ōpōchtlan kanton īkwāpān",
  "block.minecraft.banner.straight_cross.black": "Yāyāwik kros",
  "block.minecraft.banner.straight_cross.blue": "Āsoltik kros",
  "block.minecraft.banner.straight_cross.brown": "Kafēntik kros",
  "block.minecraft.banner.straight_cross.cyan": "Xiwtik kros",
  "block.minecraft.banner.straight_cross.gray": "Tenextik kros",
  "block.minecraft.banner.straight_cross.green": "Xoxoktik kros",
  "block.minecraft.banner.straight_cross.light_blue": "Tsiktik kros",
  "block.minecraft.banner.straight_cross.light_gray": "Ātenextik kros",
  "block.minecraft.banner.straight_cross.lime": "Xoxōwik kros",
  "block.minecraft.banner.straight_cross.magenta": "Ayohpāltik kros",
  "block.minecraft.banner.straight_cross.orange": "Chīlkōstik kros",
  "block.minecraft.banner.straight_cross.pink": "Iselik kros",
  "block.minecraft.banner.straight_cross.purple": "Kamohtik kros",
  "block.minecraft.banner.straight_cross.red": "Chīltik kros",
  "block.minecraft.banner.straight_cross.white": "Chipāwak kros",
  "block.minecraft.banner.straight_cross.yellow": "Kōstik kros",
  "block.minecraft.banner.stripe_bottom.black": "Yāyāwik tlatsīntlan",
  "block.minecraft.banner.stripe_bottom.blue": "Āsoltik tlatsīntlan",
  "block.minecraft.banner.stripe_bottom.brown": "Kafēntik tlatsīntlan",
  "block.minecraft.banner.stripe_bottom.cyan": "Xiwtik tlatsīntlan",
  "block.minecraft.banner.stripe_bottom.gray": "Tenextik tlatsīntlan",
  "block.minecraft.banner.stripe_bottom.green": "Xoxoktik tlatsīntlan",
  "block.minecraft.banner.stripe_bottom.light_blue": "Tsiktik tlatsīntlan",
  "block.minecraft.banner.stripe_bottom.light_gray": "Ātenextik tlatsīntlan",
  "block.minecraft.banner.stripe_bottom.lime": "Xoxōwik tlatsīntlan",
  "block.minecraft.banner.stripe_bottom.magenta": "Ayohpāltik tlatsīntlan",
  "block.minecraft.banner.stripe_bottom.orange": "Chīlkōstik tlatsīntlan",
  "block.minecraft.banner.stripe_bottom.pink": "Iselik tlatsīntlan",
  "block.minecraft.banner.stripe_bottom.purple": "Kamohtik tlatsīntlan",
  "block.minecraft.banner.stripe_bottom.red": "Chīltik tlatsīntlan",
  "block.minecraft.banner.stripe_bottom.white": "Chipāwak tlatsīntlan",
  "block.minecraft.banner.stripe_bottom.yellow": "Kōstik tlatsīntlan",
  "block.minecraft.banner.stripe_center.black": "Yāyāwik kwawitl",
  "block.minecraft.banner.stripe_center.blue": "Āsoltik kwawitl",
  "block.minecraft.banner.stripe_center.brown": "Kafēntik kwawitl",
  "block.minecraft.banner.stripe_center.cyan": "Xiwtik kwawitl",
  "block.minecraft.banner.stripe_center.gray": "Tenextik kwawitl",
  "block.minecraft.banner.stripe_center.green": "Xoxoktik kwawitl",
  "block.minecraft.banner.stripe_center.light_blue": "Tsiktik kwawitl",
  "block.minecraft.banner.stripe_center.light_gray": "Ātenextik kwawitl",
  "block.minecraft.banner.stripe_center.lime": "Xoxōwik kwawitl",
  "block.minecraft.banner.stripe_center.magenta": "Ayohpāltik kwawitl",
  "block.minecraft.banner.stripe_center.orange": "Chīlkōstik kwawitl",
  "block.minecraft.banner.stripe_center.pink": "Iselik kwawitl",
  "block.minecraft.banner.stripe_center.purple": "Kamohtik kwawitl",
  "block.minecraft.banner.stripe_center.red": "Chīltik kwawitl",
  "block.minecraft.banner.stripe_center.white": "Chipāwak kwawitl",
  "block.minecraft.banner.stripe_center.yellow": "Kōstik kwawitl",
  "block.minecraft.banner.stripe_downleft.black": "Yāyāwik witsōktli īka ōpōchtlan",
  "block.minecraft.banner.stripe_downleft.blue": "Āsoltik witsōktli īka ōpōchtlan",
  "block.minecraft.banner.stripe_downleft.brown": "Kafēntik witsōktli īka ōpōchtlan",
  "block.minecraft.banner.stripe_downleft.cyan": "Xiwtik witsōktli īka ōpōchtlan",
  "block.minecraft.banner.stripe_downleft.gray": "Tenextik witsōktli īka ōpōchtlan",
  "block.minecraft.banner.stripe_downleft.green": "Xoxoktik witsōktli īka ōpōchtlan",
  "block.minecraft.banner.stripe_downleft.light_blue": "Tsiktik witsōktli īka ōpōchtlan",
  "block.minecraft.banner.stripe_downleft.light_gray": "Ātenextik witsōktli īka ōpōchtlan",
  "block.minecraft.banner.stripe_downleft.lime": "Xoxōwik witsōktli īka ōpōchtlan",
  "block.minecraft.banner.stripe_downleft.magenta": "Ayohpāltik witsōktli īka ōpōchtlan",
  "block.minecraft.banner.stripe_downleft.orange": "Chīlkōstik witsōktli īka ōpōchtlan",
  "block.minecraft.banner.stripe_downleft.pink": "Iselik witsōktli īka ōpōchtlan",
  "block.minecraft.banner.stripe_downleft.purple": "Kamohtik witsōktli īka ōpōchtlan",
  "block.minecraft.banner.stripe_downleft.red": "Chīltik witsōktli īka ōpōchtlan",
  "block.minecraft.banner.stripe_downleft.white": "Chipāwak witsōktli īka ōpōchtlan",
  "block.minecraft.banner.stripe_downleft.yellow": "Kōstik witsōktli īka ōpōchtlan",
  "block.minecraft.banner.stripe_downright.black": "Yāyāwik wantah",
  "block.minecraft.banner.stripe_downright.blue": "Āsoltik wantah",
  "block.minecraft.banner.stripe_downright.brown": "Kafēntik wantah",
  "block.minecraft.banner.stripe_downright.cyan": "Xiwtik wantah",
  "block.minecraft.banner.stripe_downright.gray": "Tenextik wantah",
  "block.minecraft.banner.stripe_downright.green": "Xoxoktik wantah",
  "block.minecraft.banner.stripe_downright.light_blue": "Tsiktik wantah",
  "block.minecraft.banner.stripe_downright.light_gray": "Ātenextik wantah",
  "block.minecraft.banner.stripe_downright.lime": "Xoxōwik wantah",
  "block.minecraft.banner.stripe_downright.magenta": "Ayohpāltik wantah",
  "block.minecraft.banner.stripe_downright.orange": "Chīltik wantah",
  "block.minecraft.banner.stripe_downright.pink": "Iselik wantah",
  "block.minecraft.banner.stripe_downright.purple": "Kamohtik wantah",
  "block.minecraft.banner.stripe_downright.red": "Chīltik wantah",
  "block.minecraft.banner.stripe_downright.white": "Chipāwak wantah",
  "block.minecraft.banner.stripe_downright.yellow": "Kōstik wantah",
  "block.minecraft.banner.stripe_left.black": "Yāyāwik kwawitl īka yēktlan",
  "block.minecraft.banner.stripe_left.blue": "Āsoltik kwawitl īka yēktlan",
  "block.minecraft.banner.stripe_left.brown": "Kafēntik kwawitl īka yēktlan",
  "block.minecraft.banner.stripe_left.cyan": "Xiwtik kwawitl īka yēktlan",
  "block.minecraft.banner.stripe_left.gray": "Tenextik kwawitl īka yēktlan",
  "block.minecraft.banner.stripe_left.green": "Xoxoktik kwawitl īka yēktlan",
  "block.minecraft.banner.stripe_left.light_blue": "Tsiktik kwawitl īka yēktlan",
  "block.minecraft.banner.stripe_left.light_gray": "Ātenextik kwawitl īka yēktlan",
  "block.minecraft.banner.stripe_left.lime": "Xoxōwik kwawitl īka yēktlan",
  "block.minecraft.banner.stripe_left.magenta": "Ayohpāltik kwawitl īka yēktlan",
  "block.minecraft.banner.stripe_left.orange": "Chīlkōstik kwawitl īka yēktlan",
  "block.minecraft.banner.stripe_left.pink": "Iselik kwawitl īka yēktlan",
  "block.minecraft.banner.stripe_left.purple": "Kamohtik kwawitl īka yēktlan",
  "block.minecraft.banner.stripe_left.red": "Chīltik kwawitl īka yēktlan",
  "block.minecraft.banner.stripe_left.white": "Chipāwak kwawitl īka yēktlan",
  "block.minecraft.banner.stripe_left.yellow": "Kōstik kwawitl īka yēktlan",
  "block.minecraft.banner.stripe_middle.black": "Yāyāwik paxah",
  "block.minecraft.banner.stripe_middle.blue": "Āsoltik paxah",
  "block.minecraft.banner.stripe_middle.brown": "Kafēntik paxah",
  "block.minecraft.banner.stripe_middle.cyan": "Xiwtik paxah",
  "block.minecraft.banner.stripe_middle.gray": "Tenextik paxah",
  "block.minecraft.banner.stripe_middle.green": "Xoxoktik paxah",
  "block.minecraft.banner.stripe_middle.light_blue": "Tsiktik paxah",
  "block.minecraft.banner.stripe_middle.light_gray": "Ātenextik paxah",
  "block.minecraft.banner.stripe_middle.lime": "Xoxōwik paxah",
  "block.minecraft.banner.stripe_middle.magenta": "Ayohpāltik paxah",
  "block.minecraft.banner.stripe_middle.orange": "Chīlkōstik paxah",
  "block.minecraft.banner.stripe_middle.pink": "Iselik paxah",
  "block.minecraft.banner.stripe_middle.purple": "Kamohtik paxah",
  "block.minecraft.banner.stripe_middle.red": "Chīltik paxah",
  "block.minecraft.banner.stripe_middle.white": "Chipāwak paxah",
  "block.minecraft.banner.stripe_middle.yellow": "Kōstik paxah",
  "block.minecraft.banner.stripe_right.black": "Yāyāwik kwawitl īka ōpōchtlan",
  "block.minecraft.banner.stripe_right.blue": "Āsoltik kwawitl īka ōpōchtlan",
  "block.minecraft.banner.stripe_right.brown": "Kafēntik kwawitl īka ōpōchtlan",
  "block.minecraft.banner.stripe_right.cyan": "Xiwtik kwawitl īka ōpōchtlan",
  "block.minecraft.banner.stripe_right.gray": "Tenextik kwawitl īka ōpōchtlan",
  "block.minecraft.banner.stripe_right.green": "Xoxoktik kwawitl īka ōpōchtlan",
  "block.minecraft.banner.stripe_right.light_blue": "Tsiktik kwawitl ōpōchtlan",
  "block.minecraft.banner.stripe_right.light_gray": "Ātenextik kwawitl īka ōpōchtlan",
  "block.minecraft.banner.stripe_right.lime": "Xoxōwik kwawitl īka ōpōchtlan",
  "block.minecraft.banner.stripe_right.magenta": "Ayohpāltik kwawitl ōpōchtlan",
  "block.minecraft.banner.stripe_right.orange": "Chīlkōstik kwawitl ōpōchtlan",
  "block.minecraft.banner.stripe_right.pink": "Iselik kwawitl īka ōpōchtlan",
  "block.minecraft.banner.stripe_right.purple": "Kamohtik kwawitl īka ōpōchtlan",
  "block.minecraft.banner.stripe_right.red": "Chīltik kwawitl īka ōpōchtlan",
  "block.minecraft.banner.stripe_right.white": "Chipāwak kwawitl ōpōchtlan",
  "block.minecraft.banner.stripe_right.yellow": "Kōstik kwawitl ōpōchtlan",
  "block.minecraft.banner.stripe_top.black": "Yāyāwik kwāitl",
  "block.minecraft.banner.stripe_top.blue": "Āsoltik kwāitl",
  "block.minecraft.banner.stripe_top.brown": "Kafēntik kwāitl",
  "block.minecraft.banner.stripe_top.cyan": "Xiwtik kwāitl",
  "block.minecraft.banner.stripe_top.gray": "Tenextik kwāitl",
  "block.minecraft.banner.stripe_top.green": "Xoxoktik kwāitl",
  "block.minecraft.banner.stripe_top.light_blue": "Tsiktik kwāitl",
  "block.minecraft.banner.stripe_top.light_gray": "Ātenextik kwāitl",
  "block.minecraft.banner.stripe_top.lime": "Xoxōwik kwāitl",
  "block.minecraft.banner.stripe_top.magenta": "Ayohpaltik kwāitl",
  "block.minecraft.banner.stripe_top.orange": "Chīlkōstik kwāitl",
  "block.minecraft.banner.stripe_top.pink": "Iselik kwāitl",
  "block.minecraft.banner.stripe_top.purple": "Kamohtik kwāitl",
  "block.minecraft.banner.stripe_top.red": "Chīltik kwāitl",
  "block.minecraft.banner.stripe_top.white": "Chipāwak kwāitl",
  "block.minecraft.banner.stripe_top.yellow": "Kōstik kwāitl",
  "block.minecraft.banner.triangle_bottom.black": "Yāyāwik chepron",
  "block.minecraft.banner.triangle_bottom.blue": "Āsoltik chepron",
  "block.minecraft.banner.triangle_bottom.brown": "Kafēntik chepron",
  "block.minecraft.banner.triangle_bottom.cyan": "Xiwtik chepron",
  "block.minecraft.banner.triangle_bottom.gray": "Tenextik chepron",
  "block.minecraft.banner.triangle_bottom.green": "Xoxoktik chepron",
  "block.minecraft.banner.triangle_bottom.light_blue": "Tsiktik chepron",
  "block.minecraft.banner.triangle_bottom.light_gray": "Ātenextik chepron",
  "block.minecraft.banner.triangle_bottom.lime": "Xoxōwik chepron",
  "block.minecraft.banner.triangle_bottom.magenta": "Ayohpāltik chepron",
  "block.minecraft.banner.triangle_bottom.orange": "Chīlkōstik chepron",
  "block.minecraft.banner.triangle_bottom.pink": "Iselik chepron",
  "block.minecraft.banner.triangle_bottom.purple": "Kamohtik chepron",
  "block.minecraft.banner.triangle_bottom.red": "Chīltik chepron",
  "block.minecraft.banner.triangle_bottom.white": "Chipāwak chepron",
  "block.minecraft.banner.triangle_bottom.yellow": "Kōstik chepron",
  "block.minecraft.banner.triangle_top.black": "Yāyāwik īxkwaptok chepron",
  "block.minecraft.banner.triangle_top.blue": "Āsoltik īxkwaptok chepron",
  "block.minecraft.banner.triangle_top.brown": "Kafēntik īxkwaptok chepron",
  "block.minecraft.banner.triangle_top.cyan": "Xiwtik īxkwaptok chepron",
  "block.minecraft.banner.triangle_top.gray": "Tenextik īxkwaptok chepron",
  "block.minecraft.banner.triangle_top.green": "Xoxoktik īxkwaptok chepron",
  "block.minecraft.banner.triangle_top.light_blue": "Tsiktik īxkwaptok chepron",
  "block.minecraft.banner.triangle_top.light_gray": "Ātenextik īxkwaptok chepron",
  "block.minecraft.banner.triangle_top.lime": "Xoxōwik īxkwaptok chepron",
  "block.minecraft.banner.triangle_top.magenta": "Ayohpāltik īxkwaptok chepron",
  "block.minecraft.banner.triangle_top.orange": "Chīlkōstik īxkwaptok chepron",
  "block.minecraft.banner.triangle_top.pink": "Iselik īxkwaptok chepron",
  "block.minecraft.banner.triangle_top.purple": "Kamohtik īxkwaptok chepron",
  "block.minecraft.banner.triangle_top.red": "Chīltik īxkwaptok chepron",
  "block.minecraft.banner.triangle_top.white": "Chipāwak īxkwaptok chepron",
  "block.minecraft.banner.triangle_top.yellow": "Kōstik īxkwaptok chepron",
  "block.minecraft.banner.triangles_bottom.black": "Tsitsikiltik yāyāwik tlatsīntlan",
  "block.minecraft.banner.triangles_bottom.blue": "Tsitsikiltik āsoltik tlatsīntlan",
  "block.minecraft.banner.triangles_bottom.brown": "Tsitsikiltik kafēntik tlatsīntlan",
  "block.minecraft.banner.triangles_bottom.cyan": "Tsitsikiltik xiwtik tlatsīntlan",
  "block.minecraft.banner.triangles_bottom.gray": "Tsitsikiltik tenextik tlatsīntlan",
  "block.minecraft.banner.triangles_bottom.green": "Tsitsikiltik xoxoktik tlatsīntlan",
  "block.minecraft.banner.triangles_bottom.light_blue": "Tsitsikiltik tsiktik tlatsīntlan",
  "block.minecraft.banner.triangles_bottom.light_gray": "Tsitsikiltik ātenextik tlatsīntlan",
  "block.minecraft.banner.triangles_bottom.lime": "Tsitsikiltik xoxōwik tlatsīntlan",
  "block.minecraft.banner.triangles_bottom.magenta": "Tsitsikiltik ayohpāltik tlatsīntlan",
  "block.minecraft.banner.triangles_bottom.orange": "Tsitsikiltik chīlkōstik tlatsīntlan",
  "block.minecraft.banner.triangles_bottom.pink": "Tsitsikiltik iselik tlatsīntlan",
  "block.minecraft.banner.triangles_bottom.purple": "Tsitsikiltik kamohtik tlatsīntlan",
  "block.minecraft.banner.triangles_bottom.red": "Tsitsikiltik chīltik tlatsīntlan",
  "block.minecraft.banner.triangles_bottom.white": "Tsitsikiltik chipāwak tlatsīntlan",
  "block.minecraft.banner.triangles_bottom.yellow": "Tsitsikiltik kōstik tlatsīntlan",
  "block.minecraft.banner.triangles_top.black": "Tsitsikiltik yāyāwik kwāitl",
  "block.minecraft.banner.triangles_top.blue": "Tsitsikiltik āsoltik kwāitl",
  "block.minecraft.banner.triangles_top.brown": "Tsitsikiltik kafēntik hefeh",
  "block.minecraft.banner.triangles_top.cyan": "Tsitsikiltik xiwtik hefeh",
  "block.minecraft.banner.triangles_top.gray": "Tsitsikiltik tenextik kwāitl",
  "block.minecraft.banner.triangles_top.green": "Tsitsikiltik xoxoktik kwāitl",
  "block.minecraft.banner.triangles_top.light_blue": "Tsitsikiltik tsiktik kwāitl",
  "block.minecraft.banner.triangles_top.light_gray": "Tsitsikiltik ātenextik kwāitl",
  "block.minecraft.banner.triangles_top.lime": "Tsitsikiltik xoxōwik kwāitl",
  "block.minecraft.banner.triangles_top.magenta": "Tsitsikiltik ayohpaltik kwāitl",
  "block.minecraft.banner.triangles_top.orange": "Tsitsikiltik chīlkōstik kwāitl",
  "block.minecraft.banner.triangles_top.pink": "Tsitsikiltik iselik kwāitl",
  "block.minecraft.banner.triangles_top.purple": "Tsitsikiltik kamohtik kwāitl",
  "block.minecraft.banner.triangles_top.red": "Tsitsikiltik chīltik kwāitl",
  "block.minecraft.banner.triangles_top.white": "Tsitsikiltik chipāwak kwāitl",
  "block.minecraft.banner.triangles_top.yellow": "Tsitsikiltik kōstik hefeh",
  "block.minecraft.barrel": "Kwawkomitl",
  "block.minecraft.barrier": "Tlakāwatilistli",
  "block.minecraft.basalt": "Tetsontli",
  "block.minecraft.beacon": "Tlaneīxtilōyān",
  "block.minecraft.beacon.primary": "Chikāwakāyōtl tlen sē",
  "block.minecraft.beacon.secondary": "Chikāwakāyōtl tlen ōme",
  "block.minecraft.bed.no_sleep": "Weli tikochi san īka yowalli so īka ātlatlakamanilistli",
  "block.minecraft.bed.not_safe": "Axweli tikochi nāman: onkah tēkwānih nechka",
  "block.minecraft.bed.obstructed": "Ni tlapechtli tlatsakwililli",
  "block.minecraft.bed.occupied": "Ni tlapechtli tlatekiwilli",
  "block.minecraft.bed.too_far_away": "Axweli tikochi nāman: tlapechtli ēltok tlawel wahka",
  "block.minecraft.bedrock": "Nāntetl",
  "block.minecraft.bee_nest": "Pānalli",
  "block.minecraft.beehive": "Newktsinkalli",
  "block.minecraft.beetroots": "Remolachah",
  "block.minecraft.bell": "Teposkāmapanah",
  "block.minecraft.big_dripleaf": "Wēyi chipīnxiwitl",
  "block.minecraft.big_dripleaf_stem": "Wēyi chipīnxiwkwayōtl",
  "block.minecraft.birch_button": "Aitiboton",
  "block.minecraft.birch_door": "Aitikaltēntli",
  "block.minecraft.birch_fence": "Aitichināmitl",
  "block.minecraft.birch_fence_gate": "Aitichināntēntli",
  "block.minecraft.birch_hanging_sign": "Aitikwatlahkwilōlli wiyōnkētl",
  "block.minecraft.birch_leaves": "Aitixiwiyōtl",
  "block.minecraft.birch_log": "Aitikwatomaktli",
  "block.minecraft.birch_planks": "Aitiwapalli",
  "block.minecraft.birch_pressure_plate": "Aititlakomaltektli",
  "block.minecraft.birch_sapling": "Aitichamānkētl",
  "block.minecraft.birch_shelf": "Aitiākōmitl",
  "block.minecraft.birch_sign": "Atitikwatlahkwilōlli",
  "block.minecraft.birch_slab": "Aitiitstapalli",
  "block.minecraft.birch_stairs": "Aititlehkōlli",
  "block.minecraft.birch_trapdoor": "Aititlaketstēntli",
  "block.minecraft.birch_wall_hanging_sign": "Aititepankwatlahkwilōlli wiyōnkētl",
  "block.minecraft.birch_wall_sign": "Aititepankwatlahkwilōlli",
  "block.minecraft.birch_wood": "Aitikwawitl",
  "block.minecraft.black_banner": "Yāyāwik kwachpāmitl",
  "block.minecraft.black_bed": "Yāyāwik tlapechtli",
  "block.minecraft.black_candle": "Yāyāwik kantēlah",
  "block.minecraft.black_candle_cake": "Tlaoyotlaxkalli īka yāyāwik kantēlah",
  "block.minecraft.black_carpet": "Yāyāwik tilmahpepechtōntli",
  "block.minecraft.black_concrete": "Yāyāwik tenextetl",
  "block.minecraft.black_concrete_powder": "Yāyāwik sementoh",
  "block.minecraft.black_glazed_terracotta": "Yāyāwik tlamahsiltetl",
  "block.minecraft.black_shulker_box": "Yāyāwik shulker-kāxah",
  "block.minecraft.black_stained_glass": "Yāyāwik tewilōtl",
  "block.minecraft.black_stained_glass_pane": "Yāyāwik tewilōpanel",
  "block.minecraft.black_terracotta": "Yāyāwik wiksika tlālkōstli",
  "block.minecraft.black_wool": "Yāyāwik tomitl",
  "block.minecraft.blackstone": "Poyaktetl",
  "block.minecraft.blackstone_slab": "Poyakteitstapalli",
  "block.minecraft.blackstone_stairs": "Poyaktetlehkōlli",
  "block.minecraft.blackstone_wall": "Poyaktetepantli",
  "block.minecraft.blast_furnace": "Ahko ornoh",
  "block.minecraft.blue_banner": "Āsoltik kwachpāmitl",
  "block.minecraft.blue_bed": "Āsoltik tlapechtli",
  "block.minecraft.blue_candle": "Āsoltik kantēlah",
  "block.minecraft.blue_candle_cake": "Tlaoyotlaxkalli īka āsoltik kantēlah",
  "block.minecraft.blue_carpet": "Āsoltik tilmahpepechtōntli",
  "block.minecraft.blue_concrete": "Āsoltik tenextetl",
  "block.minecraft.blue_concrete_powder": "Āsoltik sementoh",
  "block.minecraft.blue_glazed_terracotta": "Āsoltik tlamahsiltetl",
  "block.minecraft.blue_ice": "Āsoltik setl",
  "block.minecraft.blue_orchid": "Āsoltik akatsawihtli",
  "block.minecraft.blue_shulker_box": "Āsoltik shulker-kāxah",
  "block.minecraft.blue_stained_glass": "Āsoltik tewilōtl",
  "block.minecraft.blue_stained_glass_pane": "Āsoltik tewilōpanel",
  "block.minecraft.blue_terracotta": "Āsoltik wiksika tlālkōstli",
  "block.minecraft.blue_wool": "Āsoltik tomitl",
  "block.minecraft.bone_block": "Omixamixtli",
  "block.minecraft.bookshelf": "Āmoxkalli",
  "block.minecraft.brain_coral": "Kwātixxōtapachtli",
  "block.minecraft.brain_coral_block": "Kwātixxōtapachxamixtli",
  "block.minecraft.brain_coral_fan": "Kwātixxōgorgoniah",
  "block.minecraft.brain_coral_wall_fan": "Kwātixxōtepangorgoniah",
  "block.minecraft.brewing_stand": "Tlatsehtselohkētl",
  "block.minecraft.brick_slab": "Kalxamixitstapalli",
  "block.minecraft.brick_stairs": "Kalxamixtlehkōlli",
  "block.minecraft.brick_wall": "Kalxamixtepantli",
  "block.minecraft.bricks": "Kalxamixtli",
  "block.minecraft.brown_banner": "Kafēntik kwachpāmitl",
  "block.minecraft.brown_bed": "Kafēntik tlapechtli",
  "block.minecraft.brown_candle": "Kafēntik kantēlah",
  "block.minecraft.brown_candle_cake": "Tlaoyotlaxkalli īka kafēntik kantēlah",
  "block.minecraft.brown_carpet": "Kafēntik tilmahpepechtōntli",
  "block.minecraft.brown_concrete": "Kafēntik tenextetl",
  "block.minecraft.brown_concrete_powder": "Kafēntik semento",
  "block.minecraft.brown_glazed_terracotta": "Kafēntik tlamahsiltetl",
  "block.minecraft.brown_mushroom": "Kafēntik nanakatl",
  "block.minecraft.brown_mushroom_block": "Kafēntik nanakaxamixtli",
  "block.minecraft.brown_shulker_box": "Kafēntik shulker-kāxah",
  "block.minecraft.brown_stained_glass": "Kafēntik tewilōtl",
  "block.minecraft.brown_stained_glass_pane": "Kafēntik tewilōpanel",
  "block.minecraft.brown_terracotta": "Kafēntik wiksika tlālkōstli",
  "block.minecraft.brown_wool": "Kafēntik tomitl",
  "block.minecraft.bubble_column": "Āpoposokaliskolomnah",
  "block.minecraft.bubble_coral": "Āpoposokalistapachtli",
  "block.minecraft.bubble_coral_block": "Āpoposokalistapachxamixtli",
  "block.minecraft.bubble_coral_fan": "Āpoposokalisgorgoniah",
  "block.minecraft.bubble_coral_wall_fan": "Āpoposokalistepangorgoniah",
  "block.minecraft.budding_amethyst": "Ayohpāltewilōkīxtihkētl",
  "block.minecraft.bush": "Kwawtōntli",
  "block.minecraft.cactus": "Witsatsastli",
  "block.minecraft.cactus_flower": "Witsatsasxōchitl",
  "block.minecraft.cake": "Tlaoyotlaxkalli",
  "block.minecraft.calcite": "Kalsitah",
  "block.minecraft.calibrated_sculk_sensor": "Tlasololtilli Sculk-tlamachilihkētl",
  "block.minecraft.campfire": "Tlikwitl",
  "block.minecraft.candle": "Kantēlah",
  "block.minecraft.candle_cake": "Tlaoyotlaxkalli īka kantēlah",
  "block.minecraft.carrots": "Xōchikamohtli",
  "block.minecraft.cartography_table": "Tlālīxnēxkāyōihkwilolisahkopechtli",
  "block.minecraft.carved_pumpkin": "Alaxtik ayohtli",
  "block.minecraft.cauldron": "Teposāpastli",
  "block.minecraft.cave_air": "Ōstōkehēkatl",
  "block.minecraft.cave_vines": "Ōstōkmekatl",
  "block.minecraft.cave_vines_plant": "Ōstōkmekaxiwitl",
  "block.minecraft.chain": "Teposmekatl",
  "block.minecraft.chain_command_block": "Teposmekatlanawatilisxamixtli",
  "block.minecraft.cherry_button": "Kapolboton",
  "block.minecraft.cherry_door": "Kapolkaltēntli",
  "block.minecraft.cherry_fence": "Kapolchināmitl",
  "block.minecraft.cherry_fence_gate": "Kapolchināntēntli",
  "block.minecraft.cherry_hanging_sign": "Kapolkwatlahkwilōlli wiyōnkētl",
  "block.minecraft.cherry_leaves": "Kapolxiwiyōtl",
  "block.minecraft.cherry_log": "Kapolkwatomaktli",
  "block.minecraft.cherry_planks": "Kapolwapalli",
  "block.minecraft.cherry_pressure_plate": "Kapoltlakomaltektli",
  "block.minecraft.cherry_sapling": "Kapolchamānkētl",
  "block.minecraft.cherry_shelf": "Kapolākōmitl",
  "block.minecraft.cherry_sign": "Kapolkwatlahkwilōlli",
  "block.minecraft.cherry_slab": "Kapolitstapalli",
  "block.minecraft.cherry_stairs": "Kapoltlehkōlli",
  "block.minecraft.cherry_trapdoor": "Kapoltlaketstēntli",
  "block.minecraft.cherry_wall_hanging_sign": "Kapoltepankwatlahkwilōlli wiyōnkētl",
  "block.minecraft.cherry_wall_sign": "Kapoltepankwatlahkwilōlli",
  "block.minecraft.cherry_wood": "Kapolkwawitl",
  "block.minecraft.chest": "Kwapetlakalli",
  "block.minecraft.chipped_anvil": "Kokoxki tepostlatsonalōni",
  "block.minecraft.chiseled_bookshelf": "Tlamāchihchīwalli āmoxkalli",
  "block.minecraft.chiseled_copper": "Tlamāchihchīwalli amochitl",
  "block.minecraft.chiseled_deepslate": "Tlamāchihchīwalli koyowatetl",
  "block.minecraft.chiseled_nether_bricks": "Tlamāchihchīwalli Nether kalxamixtli",
  "block.minecraft.chiseled_polished_blackstone": "Tlamāchihchīwalli petstik poyaktetl",
  "block.minecraft.chiseled_quartz_block": "Tlamāchihchīwalli chawatetl",
  "block.minecraft.chiseled_red_sandstone": "Tlamāchihchīwalli chīltik xāltetl",
  "block.minecraft.chiseled_resin_bricks": "Tlamāchihchīwalli Nether ohxikalxamixtli",
  "block.minecraft.chiseled_sandstone": "Tlamāchihchīwalli xāltetl",
  "block.minecraft.chiseled_stone_bricks": "Tlamāchihchīwalli tekalxamixtli",
  "block.minecraft.chiseled_tuff": "Tlamāchihchīwalli tobah",
  "block.minecraft.chiseled_tuff_bricks": "Tlamāchihchīwalli tobahkalxamixtli",
  "block.minecraft.chorus_flower": "Chorosxōchitl",
  "block.minecraft.chorus_plant": "Chorosxiwitl",
  "block.minecraft.clay": "Tepatl",
  "block.minecraft.closed_eyeblossom": "Ihkopki īxxōchitl",
  "block.minecraft.coal_block": "Tlīlxamixtli",
  "block.minecraft.coal_ore": "Tlīlōstōkāyōtl",
  "block.minecraft.coarse_dirt": "Mikki tlālli",
  "block.minecraft.cobbled_deepslate": "Tlapatlaxīmalli koyowatetl",
  "block.minecraft.cobbled_deepslate_slab": "Tlapatlaxīmalli koyowateitstapalli",
  "block.minecraft.cobbled_deepslate_stairs": "Tlapatlaxīmalli koyowatetlehkōlli",
  "block.minecraft.cobbled_deepslate_wall": "Tlapatlaxīmalli koyowatetepantli",
  "block.minecraft.cobblestone": "Tlapatlaxīmalli tetl",
  "block.minecraft.cobblestone_slab": "Tlapatlaxīmalli itstapalli",
  "block.minecraft.cobblestone_stairs": "Tlapatlaxīmalli tetlehkōlli",
  "block.minecraft.cobblestone_wall": "Tlapatlaxīmalli tetepantli",
  "block.minecraft.cobweb": "Tokasāwalli",
  "block.minecraft.cocoa": "Kakawatl",
  "block.minecraft.command_block": "Tlanawatilisxamixtli",
  "block.minecraft.comparator": "Redstone-tlaīxnāmiktihkētl",
  "block.minecraft.composter": "Kompostahchīwkētl",
  "block.minecraft.conduit": "Tlakanalisarohkētl",
  "block.minecraft.copper_bars": "Amochiwitsōktli",
  "block.minecraft.copper_block": "Amochixamixtli",
  "block.minecraft.copper_bulb": "Amochitlāwīlli",
  "block.minecraft.copper_chain": "Amochimekatl",
  "block.minecraft.copper_chest": "Amochipetlakalli",
  "block.minecraft.copper_door": "Amochikaltēntli",
  "block.minecraft.copper_golem_statue": "Amochigolemkwakwilli",
  "block.minecraft.copper_grate": "Amochirehiyah",
  "block.minecraft.copper_lantern": "Amochikāntīl",
  "block.minecraft.copper_ore": "Amochiōstōkāyōtl",
  "block.minecraft.copper_torch": "Amochitlāwilikōtl",
  "block.minecraft.copper_trapdoor": "Amochitlaketstēntli",
  "block.minecraft.copper_wall_torch": "Amochitepantlāwilikōtl",
  "block.minecraft.cornflower": "Asianoh",
  "block.minecraft.cracked_deepslate_bricks": "Tlapānki koyowatekalxamixtli",
  "block.minecraft.cracked_deepslate_tiles": "Tlapānki koyowatexiwxamixtli",
  "block.minecraft.cracked_nether_bricks": "Tlapānki Nether kalxamixtli",
  "block.minecraft.cracked_polished_blackstone_bricks": "Tlapānki petstik poyaktekalxamixtli",
  "block.minecraft.cracked_stone_bricks": "Tlapānki tekalxamixtli",
  "block.minecraft.crafter": "Tlachihchīwkētl",
  "block.minecraft.crafting_table": "Tlachihchīwalisahkopechtli",
  "block.minecraft.creaking_heart": "Xaxamakakētl īyōllo",
  "block.minecraft.creeper_head": "Creeper-tsontekōmitl",
  "block.minecraft.creeper_wall_head": "Creeper-tepantsontekōmitl",
  "block.minecraft.crimson_button": "Nelchīltik boton",
  "block.minecraft.crimson_door": "Nelchīltik kaltēntli",
  "block.minecraft.crimson_fence": "Nelchīltik chināmitl",
  "block.minecraft.crimson_fence_gate": "Nelchīltik chināntēntli",
  "block.minecraft.crimson_fungus": "Nelchīltik nanakatl",
  "block.minecraft.crimson_hanging_sign": "Nelchīltik kwatlahkwilōlli wiyōnkētl",
  "block.minecraft.crimson_hyphae": "Nelchīltik ifah",
  "block.minecraft.crimson_nylium": "Nelchīltik nilioh",
  "block.minecraft.crimson_planks": "Nelchīltik wapalli",
  "block.minecraft.crimson_pressure_plate": "Nelchīltik tlakomaltektli",
  "block.minecraft.crimson_roots": "Nelchīltik nelwayōtl",
  "block.minecraft.crimson_shelf": "Nelchīltik ākōmitl",
  "block.minecraft.crimson_sign": "Nelchīltik kwatlahkwilōlli",
  "block.minecraft.crimson_slab": "Nelchīltik itstapalli",
  "block.minecraft.crimson_stairs": "Nelchīltik tlehkōlli",
  "block.minecraft.crimson_stem": "Nelchīltik kwayōtl",
  "block.minecraft.crimson_trapdoor": "Nelchīltik tlaketstēntli",
  "block.minecraft.crimson_wall_hanging_sign": "Nelchīltik tepankwatlahkwilōlli wiyōnkētl",
  "block.minecraft.crimson_wall_sign": "Nelchīltik tepankwatlahkwilōlli",
  "block.minecraft.crying_obsidian": "Itstli chōkani",
  "block.minecraft.cut_copper": "Tehtekki amochitl",
  "block.minecraft.cut_copper_slab": "Tehtekki amochiitstapalli",
  "block.minecraft.cut_copper_stairs": "Tehtekki amochitlehkōlli",
  "block.minecraft.cut_red_sandstone": "Tehtekki chīltik xāltetl",
  "block.minecraft.cut_red_sandstone_slab": "Tehtekki chīltik xālteitstapalli",
  "block.minecraft.cut_sandstone": "Tehtekki xāltetl",
  "block.minecraft.cut_sandstone_slab": "Tehtekki xālteitstapalli",
  "block.minecraft.cyan_banner": "Xiwtik kwachpāmitl",
  "block.minecraft.cyan_bed": "Xiwtik tlapechtli",
  "block.minecraft.cyan_candle": "Xiwtik kantēlah",
  "block.minecraft.cyan_candle_cake": "Tlaoyotlaxkalli īka xiwtik kantēlah",
  "block.minecraft.cyan_carpet": "Xiwtik tilmahpepechtōntli",
  "block.minecraft.cyan_concrete": "Xiwtik tenextetl",
  "block.minecraft.cyan_concrete_powder": "Xiwtik sementoh",
  "block.minecraft.cyan_glazed_terracotta": "Xiwtik tlamahsiltetl",
  "block.minecraft.cyan_shulker_box": "Xiwtik shulker-kāxah",
  "block.minecraft.cyan_stained_glass": "Xiwtik tewilōtl",
  "block.minecraft.cyan_stained_glass_pane": "Xiwtik tewilōpanel",
  "block.minecraft.cyan_terracotta": "Xiwtik wiksika tlālkōstli",
  "block.minecraft.cyan_wool": "Xiwtik tomitl",
  "block.minecraft.damaged_anvil": "Tlawel kokoxki tepostlatsonalōni",
  "block.minecraft.dandelion": "Kwānakakilitl",
  "block.minecraft.dark_oak_button": "Yāyaktik āwaboton",
  "block.minecraft.dark_oak_door": "Yāyaktik āwakaltēntli",
  "block.minecraft.dark_oak_fence": "Yāyaktik āwachināmitl",
  "block.minecraft.dark_oak_fence_gate": "Yāyaktik āwachināntēntli",
  "block.minecraft.dark_oak_hanging_sign": "Yāyaktik āwakwatlahkwilōlli wiyōnkētl",
  "block.minecraft.dark_oak_leaves": "Yāyaktik āwaxiwiyōtl",
  "block.minecraft.dark_oak_log": "Yāyaktik āwakwatomaktli",
  "block.minecraft.dark_oak_planks": "Yāyaktik āwawapalli",
  "block.minecraft.dark_oak_pressure_plate": "Yāyaktik āwatlakomaltektli",
  "block.minecraft.dark_oak_sapling": "Yāyaktik āwachamānkētl",
  "block.minecraft.dark_oak_shelf": "Yāyaktik āwaākōmitl",
  "block.minecraft.dark_oak_sign": "Yāyaktik āwakwatlahkwilōlli",
  "block.minecraft.dark_oak_slab": "Yāyaktik āwaitstapalli",
  "block.minecraft.dark_oak_stairs": "Yāyaktik āwatlehkōlli",
  "block.minecraft.dark_oak_trapdoor": "Yāyaktik āwatlaketstēntli",
  "block.minecraft.dark_oak_wall_hanging_sign": "Yāyaktik āwatepankwatlahkwilōlli wiyōnkētl",
  "block.minecraft.dark_oak_wall_sign": "Yāyaktik āwatepankwatlahkwilōlli",
  "block.minecraft.dark_oak_wood": "Yāyaktik āwakwawitl",
  "block.minecraft.dark_prismarine": "Nelxiwtik prismarinah",
  "block.minecraft.dark_prismarine_slab": "Nelxiwtik prismarinahitstapalli",
  "block.minecraft.dark_prismarine_stairs": "Nelxiwtik prismarinahtlehkōlli",
  "block.minecraft.daylight_detector": "Tōnalmeyopantlasalihkētl",
  "block.minecraft.dead_brain_coral": "Mikki kwātixxōtapachtli",
  "block.minecraft.dead_brain_coral_block": "Mikki kwātixxōtapachxamixtli",
  "block.minecraft.dead_brain_coral_fan": "Mikki kwātixxōgorgoniah",
  "block.minecraft.dead_brain_coral_wall_fan": "Mikki kwātixxōtepangorgoniah",
  "block.minecraft.dead_bubble_coral": "Mikki āpoposokalistapachtli",
  "block.minecraft.dead_bubble_coral_block": "Mikki āpoposokalistapachxamixtli",
  "block.minecraft.dead_bubble_coral_fan": "Mikki āpoposokalisgorgoniah",
  "block.minecraft.dead_bubble_coral_wall_fan": "Mikki āpoposokalistepangorgoniah",
  "block.minecraft.dead_bush": "Wākki kwawtōntli",
  "block.minecraft.dead_fire_coral": "Mikki tlitapachtli",
  "block.minecraft.dead_fire_coral_block": "Mikki tlitapachxamixtli",
  "block.minecraft.dead_fire_coral_fan": "Mikki tligorgoniah",
  "block.minecraft.dead_fire_coral_wall_fan": "Mikki tlitepangorgoniah",
  "block.minecraft.dead_horn_coral": "Mikki kwākwawtapachtli",
  "block.minecraft.dead_horn_coral_block": "Mikki kwākwawtapachxamixtli",
  "block.minecraft.dead_horn_coral_fan": "Mikki kwākwawtapachgorgoniah",
  "block.minecraft.dead_horn_coral_wall_fan": "Mikki kwākwawtepangorgoniah",
  "block.minecraft.dead_tube_coral": "Mikki ākatlatektapachtli",
  "block.minecraft.dead_tube_coral_block": "Mikki ākatlatektapachxamixtli",
  "block.minecraft.dead_tube_coral_fan": "Mikki ākatlatektapachgorgoniah",
  "block.minecraft.dead_tube_coral_wall_fan": "Mikki ākatlatektapachteoangorgoniah",
  "block.minecraft.decorated_pot": "Kōmitl",
  "block.minecraft.deepslate": "Koyowatetl",
  "block.minecraft.deepslate_brick_slab": "Koyowatekalxamixitstapalli",
  "block.minecraft.deepslate_brick_stairs": "Koyowatekalxamixtlehkōlli",
  "block.minecraft.deepslate_brick_wall": "Koyowatekalxamixtepantli",
  "block.minecraft.deepslate_bricks": "Koyowatekalxamixtli",
  "block.minecraft.deepslate_coal_ore": "Koyowatetlīlōstōkāyōtl",
  "block.minecraft.deepslate_copper_ore": "Koyowateamochiōstōkāyōtl",
  "block.minecraft.deepslate_diamond_ore": "Koyowatetlakwawaktekpaōstōkāyōtl",
  "block.minecraft.deepslate_emerald_ore": "Koyowatechalchiwōstōkāyōtl",
  "block.minecraft.deepslate_gold_ore": "Koyowateteōkwitlaōstōkayōtl",
  "block.minecraft.deepslate_iron_ore": "Koyowateteposōstōkāyōtl",
  "block.minecraft.deepslate_lapis_ore": "Koyowatelapislasolihōstōkāyōtl",
  "block.minecraft.deepslate_redstone_ore": "Koyowate-redstone-ōstōkāyōtl",
  "block.minecraft.deepslate_tile_slab": "Koyowatexiwxamixitstapalli",
  "block.minecraft.deepslate_tile_stairs": "Koyowatexiwxamixtlehkōlli",
  "block.minecraft.deepslate_tile_wall": "Koyowatexiwxamixtepantli",
  "block.minecraft.deepslate_tiles": "Koyowatexiwxamixtli",
  "block.minecraft.detector_rail": "Teposohtli tlapantlasalihkētl",
  "block.minecraft.diamond_block": "Tlakwawak tekpaxamixtli",
  "block.minecraft.diamond_ore": "Tlakwawak tekpaōstōkāyōtl",
  "block.minecraft.diorite": "Tlīltepaktli",
  "block.minecraft.diorite_slab": "Tlīltepakitstapalli",
  "block.minecraft.diorite_stairs": "Tlīltepaktlehkōlli",
  "block.minecraft.diorite_wall": "Tlīltepaktepantli",
  "block.minecraft.dirt": "Tlālli",
  "block.minecraft.dirt_path": "Tlālohtli",
  "block.minecraft.dispenser": "Tlaxehxelohkētl",
  "block.minecraft.dragon_egg": "Ketsalkwetspaltetl",
  "block.minecraft.dragon_head": "Ketsalkwetspaltsontekōmitl",
  "block.minecraft.dragon_wall_head": "Ketsalkwetspaltepantsontekōmitl",
  "block.minecraft.dried_ghast": "Wākki ghast",
  "block.minecraft.dried_kelp_block": "Wākki ākwawtōnxamixtli",
  "block.minecraft.dripstone_block": "Tlāltisaxamixtli",
  "block.minecraft.dropper": "Tlamahkāwkētl",
  "block.minecraft.emerald_block": "Chalchiwxamixtli",
  "block.minecraft.emerald_ore": "Chalchiwōstōkāyōtl",
  "block.minecraft.enchanting_table": "Tlaxōchilisahkopechtli",
  "block.minecraft.end_gateway": "End-onkakistilistli",
  "block.minecraft.end_portal": "End kalakiyān",
  "block.minecraft.end_portal_frame": "End kalakiyān markoh",
  "block.minecraft.end_rod": "End kwawinaxtli",
  "block.minecraft.end_stone": "End tetl",
  "block.minecraft.end_stone_brick_slab": "End tekalxamixitstapalli",
  "block.minecraft.end_stone_brick_stairs": "End tekalxamixtlehkōlli",
  "block.minecraft.end_stone_brick_wall": "End tekalxamixtepantli",
  "block.minecraft.end_stone_bricks": "End tekalxamixtli",
  "block.minecraft.ender_chest": "Ender kwapetlakalli",
  "block.minecraft.exposed_chiseled_copper": "Tlatōnaltlālilli tlamāchihchīwalli amochitl",
  "block.minecraft.exposed_copper": "Tlatōnaltlālilli amochitl",
  "block.minecraft.exposed_copper_bars": "Tlatōnaltlālilli amochiwitsōktli",
  "block.minecraft.exposed_copper_bulb": "Tlatōnaltlālilli amochitlāwīlli",
  "block.minecraft.exposed_copper_chain": "Tlatōnaltlālilli amochimekatl",
  "block.minecraft.exposed_copper_chest": "Tlatōnaltlālilli amochipetlakalli",
  "block.minecraft.exposed_copper_door": "Tlatōnaltlālilli amochikaltēntli",
  "block.minecraft.exposed_copper_golem_statue": "Tlatōnaltlālilli amochigolemkwakwilli",
  "block.minecraft.exposed_copper_grate": "Tlatōnaltlālilli amochirehiyah",
  "block.minecraft.exposed_copper_lantern": "Tlatōnaltlālilli amochikāntīl",
  "block.minecraft.exposed_copper_trapdoor": "Tlatōnaltlālilli amochitlaketstēntli",
  "block.minecraft.exposed_cut_copper": "Tlatōnaltlālilli tehtekki amochitl",
  "block.minecraft.exposed_cut_copper_slab": "Tlatōnaltlālilli tehtekki amochiitstapalli",
  "block.minecraft.exposed_cut_copper_stairs": "Tlatōnaltlālilli tehtekki amochitlehkōlli",
  "block.minecraft.exposed_lightning_rod": "Tlatōnaltlālilli tlimekaketskētl",
  "block.minecraft.farmland": "Ātōktli",
  "block.minecraft.fern": "Okopetlatl",
  "block.minecraft.fire": "Tlitl",
  "block.minecraft.fire_coral": "Tlitapachtli",
  "block.minecraft.fire_coral_block": "Tlitapachxamixtli",
  "block.minecraft.fire_coral_fan": "Tligorgoniah",
  "block.minecraft.fire_coral_wall_fan": "Tlitepangorgoniah",
  "block.minecraft.firefly_bush": "Kwawtōntli īka kokimeh",
  "block.minecraft.fletching_table": "Tlamīnalisahkopechtli",
  "block.minecraft.flower_pot": "Masetah",
  "block.minecraft.flowering_azalea": "Xōchiyowki asaleah",
  "block.minecraft.flowering_azalea_leaves": "Asaleahxiwiyōtl xōchiyowkētl",
  "block.minecraft.frogspawn": "Pechpechtetl",
  "block.minecraft.frosted_ice": "Setl",
  "block.minecraft.furnace": "Xamixkaltexkalli",
  "block.minecraft.gilded_blackstone": "Tteōkwitlakōstik poyaktetl",
  "block.minecraft.glass": "Tewilōtl",
  "block.minecraft.glass_pane": "Tewilōpanel",
  "block.minecraft.glow_lichen": "Tlāwīlloh liken",
  "block.minecraft.glowstone": "Tlāwīltetl",
  "block.minecraft.gold_block": "Teōkwitlaxamixtli",
  "block.minecraft.gold_ore": "Teōkwitlaōstōkāyōtl",
  "block.minecraft.golden_dandelion": "Teōkwitlakōstik kwānakakilitl",
  "block.minecraft.granite": "Tepaktli",
  "block.minecraft.granite_slab": "Tepakitstapalli",
  "block.minecraft.granite_stairs": "Tepaktlehkōlli",
  "block.minecraft.granite_wall": "Tepaktepantli",
  "block.minecraft.grass": "Sakatl",
  "block.minecraft.grass_block": "Sakaxamixtli",
  "block.minecraft.gravel": "Sīltetl",
  "block.minecraft.gray_banner": "Tenextik kwachpāmitl",
  "block.minecraft.gray_bed": "Tenextik tlapechtli",
  "block.minecraft.gray_candle": "Tenextik kantēlah",
  "block.minecraft.gray_candle_cake": "Tlaoyotlaxkalli īka tenextik kantēlah",
  "block.minecraft.gray_carpet": "Tenextik tilmahpepechtōntli",
  "block.minecraft.gray_concrete": "Tenextetl",
  "block.minecraft.gray_concrete_powder": "Sementoh",
  "block.minecraft.gray_glazed_terracotta": "Tenextik tlamahsiltetl",
  "block.minecraft.gray_shulker_box": "Tenextik shulker-kāxah",
  "block.minecraft.gray_stained_glass": "Tenextik tewilōtl",
  "block.minecraft.gray_stained_glass_pane": "Tenextik tewilōpanel",
  "block.minecraft.gray_terracotta": "Tenextik wiksika tlālkōstli",
  "block.minecraft.gray_wool": "Tenextik tomitl",
  "block.minecraft.green_banner": "Xoxomti kwachpāmitl",
  "block.minecraft.green_bed": "Xoxoktik tlapechtli",
  "block.minecraft.green_candle": "Xoxoktik kantēlah",
  "block.minecraft.green_candle_cake": "Tlaoyotlaxkalli īka xoxoktik kantēlah",
  "block.minecraft.green_carpet": "Xoxoktik tilmahpepechtōntli",
  "block.minecraft.green_concrete": "Xoxoktik tenextetl",
  "block.minecraft.green_concrete_powder": "Xoxoktik sementoh",
  "block.minecraft.green_glazed_terracotta": "Xoxoktik tlamahsiltetl",
  "block.minecraft.green_shulker_box": "Xoxoktik shulker-kāxah",
  "block.minecraft.green_stained_glass": "Xoxoktik tewilōtl",
  "block.minecraft.green_stained_glass_pane": "Xoxoktik tewilōpanel",
  "block.minecraft.green_terracotta": "Xoxoktik wiksika tlālkōstli",
  "block.minecraft.green_wool": "Xoxoktik tomitl",
  "block.minecraft.grindstone": "Tetēntihkētl",
  "block.minecraft.hanging_roots": "Nelwayōtl wiyōnkētl",
  "block.minecraft.hay_block": "Pachxamixtli",
  "block.minecraft.heavy_core": "Ētik yōllōtl",
  "block.minecraft.heavy_weighted_pressure_plate": "Ētikāyōtlakomaltektli",
  "block.minecraft.honey_block": "Newkxamixtli",
  "block.minecraft.honeycomb_block": "Pānalxamixtli",
  "block.minecraft.hopper": "Tolbah",
  "block.minecraft.horn_coral": "Kwākwawtapachtli",
  "block.minecraft.horn_coral_block": "Kwākwawtapachxamixtli",
  "block.minecraft.horn_coral_fan": "Kwākwawgorgoniah",
  "block.minecraft.horn_coral_wall_fan": "Kwākwawtepangorgoniah",
  "block.minecraft.ice": "Setl",
  "block.minecraft.infested_chiseled_stone_bricks": "Palaxtik tlamāchihchīwalli tekalxamixtli",
  "block.minecraft.infested_cobblestone": "Palaxtik tlapatlaxīmalli tetl",
  "block.minecraft.infested_cracked_stone_bricks": "Palaxtik tlapānki tekalxamixtli",
  "block.minecraft.infested_deepslate": "Palaxtik koyowatetl",
  "block.minecraft.infested_mossy_stone_bricks": "Palaxtik sakaxiwiyoh tekalxamixtli",
  "block.minecraft.infested_stone": "Palaxtik tetl",
  "block.minecraft.infested_stone_bricks": "Palaxtik tekalxamixtli",
  "block.minecraft.iron_bars": "Teposwitsōktli",
  "block.minecraft.iron_block": "Teposxamixtli",
  "block.minecraft.iron_chain": "Teposmekatl",
  "block.minecraft.iron_door": "Teposkaltēntli",
  "block.minecraft.iron_ore": "Teposōstōkāyōtl",
  "block.minecraft.iron_trapdoor": "Tepostlaketstēntli",
  "block.minecraft.jack_o_lantern": "Ilwiayohtli",
  "block.minecraft.jigsaw": "Tsontekōntlapānkāxamixtli",
  "block.minecraft.jukebox": "Wīkayōkāxah",
  "block.minecraft.jungle_button": "Āchipiko boton",
  "block.minecraft.jungle_door": "Āchipiko kaltēntli",
  "block.minecraft.jungle_fence": "Āchipiko chināmitl",
  "block.minecraft.jungle_fence_gate": "Āchipiko chināntēntli",
  "block.minecraft.jungle_hanging_sign": "Āchipiko kwatlahkwilōlli wiyōnkētl",
  "block.minecraft.jungle_leaves": "Āchipiko xiwiyōtl",
  "block.minecraft.jungle_log": "Āchipiko kwatomaktli",
  "block.minecraft.jungle_planks": "Āchipiko wapalli",
  "block.minecraft.jungle_pressure_plate": "Āchipiko tlakomaltektli",
  "block.minecraft.jungle_sapling": "Āchipiko chamānkētl",
  "block.minecraft.jungle_shelf": "Āchipiko ākōmitl",
  "block.minecraft.jungle_sign": "Āchipiko kwatlahkwilōlli",
  "block.minecraft.jungle_slab": "Āchipiko itstapalli",
  "block.minecraft.jungle_stairs": "Āchipiko tlehkōlli",
  "block.minecraft.jungle_trapdoor": "Āchipiko tlaketstēntli",
  "block.minecraft.jungle_wall_hanging_sign": "Āchipiko tepankwatlahkwilōlli wiyōnkētl",
  "block.minecraft.jungle_wall_sign": "Āchipiko tepankwatlahkwilōlli",
  "block.minecraft.jungle_wood": "Āchipiko kwawitl",
  "block.minecraft.kelp": "Ākwawtōntli",
  "block.minecraft.kelp_plant": "Ākwawtōnnelwayōtl",
  "block.minecraft.ladder": "Māekawastli",
  "block.minecraft.lantern": "Kāntīl",
  "block.minecraft.lapis_block": "Lapislasolihxamixtli",
  "block.minecraft.lapis_ore": "Lapislasolihōstōkāyōtl",
  "block.minecraft.large_amethyst_bud": "Wēyi ayohpāltewilōkīsalistli",
  "block.minecraft.large_fern": "Wahkapāntik okopetlatl",
  "block.minecraft.lava": "Pōposōnilli",
  "block.minecraft.lava_cauldron": "Teposāpastli īka pōposōnilli",
  "block.minecraft.leaf_litter": "Tlasollōtl",
  "block.minecraft.lectern": "Kwatlehkōni",
  "block.minecraft.lever": "Kwammītl",
  "block.minecraft.light": "Tlāwīlli",
  "block.minecraft.light_blue_banner": "Tsiktik kwachpāmitl",
  "block.minecraft.light_blue_bed": "Tsiktik tlapechtli",
  "block.minecraft.light_blue_candle": "Tsiktik kantēlah",
  "block.minecraft.light_blue_candle_cake": "Tlaoyotlaxkalli īka tsiktik kantēlah",
  "block.minecraft.light_blue_carpet": "Tsiktik tilmahpepechtōntli",
  "block.minecraft.light_blue_concrete": "Tsiktik tenextetl",
  "block.minecraft.light_blue_concrete_powder": "Tsiktik sementoh",
  "block.minecraft.light_blue_glazed_terracotta": "Tsiktik tlamahsiltetl",
  "block.minecraft.light_blue_shulker_box": "Tsiktik shulker-kāxah",
  "block.minecraft.light_blue_stained_glass": "Tsiktik tewilōtl",
  "block.minecraft.light_blue_stained_glass_pane": "Tsiktik tewilōpanel",
  "block.minecraft.light_blue_terracotta": "Tsiktik wiksika tlālkōstli",
  "block.minecraft.light_blue_wool": "Tsiktik tomitl",
  "block.minecraft.light_gray_banner": "Ātenextik kwachpāmitl",
  "block.minecraft.light_gray_bed": "Ātenextik tlapechtli",
  "block.minecraft.light_gray_candle": "Ātenextik kantēlah",
  "block.minecraft.light_gray_candle_cake": "Tlaoyotlaxkalli īka ātenextik kantēlah",
  "block.minecraft.light_gray_carpet": "Ātenextik tilmahpepechtōntli",
  "block.minecraft.light_gray_concrete": "Ātenextik tenextetl",
  "block.minecraft.light_gray_concrete_powder": "Sementoh",
  "block.minecraft.light_gray_glazed_terracotta": "Ātenextik tlamahsiltetl",
  "block.minecraft.light_gray_shulker_box": "Ātenextik shulker-kāxah",
  "block.minecraft.light_gray_stained_glass": "Ātenextik tewilōtl",
  "block.minecraft.light_gray_stained_glass_pane": "Ātenextik tewilōpanel",
  "block.minecraft.light_gray_terracotta": "Ātenextik wiksika tlālkōstli",
  "block.minecraft.light_gray_wool": "Ātenextik tomitl",
  "block.minecraft.light_weighted_pressure_plate": "Ākasotikāyōtlakomaltektli",
  "block.minecraft.lightning_rod": "Tlimekaketskētl",
  "block.minecraft.lilac": "Poxxōchitl",
  "block.minecraft.lily_of_the_valley": "Tsontekōnxōchitl tlen ixtlawatl",
  "block.minecraft.lily_pad": "Ātlakwesonan",
  "block.minecraft.lime_banner": "Xoxōwik kwachpāmitl",
  "block.minecraft.lime_bed": "Xoxōwik tlapechtli",
  "block.minecraft.lime_candle": "Xoxōwik kantēlah",
  "block.minecraft.lime_candle_cake": "Tlaoyotlaxkalli īka xoxōwik kantēlah",
  "block.minecraft.lime_carpet": "Xoxōwik tilmahpepechtōntli",
  "block.minecraft.lime_concrete": "Xoxōwik tenextetl",
  "block.minecraft.lime_concrete_powder": "Xoxōwik sementoh",
  "block.minecraft.lime_glazed_terracotta": "Xoxōwik tlamahsiltetl",
  "block.minecraft.lime_shulker_box": "Xoxōwik shulker-kāxah",
  "block.minecraft.lime_stained_glass": "Xoxōwik tewilōtl",
  "block.minecraft.lime_stained_glass_pane": "Xoxōwik tewilōpanel",
  "block.minecraft.lime_terracotta": "Xoxōwik wiksika tlālkōstli",
  "block.minecraft.lime_wool": "Xoxōwik tomitl",
  "block.minecraft.lodestone": "Maknetitah",
  "block.minecraft.loom": "Ikitiwalōni",
  "block.minecraft.magenta_banner": "Ayohpāltik kwachpāmitl",
  "block.minecraft.magenta_bed": "Ayopaltik tlapechtli",
  "block.minecraft.magenta_candle": "Ayohpāltik kantēlah",
  "block.minecraft.magenta_candle_cake": "Tlaoyotlaxkalli īka ayohpāltik kantēlah",
  "block.minecraft.magenta_carpet": "Ayohpāltik tilmahpepechtōntli",
  "block.minecraft.magenta_concrete": "Ayohpāltik tenextetl",
  "block.minecraft.magenta_concrete_powder": "Ayohpaltik sementoh",
  "block.minecraft.magenta_glazed_terracotta": "Ayohpāltik tlamahsiltetl",
  "block.minecraft.magenta_shulker_box": "Ayohpāltik shulker-kāxah",
  "block.minecraft.magenta_stained_glass": "Ayohpāltik tewilōtl",
  "block.minecraft.magenta_stained_glass_pane": "Ayohpāltik tewilōpanel",
  "block.minecraft.magenta_terracotta": "Ayohpāltik wiksika tlālkōstli",
  "block.minecraft.magenta_wool": "Ayohpāltik tomitl",
  "block.minecraft.magma_block": "Tlisokiāxamixtli",
  "block.minecraft.mangrove_button": "Āwihkolkwawboton",
  "block.minecraft.mangrove_door": "Āwihkolkwawkaltēntli",
  "block.minecraft.mangrove_fence": "Āwihkolkwawchināmitl",
  "block.minecraft.mangrove_fence_gate": "Āwihkolkwawchināntēntli",
  "block.minecraft.mangrove_hanging_sign": "Āwihkolkwatlahkwilōlli wiyōnkētl",
  "block.minecraft.mangrove_leaves": "Āwihkolkwawxiwiyōtl",
  "block.minecraft.mangrove_log": "Āwihkolkwawkwatomaktli",
  "block.minecraft.mangrove_planks": "Āwihkolkwawapalli",
  "block.minecraft.mangrove_pressure_plate": "Āwihkolkwawtlakomaltektli",
  "block.minecraft.mangrove_propagule": "Āwihkolkwawpropagoloh",
  "block.minecraft.mangrove_roots": "Āwihkolkwawnelwayōtl",
  "block.minecraft.mangrove_shelf": "Āwihkolkwawākōmitl",
  "block.minecraft.mangrove_sign": "Āwihkolkwawkwatlahkwilōlli",
  "block.minecraft.mangrove_slab": "Āwihkolkwawitstapalli",
  "block.minecraft.mangrove_stairs": "Āwihkolkwawtlehkōlli",
  "block.minecraft.mangrove_trapdoor": "Āwihkolkwawtlaketstēntli",
  "block.minecraft.mangrove_wall_hanging_sign": "Āwihkolkwawtepankwatlahkwilōlli wiyōnkētl",
  "block.minecraft.mangrove_wall_sign": "Āwihkolkwawtepankwatlahkwilōlli",
  "block.minecraft.mangrove_wood": "Āwihkolkwawitl",
  "block.minecraft.medium_amethyst_bud": "Sankwalli ayohpāltewilōkīsalistli",
  "block.minecraft.melon": "Santiah",
  "block.minecraft.melon_stem": "Santiahkwayōtl",
  "block.minecraft.moss_block": "Sakaxiwixamixtli",
  "block.minecraft.moss_carpet": "Sakaxiwipetlatl",
  "block.minecraft.mossy_cobblestone": "Petstik tlapatlaxīmalli tetl",
  "block.minecraft.mossy_cobblestone_slab": "Sakaxiwiyoh tlapatlaxīmalli itstapalli",
  "block.minecraft.mossy_cobblestone_stairs": "Sakaxiwiyoh tlapatlaxīmalli tetlehkōlli",
  "block.minecraft.mossy_cobblestone_wall": "Sakaxiwiyoh tlapatlaxīmalli tetepantli",
  "block.minecraft.mossy_stone_brick_slab": "Sakaxiwiyoh tekalxamixitstapalli",
  "block.minecraft.mossy_stone_brick_stairs": "Sakaxiwiyoh tekalxamixtlehkōlli",
  "block.minecraft.mossy_stone_brick_wall": "Sakaxiwiyoh tekalxamixtepantli",
  "block.minecraft.mossy_stone_bricks": "Sakaxiwiyoh tekalxamixtli",
  "block.minecraft.moving_piston": "Piston moihkwenihkētl",
  "block.minecraft.mud": "Sokitl",
  "block.minecraft.mud_brick_slab": "Xankalxamixitstapalli",
  "block.minecraft.mud_brick_stairs": "Xankalxamixtlehkōlli",
  "block.minecraft.mud_brick_wall": "Xankalxamixtepantli",
  "block.minecraft.mud_bricks": "Xankalxamixtli",
  "block.minecraft.muddy_mangrove_roots": "Sokiyoh āwihkolkwawnelwayōtl",
  "block.minecraft.mushroom_stem": "Nanakakwayōtl",
  "block.minecraft.mycelium": "Miselioh",
  "block.minecraft.nether_brick_fence": "Nether kalxamixchināmitl",
  "block.minecraft.nether_brick_slab": "Nether kalxamixitstapalli",
  "block.minecraft.nether_brick_stairs": "Nether xamixtlehkōlli",
  "block.minecraft.nether_brick_wall": "Nether kalxamixtepantli",
  "block.minecraft.nether_bricks": "Nether kalxamixtli",
  "block.minecraft.nether_gold_ore": "Nether teōkwitlaōstōkāyōtl",
  "block.minecraft.nether_portal": "Nether kalakiyān",
  "block.minecraft.nether_quartz_ore": "Nether chawateōstōkāyōtl",
  "block.minecraft.nether_sprouts": "Nether chamānkētl",
  "block.minecraft.nether_wart": "Nether tsokaxiwitl",
  "block.minecraft.nether_wart_block": "Nether tsokaxiwixamixtli",
  "block.minecraft.netherite_block": "Nethertexamixtli",
  "block.minecraft.netherrack": "Netherrack",
  "block.minecraft.note_block": "Wīkaxamixtli",
  "block.minecraft.oak_button": "Āwaboton",
  "block.minecraft.oak_door": "Āwakaltēntli",
  "block.minecraft.oak_fence": "Āwachināmitl",
  "block.minecraft.oak_fence_gate": "Āwachināntēntli",
  "block.minecraft.oak_hanging_sign": "Āwakwatlahkwilōlli wiyōnkētl",
  "block.minecraft.oak_leaves": "Āwaxiwiyōtl",
  "block.minecraft.oak_log": "Āwakwatomaktli",
  "block.minecraft.oak_planks": "Āwawapalli",
  "block.minecraft.oak_pressure_plate": "Āwatlakomaltektli",
  "block.minecraft.oak_sapling": "Āwachamānkētl",
  "block.minecraft.oak_shelf": "Āwaākōmitl",
  "block.minecraft.oak_sign": "Āwakwatlahkwilōlli",
  "block.minecraft.oak_slab": "Āwaitstapalli",
  "block.minecraft.oak_stairs": "Āwatlehkōlli",
  "block.minecraft.oak_trapdoor": "Āwatlaketstēntli",
  "block.minecraft.oak_wall_hanging_sign": "Āwatepankwatlahkwilōlli wiyōnkētl",
  "block.minecraft.oak_wall_sign": "Āwatepankwatlahkwilōlli",
  "block.minecraft.oak_wood": "Āwakwawitl",
  "block.minecraft.observer": "Tlatlachīxkētl",
  "block.minecraft.obsidian": "Itstli",
  "block.minecraft.ochre_froglight": "Tlatlāwililli pechpechtlāwīlli",
  "block.minecraft.ominous_banner": "Kehnipatik kwachpāmitl",
  "block.minecraft.open_eyeblossom": "Kwepōnki īxxōchitl",
  "block.minecraft.orange_banner": "Chīlkōstik kwachpāmitl",
  "block.minecraft.orange_bed": "Chīlkōstik tlapechtli",
  "block.minecraft.orange_candle": "Chīlkōstik kantēlah",
  "block.minecraft.orange_candle_cake": "Tlaoyotlaxkalli īka chīlkōstik kantēlah",
  "block.minecraft.orange_carpet": "Chīlkōstik tilmahpepechtōntli",
  "block.minecraft.orange_concrete": "Chīlkōstik tenextetl",
  "block.minecraft.orange_concrete_powder": "Chīlkōstik sementoh",
  "block.minecraft.orange_glazed_terracotta": "Chīlkōstik tlamahsiltetl",
  "block.minecraft.orange_shulker_box": "Chīlkōstik shulker-kāxah",
  "block.minecraft.orange_stained_glass": "Chīlkōstik tewilōtl",
  "block.minecraft.orange_stained_glass_pane": "Kōstik tewilōpanel",
  "block.minecraft.orange_terracotta": "Chīlkōstik wiksika tlālkōstli",
  "block.minecraft.orange_tulip": "Chilkostik tolipan",
  "block.minecraft.orange_wool": "Chīlkōstik ichkatsomitl",
  "block.minecraft.oxeye_daisy": "Koktelxōchitl",
  "block.minecraft.oxidized_chiseled_copper": "Xawalōk tlamāchihchīwalli amochitl",
  "block.minecraft.oxidized_copper": "Xawalōk amochitl",
  "block.minecraft.oxidized_copper_bars": "Xawalōk amochiwitsōktli",
  "block.minecraft.oxidized_copper_bulb": "Xawalōk amochitlāwīlli",
  "block.minecraft.oxidized_copper_chain": "Xawalōk amochimekatl",
  "block.minecraft.oxidized_copper_chest": "Xawalōk amochipetlakalli",
  "block.minecraft.oxidized_copper_door": "Xawalōk amochikaltēntli",
  "block.minecraft.oxidized_copper_golem_statue": "Xawalōk amochigolemkwakwilli",
  "block.minecraft.oxidized_copper_grate": "Xawalōk amochirehiyah",
  "block.minecraft.oxidized_copper_lantern": "Xawalōk amochiokāntīl",
  "block.minecraft.oxidized_copper_trapdoor": "Xawalōk amochitlaketstēntli",
  "block.minecraft.oxidized_cut_copper": "Xawalōk tehtekki amochitl",
  "block.minecraft.oxidized_cut_copper_slab": "Xawalōk tehtekki amochiitstapalli",
  "block.minecraft.oxidized_cut_copper_stairs": "Xawalōk tehtekki amochitlehkōlli",
  "block.minecraft.oxidized_lightning_rod": "Xawalōk tlimekaketskētl",
  "block.minecraft.packed_ice": "Tepasetl",
  "block.minecraft.packed_mud": "Xamitl",
  "block.minecraft.pale_hanging_moss": "Istāltik sakaxiwitl wiyōnkētl",
  "block.minecraft.pale_moss_block": "Istāltik sakaxiwixamixtli",
  "block.minecraft.pale_moss_carpet": "Istāltik sakaxiwitilmahpepechtōntli",
  "block.minecraft.pale_oak_button": "Istāltik āwaboton",
  "block.minecraft.pale_oak_door": "Istāltik āwakaltēntli",
  "block.minecraft.pale_oak_fence": "Istāltik āwachināmitl",
  "block.minecraft.pale_oak_fence_gate": "Istāltik āwachināntēntli",
  "block.minecraft.pale_oak_hanging_sign": "Istāltik āwakwatlahkwilōlli wiyōnkētl",
  "block.minecraft.pale_oak_leaves": "Istāltik āwaxiwiyōtl",
  "block.minecraft.pale_oak_log": "Istāltik āwakwatomaktli",
  "block.minecraft.pale_oak_planks": "Istāltik āwawapalli",
  "block.minecraft.pale_oak_pressure_plate": "Istāltik āwatlakomaltektli",
  "block.minecraft.pale_oak_sapling": "Istāltik āwachamānkētl",
  "block.minecraft.pale_oak_shelf": "Istlāltik āwaākōmitl",
  "block.minecraft.pale_oak_sign": "Istāltik āwakwatlahkwilōlli",
  "block.minecraft.pale_oak_slab": "Istāltik āwaitstapalli",
  "block.minecraft.pale_oak_stairs": "Istāltik āwatlehkōlli",
  "block.minecraft.pale_oak_trapdoor": "Istāltik āwatlaketstēntli",
  "block.minecraft.pale_oak_wall_hanging_sign": "Istāltik āwatepankwatlahkwilōlli wiyōnkētl",
  "block.minecraft.pale_oak_wall_sign": "Istāltik āwatepankwatlahkwilōlli",
  "block.minecraft.pale_oak_wood": "Istāltik āwakwawitl",
  "block.minecraft.pearlescent_froglight": "Tewiltik pechpechtlāwīlli",
  "block.minecraft.peony": "Peoniah",
  "block.minecraft.petrified_oak_slab": "Teteski āwaitstapalli",
  "block.minecraft.piglin_head": "Piglintsontekōmitl",
  "block.minecraft.piglin_wall_head": "Piglintepantsontekōmitl",
  "block.minecraft.pink_banner": "Iselik kwachpāmitl",
  "block.minecraft.pink_bed": "Iselik tlapechtli",
  "block.minecraft.pink_candle": "Iselik kantēlah",
  "block.minecraft.pink_candle_cake": "Tlaoyotlaxkalli īka iselik kantēlah",
  "block.minecraft.pink_carpet": "Iselik tilmahpepechtōntli",
  "block.minecraft.pink_concrete": "Iselik tenextetl",
  "block.minecraft.pink_concrete_powder": "Iselik sementoh",
  "block.minecraft.pink_glazed_terracotta": "Iselik tlamahsiltetl",
  "block.minecraft.pink_petals": "Iselik xōchiiswatl",
  "block.minecraft.pink_shulker_box": "Iselik shulker-kāxah",
  "block.minecraft.pink_stained_glass": "Iselik tewilōtl",
  "block.minecraft.pink_stained_glass_pane": "Iselik tewilōpanel",
  "block.minecraft.pink_terracotta": "Iselik wiksika tlālkōstli",
  "block.minecraft.pink_tulip": "Iselik tolipan",
  "block.minecraft.pink_wool": "Iselik ichkatsomitl",
  "block.minecraft.piston": "Piston",
  "block.minecraft.piston_head": "Pistontsontekōmitl",
  "block.minecraft.pitcher_crop": "Kōnxiwiēlīltilistli",
  "block.minecraft.pitcher_plant": "Kōnxiwitl",
  "block.minecraft.player_head": "Māwiltihkātsontekōmitl",
  "block.minecraft.player_head.named": "%s ītsontekōn",
  "block.minecraft.player_wall_head": "Māwiltihkātepantsontekōmitl",
  "block.minecraft.podzol": "Axkwaltlālli",
  "block.minecraft.pointed_dripstone": "Yakawitstik tlāltisatl",
  "block.minecraft.polished_andesite": "Petstik antesitah",
  "block.minecraft.polished_andesite_slab": "Petstik antesitahitstapalli",
  "block.minecraft.polished_andesite_stairs": "Petstik antesitahtlehkōlli",
  "block.minecraft.polished_basalt": "Petstik tetsontli",
  "block.minecraft.polished_blackstone": "Petstik poyaktetl",
  "block.minecraft.polished_blackstone_brick_slab": "Petstik poyaktekalxamixitstapalli",
  "block.minecraft.polished_blackstone_brick_stairs": "Petstik poyaktekalxamixtlehkōlli",
  "block.minecraft.polished_blackstone_brick_wall": "Petstik poyaktekalxamixtepantli",
  "block.minecraft.polished_blackstone_bricks": "Petstik poyaktekalxamixtli",
  "block.minecraft.polished_blackstone_button": "Petstik poyaktewoton",
  "block.minecraft.polished_blackstone_pressure_plate": "Petstik poyaktetlakomaltektli",
  "block.minecraft.polished_blackstone_slab": "Petstik poyakteitstapalli",
  "block.minecraft.polished_blackstone_stairs": "Petstik poyaktetlehkōlli",
  "block.minecraft.polished_blackstone_wall": "Petstik poyaktetepantli",
  "block.minecraft.polished_deepslate": "Petstik koyowatetl",
  "block.minecraft.polished_deepslate_slab": "Petstik koyowateitstapalli",
  "block.minecraft.polished_deepslate_stairs": "Petstik koyowatetlehkōlli",
  "block.minecraft.polished_deepslate_wall": "Petstik koyowatetepantli",
  "block.minecraft.polished_diorite": "Petstik tlīltepaktli",
  "block.minecraft.polished_diorite_slab": "Petstik tlīltepakitstapalli",
  "block.minecraft.polished_diorite_stairs": "Petstik tlīltepaktlehkōlli",
  "block.minecraft.polished_granite": "Petstik tepaktli",
  "block.minecraft.polished_granite_slab": "Petstik tepakitstapalli",
  "block.minecraft.polished_granite_stairs": "Petstik tepaktlehkōlli",
  "block.minecraft.polished_tuff": "Petstik tobah",
  "block.minecraft.polished_tuff_slab": "Petstik tobahitstapalli",
  "block.minecraft.polished_tuff_stairs": "Petstik tobahtlehkōlli",
  "block.minecraft.polished_tuff_wall": "Petstik tobahtepantli",
  "block.minecraft.poppy": "Amapotl",
  "block.minecraft.potatoes": "Tlakwaltetl",
  "block.minecraft.potted_acacia_sapling": "Masetah īka akasiahchamānkētl",
  "block.minecraft.potted_allium": "Masetah īka āxoxxōchitl",
  "block.minecraft.potted_azalea_bush": "Masetah īka asaleah",
  "block.minecraft.potted_azure_bluet": "Masetah īka istāltik xōchitl",
  "block.minecraft.potted_bamboo": "Masetah īka chīmalākatl",
  "block.minecraft.potted_birch_sapling": "Masetah īka aitichamānkētl",
  "block.minecraft.potted_blue_orchid": "Masetah īka āsoltik akatsawihtli",
  "block.minecraft.potted_brown_mushroom": "Masetah īka kafēntik nanakatl",
  "block.minecraft.potted_cactus": "Masetah īka witsatsatli",
  "block.minecraft.potted_cherry_sapling": "Masetah īka kapolchamānkētl",
  "block.minecraft.potted_closed_eyeblossom": "Masetah īka ihkopki īxxōchitl",
  "block.minecraft.potted_cornflower": "Masetah īka asianoh",
  "block.minecraft.potted_crimson_fungus": "Masetah īka nelchīltik nanakatl",
  "block.minecraft.potted_crimson_roots": "Masetah īka nelchīltik nelwayōtl",
  "block.minecraft.potted_dandelion": "Masetah īka kwānakakilitl",
  "block.minecraft.potted_dark_oak_sapling": "Masetah īka yāyaktik āwachamānkētl",
  "block.minecraft.potted_dead_bush": "Masetah īka wākki kwawtōntli",
  "block.minecraft.potted_fern": "Masetah īka okopetlatl",
  "block.minecraft.potted_flowering_azalea_bush": "Masetah īka asaleah īka xōchitl",
  "block.minecraft.potted_golden_dandelion": "Masetah īka teōkwitlakōstik kwānakakilitl",
  "block.minecraft.potted_jungle_sapling": "Masetah īka āchipiko chamānkētl",
  "block.minecraft.potted_lily_of_the_valley": "Masetah īka ixtlawatsontekōnxōchitl",
  "block.minecraft.potted_mangrove_propagule": "Masetah īka āwihkolkwawpropaguloh",
  "block.minecraft.potted_oak_sapling": "Masetah īka āwachamānkētl",
  "block.minecraft.potted_open_eyeblossom": "Masetah īka kwepōnki īxxōchitl",
  "block.minecraft.potted_orange_tulip": "Masetah īka chīlkōstik tolipan",
  "block.minecraft.potted_oxeye_daisy": "Masetah īka koktelxōchitl",
  "block.minecraft.potted_pale_oak_sapling": "Masetah īka istāltik āwachamānkētl",
  "block.minecraft.potted_pink_tulip": "Masetah īka iselik tolipan",
  "block.minecraft.potted_poppy": "Masetah īka amapotl",
  "block.minecraft.potted_red_mushroom": "Masetah īka chīltik nanakatl",
  "block.minecraft.potted_red_tulip": "Masetah īka chīltik tolipan",
  "block.minecraft.potted_spruce_sapling": "Masetah īka okochamānkētl",
  "block.minecraft.potted_torchflower": "Masetah īka tlāwilikōxōchitl",
  "block.minecraft.potted_warped_fungus": "Masetah īka koltik nanakatl",
  "block.minecraft.potted_warped_roots": "Masetah īka koltik nelwayōtl",
  "block.minecraft.potted_white_tulip": "Masetah īka chipāwak tolipan",
  "block.minecraft.potted_wither_rose": "Masetah īka Wither-poyomatl",
  "block.minecraft.powder_snow": "Poteksepayawitl",
  "block.minecraft.powder_snow_cauldron": "Poteksepayawteposāpastli",
  "block.minecraft.powered_rail": "Teposohtli tlakwatopēwkētl",
  "block.minecraft.prismarine": "Prismarinah",
  "block.minecraft.prismarine_brick_slab": "Prismarinahkalxamixitstapalli",
  "block.minecraft.prismarine_brick_stairs": "Prismarinahkalxamixtlehkōlli",
  "block.minecraft.prismarine_bricks": "Prismarinahkalxamixtli",
  "block.minecraft.prismarine_slab": "Prismarinahitstapalli",
  "block.minecraft.prismarine_stairs": "Prismarinahtlehkōlli",
  "block.minecraft.prismarine_wall": "Prismarinahtepantli",
  "block.minecraft.pumpkin": "Ayohtli",
  "block.minecraft.pumpkin_stem": "Ayohkwayōtl",
  "block.minecraft.purple_banner": "Kamohtik kwachpāmitl",
  "block.minecraft.purple_bed": "Kamohtik tlapechtli",
  "block.minecraft.purple_candle": "Kamohtik kantēlah",
  "block.minecraft.purple_candle_cake": "Tlaoyotlaxkalli īka kamohtik kantēlah",
  "block.minecraft.purple_carpet": "Kamohtik tilmahpepechtōntli",
  "block.minecraft.purple_concrete": "Kamohtik tenextetl",
  "block.minecraft.purple_concrete_powder": "Kamohtik sementoh",
  "block.minecraft.purple_glazed_terracotta": "Kamohtik tlamahsiltetl",
  "block.minecraft.purple_shulker_box": "Kamohtik shulker-kāxah",
  "block.minecraft.purple_stained_glass": "Kamohtik tewilōtl",
  "block.minecraft.purple_stained_glass_pane": "Kamohtik tewilōpanel",
  "block.minecraft.purple_terracotta": "Kamohtik wiksika tlālkōstli",
  "block.minecraft.purple_wool": "Kamohtik tohmitl",
  "block.minecraft.purpur_block": "Purpur",
  "block.minecraft.purpur_pillar": "Purpurpilar",
  "block.minecraft.purpur_slab": "Purpuritstapalli",
  "block.minecraft.purpur_stairs": "Purpur-tlehkōlli",
  "block.minecraft.quartz_block": "Chawatexamixtli",
  "block.minecraft.quartz_bricks": "Chawatekalxamixtli",
  "block.minecraft.quartz_pillar": "Chawatepilar",
  "block.minecraft.quartz_slab": "Chawateitstapalli",
  "block.minecraft.quartz_stairs": "Chawatetlehkōlli",
  "block.minecraft.rail": "Teposohtli",
  "block.minecraft.raw_copper_block": "Xoxoktik amochixamixtli",
  "block.minecraft.raw_gold_block": "Xoxokteōkwitlaxamixtli",
  "block.minecraft.raw_iron_block": "Xoxoktik teposxamixtli",
  "block.minecraft.red_banner": "Chīltik kwachpāmitl",
  "block.minecraft.red_bed": "Chīltik tlapechtli",
  "block.minecraft.red_candle": "Chīltik kantēlah",
  "block.minecraft.red_candle_cake": "Tlaoyotlaxkalli īka chīltik kantēlah",
  "block.minecraft.red_carpet": "Chīltik tilmahpepechtōntli",
  "block.minecraft.red_concrete": "Chīltik tenextetl",
  "block.minecraft.red_concrete_powder": "Chīltik sementoh",
  "block.minecraft.red_glazed_terracotta": "Chīltik tlamahsiltetl",
  "block.minecraft.red_mushroom": "Chīltik nanakatl",
  "block.minecraft.red_mushroom_block": "Chīlnanakaxamixtli",
  "block.minecraft.red_nether_brick_slab": "Chīltik Nether kalxamixitstapalli",
  "block.minecraft.red_nether_brick_stairs": "Chīltik Nether kalxamixtlehkōlli",
  "block.minecraft.red_nether_brick_wall": "Chīltik Nether kalxamixtepantli",
  "block.minecraft.red_nether_bricks": "Chīltik Nether kalxamixtli",
  "block.minecraft.red_sand": "Chīltik xālli",
  "block.minecraft.red_sandstone": "Chīltik xāltetl",
  "block.minecraft.red_sandstone_slab": "Chīltik xālteitstapalli",
  "block.minecraft.red_sandstone_stairs": "Chīltik xāltetlehkōlli",
  "block.minecraft.red_sandstone_wall": "Chīltik xāltetepantli",
  "block.minecraft.red_shulker_box": "Chīltik shulker-kāxah",
  "block.minecraft.red_stained_glass": "Chīltik tewilōtl",
  "block.minecraft.red_stained_glass_pane": "Chīltik tewilōpanel",
  "block.minecraft.red_terracotta": "Chīltik wiksika tlālkōstli",
  "block.minecraft.red_tulip": "Chīltik tolipan",
  "block.minecraft.red_wool": "Chīltik tomitl",
  "block.minecraft.redstone_block": "Xamixtli tlen redstone",
  "block.minecraft.redstone_lamp": "Tlāwīlli",
  "block.minecraft.redstone_ore": "Redstone-ōstōkāyōtl",
  "block.minecraft.redstone_torch": "Redstone-tlāwilikōtl",
  "block.minecraft.redstone_wall_torch": "Redstone-tepantlāwilikōtl",
  "block.minecraft.redstone_wire": "Redstone-mekatl",
  "block.minecraft.reinforced_deepslate": "Chikāwak koyowatetl",
  "block.minecraft.repeater": "Redstone-tlasanpayanōkētl",
  "block.minecraft.repeating_command_block": "Tlasanpayanōlistlanawatilisxamixtli",
  "block.minecraft.resin_block": "Ohxixamixtli",
  "block.minecraft.resin_brick_slab": "Ohxikalxamixitstapalli",
  "block.minecraft.resin_brick_stairs": "Ohxikalxamixtlehkōlli",
  "block.minecraft.resin_brick_wall": "Ohxikalxamixtepantli",
  "block.minecraft.resin_bricks": "Ohxikalxamixtli",
  "block.minecraft.resin_clump": "Ohxitl",
  "block.minecraft.respawn_anchor": "Tēnēxtihkētl",
  "block.minecraft.rooted_dirt": "Tlālli īka nelwayōtl",
  "block.minecraft.rose_bush": "Rosahtlan",
  "block.minecraft.sand": "Xālli",
  "block.minecraft.sandstone": "Xāltetl",
  "block.minecraft.sandstone_slab": "Xālteitstapalli",
  "block.minecraft.sandstone_stairs": "Xāltetlehkōlli",
  "block.minecraft.sandstone_wall": "Xāltetepantli",
  "block.minecraft.scaffolding": "Kwawtlapechtli",
  "block.minecraft.sculk": "Sculk",
  "block.minecraft.sculk_catalyst": "Sculk-katalisarohkētl",
  "block.minecraft.sculk_sensor": "Sculk-tlamachilihkētl",
  "block.minecraft.sculk_shrieker": "Sculk-tlachikwihkētl",
  "block.minecraft.sculk_vein": "Sculk-ēwkayōtl",
  "block.minecraft.sea_lantern": "Wēyākāntīl",
  "block.minecraft.sea_pickle": "Wēyāyoxoxowkatl",
  "block.minecraft.seagrass": "Wēyāsakatl",
  "block.minecraft.set_spawn": "Kitlālih tēnēxtilōyān",
  "block.minecraft.short_dry_grass": "Echkapantsin wākki sakatl",
  "block.minecraft.short_grass": "Echkapantsin sakatl",
  "block.minecraft.shroomlight": "Tlāwīlnanakatl",
  "block.minecraft.shulker_box": "Shulker-kāxah",
  "block.minecraft.skeleton_skull": "Āpīsmikkētl īkwāomiyo",
  "block.minecraft.skeleton_wall_skull": "Āpīsmikkētl īkwāomiyo īpan tepantli",
  "block.minecraft.slime_block": "Yakakwitlaxamixtli",
  "block.minecraft.small_amethyst_bud": "Kwekwētstsin ayohpāltewilōkīsalistli",
  "block.minecraft.small_dripleaf": "Kwekwētstsin chipīnxiwitl",
  "block.minecraft.smithing_table": "Teposolisahkopechtli",
  "block.minecraft.smoker": "Tlapochektilihkētl",
  "block.minecraft.smooth_basalt": "Alaxtik tetsontli",
  "block.minecraft.smooth_quartz": "Alaxtik chawatexamixtli",
  "block.minecraft.smooth_quartz_slab": "Alaxtik chawateitstapalli",
  "block.minecraft.smooth_quartz_stairs": "Alaxtik chawatetlehkōlli",
  "block.minecraft.smooth_red_sandstone": "Alaxtik chīltik xāltetl",
  "block.minecraft.smooth_red_sandstone_slab": "Alaxtik chīltik xālteitstapalli",
  "block.minecraft.smooth_red_sandstone_stairs": "Alaxtik chīltik xāltetlehkōlli",
  "block.minecraft.smooth_sandstone": "Alaxtik xāltetl",
  "block.minecraft.smooth_sandstone_slab": "Alaxtik xālteitstapalli",
  "block.minecraft.smooth_sandstone_stairs": "Alaxtik xāltetlehkōlli",
  "block.minecraft.smooth_stone": "Alaxtik tetl",
  "block.minecraft.smooth_stone_slab": "Alaxtik itstapalli",
  "block.minecraft.sniffer_egg": "Tlahnewkkātetl",
  "block.minecraft.snow": "Sepayawitl",
  "block.minecraft.snow_block": "Sepayawxamixtli",
  "block.minecraft.soul_campfire": "Tōnaltlikwitl",
  "block.minecraft.soul_fire": "Tōnaltlitl",
  "block.minecraft.soul_lantern": "Tōnalokōkallōtl",
  "block.minecraft.soul_sand": "Tōnalxālli",
  "block.minecraft.soul_soil": "Tōnaltlālli",
  "block.minecraft.soul_torch": "Tōnaltlāwilikōtl",
  "block.minecraft.soul_wall_torch": "Tōnaltepantlāwilikōtl",
  "block.minecraft.spawn.not_valid": "Axtikpiya sē tlapechtli so axtsontik motēnēxtihkāw, so motsakwilih",
  "block.minecraft.spawner": "Tsitsiminēxtihkētl",
  "block.minecraft.spawner.desc1": "Xiktekiwi sē tlanēxtihkētl:",
  "block.minecraft.spawner.desc2": "Kitlālia tlamantli yōlkatl",
  "block.minecraft.sponge": "Esponhah",
  "block.minecraft.spore_blossom": "Esporahxōchitl",
  "block.minecraft.spruce_button": "Okoboton",
  "block.minecraft.spruce_door": "Okokaltēntli",
  "block.minecraft.spruce_fence": "Okochināmitl",
  "block.minecraft.spruce_fence_gate": "Okochināntēntli",
  "block.minecraft.spruce_hanging_sign": "Okokwatlahkwilōlli wiyōnkētl",
  "block.minecraft.spruce_leaves": "Okoxiwiyōtl",
  "block.minecraft.spruce_log": "Okokwatomaktli",
  "block.minecraft.spruce_planks": "Okowapalli",
  "block.minecraft.spruce_pressure_plate": "Okotlakomaltektli",
  "block.minecraft.spruce_sapling": "Okochamānkētl",
  "block.minecraft.spruce_shelf": "Okoākōmitl",
  "block.minecraft.spruce_sign": "Okokwatlahkwilōlli",
  "block.minecraft.spruce_slab": "Okoitstapalli",
  "block.minecraft.spruce_stairs": "Okotlehkōlli",
  "block.minecraft.spruce_trapdoor": "Okotlaketstēntli",
  "block.minecraft.spruce_wall_hanging_sign": "Okotepankwatlahkwilōlli wiyōnkētl",
  "block.minecraft.spruce_wall_sign": "Okotepankwatlahkwilōlli",
  "block.minecraft.spruce_wood": "Okokwawitl",
  "block.minecraft.sticky_piston": "Tsasaltik piston",
  "block.minecraft.stone": "Tetl",
  "block.minecraft.stone_brick_slab": "Tekalxamixitstapalli",
  "block.minecraft.stone_brick_stairs": "Tekalxamixtlehkōlli",
  "block.minecraft.stone_brick_wall": "Tekalxamixtepantli",
  "block.minecraft.stone_bricks": "Tekalxamixtli",
  "block.minecraft.stone_button": "Teboton",
  "block.minecraft.stone_pressure_plate": "Tetlakomaltektli",
  "block.minecraft.stone_slab": "Itstapalli",
  "block.minecraft.stone_stairs": "Tetlehkōlli",
  "block.minecraft.stonecutter": "Tetehtekkētl",
  "block.minecraft.stripped_acacia_log": "Akasiahkwatomaktli ahtle īkakawayo",
  "block.minecraft.stripped_acacia_wood": "Akasiahkwawitl ahtle īkakawayo",
  "block.minecraft.stripped_bamboo_block": "Chīmalākaxamixtli ahtle īkakawayo",
  "block.minecraft.stripped_birch_log": "Aitikwatomaktli ahtle īkakawayo",
  "block.minecraft.stripped_birch_wood": "Aitikwawitl ahtle īkakawayo",
  "block.minecraft.stripped_cherry_log": "Kapolkwatomaktli ahtle īkakawayo",
  "block.minecraft.stripped_cherry_wood": "Kapolkwawitl ahtle īkakawayo",
  "block.minecraft.stripped_crimson_hyphae": "Nelchīltik ifah ahtle īkakawayo",
  "block.minecraft.stripped_crimson_stem": "Nelchīltik kwayōtl ahtle īkakawayo",
  "block.minecraft.stripped_dark_oak_log": "Yāyaktik āwakwatomaktli ahtle īkakawayo",
  "block.minecraft.stripped_dark_oak_wood": "Yāyaktik āwakwawitl ahtle īkakawayo",
  "block.minecraft.stripped_jungle_log": "Āchipiko kwatomaktli ahtle īkakawayo",
  "block.minecraft.stripped_jungle_wood": "Āchipiko kwawitl ahtle īkakawayo",
  "block.minecraft.stripped_mangrove_log": "Āwihkolkwawkwatomaktli ahtle īkakawayo",
  "block.minecraft.stripped_mangrove_wood": "Āwihkolkwawitl ahtle īkakawayo",
  "block.minecraft.stripped_oak_log": "Āwakwatomaktli ahtle īkakawayo",
  "block.minecraft.stripped_oak_wood": "Āwakwawitl ahtle īkakawayo",
  "block.minecraft.stripped_pale_oak_log": "Istāltik āwakwatomaktli ahtle īkakawayo",
  "block.minecraft.stripped_pale_oak_wood": "Istāltik āwakwawitl ahtle īkakawayo",
  "block.minecraft.stripped_spruce_log": "Okokwatomaktli ahtle īkakawayo",
  "block.minecraft.stripped_spruce_wood": "Okokwawitl ahtle īkakawayo",
  "block.minecraft.stripped_warped_hyphae": "Koltik ifah ahtle īkakawayo",
  "block.minecraft.stripped_warped_stem": "Koltik kwayōtl ahtle īkakawayo",
  "block.minecraft.structure_block": "Tlakwaltlālīloh xamixtli",
  "block.minecraft.structure_void": "Tlakwaltlālīloh ihtikakawatikāyōtl",
  "block.minecraft.sugar_cane": "Owatl",
  "block.minecraft.sunflower": "Chīmalxōchitl",
  "block.minecraft.suspicious_gravel": "Kehnipatik sīltetl",
  "block.minecraft.suspicious_sand": "Kehnipatik xālli",
  "block.minecraft.sweet_berry_bush": "Āmakapolkwawtōntli",
  "block.minecraft.tall_dry_grass": "Wahkapāntik wākki sakatl",
  "block.minecraft.tall_grass": "Wahkapāntik sakatl",
  "block.minecraft.tall_seagrass": "Wahkapāntik wēyāsakatl",
  "block.minecraft.target": "Ophetiboh",
  "block.minecraft.terracotta": "Wiksika tlālkōstli",
  "block.minecraft.test_block": "Tlayehyēkolisxamixtli",
  "block.minecraft.test_instance_block": "Tlayehyēkolisnēxtīlxamixtli",
  "block.minecraft.tinted_glass": "Tlatlīlwilli tewilōtl",
  "block.minecraft.tnt": "Tinamitah",
  "block.minecraft.tnt.disabled": "Motlahyōwīltih dinamitahtlikwepōnilistli",
  "block.minecraft.torch": "Tlāwilikōtl",
  "block.minecraft.torchflower": "Tlāwilikōxōchitl",
  "block.minecraft.torchflower_crop": "Tlāwilikōxōchiēlīltilistli",
  "block.minecraft.trapped_chest": "Tlaketskwapetlakalli",
  "block.minecraft.trial_spawner": "Ōwihkāyōnēxtihkētl",
  "block.minecraft.tripwire": "Tlapēwalīloh",
  "block.minecraft.tripwire_hook": "Īlohganchoh",
  "block.minecraft.tube_coral": "Ākatlatektapachtli",
  "block.minecraft.tube_coral_block": "Ākatlatektapachxamixtli",
  "block.minecraft.tube_coral_fan": "Ākatlatektapachgorgoniah",
  "block.minecraft.tube_coral_wall_fan": "Ākatlatektapachtepangorgoniah",
  "block.minecraft.tuff": "Tobah",
  "block.minecraft.tuff_brick_slab": "Tobahkalxamixitstapalli",
  "block.minecraft.tuff_brick_stairs": "Tobahkalxamixtlehkōlli",
  "block.minecraft.tuff_brick_wall": "Tobahkalxamixtepantli",
  "block.minecraft.tuff_bricks": "Tobahkalxamixtinih",
  "block.minecraft.tuff_slab": "Tobahitstapalli",
  "block.minecraft.tuff_stairs": "Tobahtlehkōlli",
  "block.minecraft.tuff_wall": "Tobahtepantli",
  "block.minecraft.turtle_egg": "Āyōtetl",
  "block.minecraft.twisting_vines": "Ilakatstik mekatl",
  "block.minecraft.twisting_vines_plant": "Ilakatstik mekaxiwitl",
  "block.minecraft.vault": "Tekwapetlakalli",
  "block.minecraft.verdant_froglight": "Xoxoktik pechpechtlāwīlli",
  "block.minecraft.vine": "Mekatl",
  "block.minecraft.void_air": "Tsopīlōtlakwalko īehēkaw",
  "block.minecraft.wall_torch": "Tepantlāwilikōtl",
  "block.minecraft.warped_button": "Koltik boton",
  "block.minecraft.warped_door": "Koltik kaltēntli",
  "block.minecraft.warped_fence": "Koltik chināmitl",
  "block.minecraft.warped_fence_gate": "Koltik chināntēntli",
  "block.minecraft.warped_fungus": "Koltik nanakatl",
  "block.minecraft.warped_hanging_sign": "Koltik kwatlahkwilōlli wiyōnkētl",
  "block.minecraft.warped_hyphae": "Koltik ifah",
  "block.minecraft.warped_nylium": "Koltik nilioh",
  "block.minecraft.warped_planks": "Koltik wapalli",
  "block.minecraft.warped_pressure_plate": "Koltik tlakomaltektli",
  "block.minecraft.warped_roots": "Koltik nelwayōtl",
  "block.minecraft.warped_shelf": "Koltik ākōmitl",
  "block.minecraft.warped_sign": "Koltik kwatlahkwilōlli",
  "block.minecraft.warped_slab": "Koltik itstapalli",
  "block.minecraft.warped_stairs": "Koltik tlehkōlli",
  "block.minecraft.warped_stem": "Koltik kwayōtl",
  "block.minecraft.warped_trapdoor": "Koltik tlaketstēntli",
  "block.minecraft.warped_wall_hanging_sign": "Koltik tepankwatlahkwilōlli wiyōnkētl",
  "block.minecraft.warped_wall_sign": "Koltik tepankwatlahkwilōlli",
  "block.minecraft.warped_wart_block": "Koltik tsotsikaxiwxamixtli",
  "block.minecraft.water": "Ātl",
  "block.minecraft.water_cauldron": "Teposāpastli īka ātl",
  "block.minecraft.waxed_chiseled_copper": "Tlaxikokwitlawīlli tlamāchihchīwalli amochitl",
  "block.minecraft.waxed_copper_bars": "Tlaxikokwitlawīlli amochiwitsōktli",
  "block.minecraft.waxed_copper_block": "Tlaxikokwitlawīlli amochixamixtli",
  "block.minecraft.waxed_copper_bulb": "Tlaxikokwitlawīlli amochitlāwīlli",
  "block.minecraft.waxed_copper_chain": "Tlaxikokwitlawīlli amochimekatl",
  "block.minecraft.waxed_copper_chest": "Tlaxikokwitlawīlli amochipetlakalli",
  "block.minecraft.waxed_copper_door": "Tlaxikokwitlawīlli amochikaltēntli",
  "block.minecraft.waxed_copper_golem_statue": "Tlaxikokwitlawīlli amochigolemkwakwilli",
  "block.minecraft.waxed_copper_grate": "Tlaxikokwitlawīlli amochirehiyah",
  "block.minecraft.waxed_copper_lantern": "Tlaxikokwitlawīlli amochikāntīl",
  "block.minecraft.waxed_copper_trapdoor": "Tlaxikokwitlawīlli amochitlaketstēntli",
  "block.minecraft.waxed_cut_copper": "Tlaxikokwitlawīlli tehtekki amochitl",
  "block.minecraft.waxed_cut_copper_slab": "Tlaxikokwitlawīlli tehtekki amochiitstapalli",
  "block.minecraft.waxed_cut_copper_stairs": "Tlaxikokwitlawīlli tehtekki amochitlehkōlli",
  "block.minecraft.waxed_exposed_chiseled_copper": "Tlaxikokwitlawīlli tlatōnaltlālilli tlamāchihchīwalli amochitl",
  "block.minecraft.waxed_exposed_copper": "Tlaxikokwitlawīlli tlatōnaltlālilli amochitl",
  "block.minecraft.waxed_exposed_copper_bars": "Tlaxikokwitlawīlli tlatōnaltlālilli amochiwitsōktli",
  "block.minecraft.waxed_exposed_copper_bulb": "Tlaxikokwitlawīlli tlatōnaltlālilli amochitlāwīlli",
  "block.minecraft.waxed_exposed_copper_chain": "Tlaxikokwitlawīlli tlatōnaltlālilli amochimekatl",
  "block.minecraft.waxed_exposed_copper_chest": "Tlaxikokwitlawīlli tlatōnaltlālilli amochipetlakalli",
  "block.minecraft.waxed_exposed_copper_door": "Tlaxikokwitlawīlli tlatōnaltlālilli amochikaltēntli",
  "block.minecraft.waxed_exposed_copper_golem_statue": "Tlaxikokwitlawīlli tlatōnaltlālilli amochigolemkwakwilli",
  "block.minecraft.waxed_exposed_copper_grate": "Tlaxikokwitlawīlli tlatōnaltlālilli amochirehiyah",
  "block.minecraft.waxed_exposed_copper_lantern": "Tlaxikokwitlawīlli tlatōnaltlālilli amochikāntīl",
  "block.minecraft.waxed_exposed_copper_trapdoor": "Tlaxikokwitlawīlli tlatōnaltlālilli amochitlaketstēntli",
  "block.minecraft.waxed_exposed_cut_copper": "Tlaxikokwitlawīlli tlatōnaltlālilli tehtekki amochitl",
  "block.minecraft.waxed_exposed_cut_copper_slab": "Tlaxikokwitlawīlli tlatōnaltlālilli tehtekki amochiitstapalli",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "Tlaxikokwitlawīlli tlatōnaltlālilli tehtekki amochitlehkōlli",
  "block.minecraft.waxed_exposed_lightning_rod": "Tlaxikokwitlawīlli tlatōnaltlālilli tlimekaketskētl",
  "block.minecraft.waxed_lightning_rod": "Tlaxikokwitlawīlli tlimekaketskētl",
  "block.minecraft.waxed_oxidized_chiseled_copper": "Tlaxikokwitlawīlli xawalōk tlamāchihchīwalli amochitl",
  "block.minecraft.waxed_oxidized_copper": "Tlaxikokwitlawīlli xawalōk amochitl",
  "block.minecraft.waxed_oxidized_copper_bars": "Tlaxikokwitlawīlli xawalōk amochiwitsōktli",
  "block.minecraft.waxed_oxidized_copper_bulb": "Tlaxikokwitlawīlli xawalōk amochitlāwīlli",
  "block.minecraft.waxed_oxidized_copper_chain": "Tlaxikokwitlawīlli xawalōk amochimekatl",
  "block.minecraft.waxed_oxidized_copper_chest": "Tlaxikokwitlawīlli xawalōk amochipetlakalli",
  "block.minecraft.waxed_oxidized_copper_door": "Tlaxikokwitlawīlli xawalōk amochikaltēntli",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "Tlaxikokwitlawīlli xawalōk amochigolemkwakwilli",
  "block.minecraft.waxed_oxidized_copper_grate": "Tlaxikokwitlawīlli xawalōk amochirehiyah",
  "block.minecraft.waxed_oxidized_copper_lantern": "Tlaxikokwitlawīlli xawalōk amochikāntīl",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "Tlaxikokwitlawīlli xawalōk amochitlaketstēntli",
  "block.minecraft.waxed_oxidized_cut_copper": "Tlaxikokwitlāltīlli xawalōk tehtekki amochitl",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "Tlaxikokwitlawīlli xawalōk tehtekki amochiitstapalli",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "Tlaxikokwitlawīlli xawalōk tehtekki amochitlehkōlli",
  "block.minecraft.waxed_oxidized_lightning_rod": "Tlaxikokwitlawīlli xawalōk tlimekaketskētl",
  "block.minecraft.waxed_weathered_chiseled_copper": "Tlaxikokwitlawīlli sosoltik tlamāchihchīwalli amochitl",
  "block.minecraft.waxed_weathered_copper": "Tlaxikokwitlawīlli sosoltik amochitl",
  "block.minecraft.waxed_weathered_copper_bars": "Tlaxikokwitlawīlli sosoltik amochiwitsōktli",
  "block.minecraft.waxed_weathered_copper_bulb": "Tlaxikokwitlawīlli sosoltik amochitlāwīlli",
  "block.minecraft.waxed_weathered_copper_chain": "Tlaxikokwitlawīlli sosoltik amochimekatl",
  "block.minecraft.waxed_weathered_copper_chest": "Tlaxikokwitlawīlli sosoltik amochipetlakalli",
  "block.minecraft.waxed_weathered_copper_door": "Tlaxikokwitlawīlli sosoltik amochikaltēntli",
  "block.minecraft.waxed_weathered_copper_golem_statue": "Tlaxikokwitlawīlli sosoltik amochigolemkwakwilli",
  "block.minecraft.waxed_weathered_copper_grate": "Tlaxikokwitlawīlli sosoltik amochirehiyah",
  "block.minecraft.waxed_weathered_copper_lantern": "Tlaxikokwitlawīlli sosoltik amochikāntīl",
  "block.minecraft.waxed_weathered_copper_trapdoor": "Tlaxikokwitlawīlli sosoltik amochitlaketstēntli",
  "block.minecraft.waxed_weathered_cut_copper": "Tlaxikokwitlawīlli sosoltik tehtekki amochitl",
  "block.minecraft.waxed_weathered_cut_copper_slab": "Tlaxikokwitlawīlli sosoltik tehtekki amochiitstapalli",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "Tlaxikokwitlawīlli sosoltik tehtekki amochitlehkōlli",
  "block.minecraft.waxed_weathered_lightning_rod": "Tlaxikokwitlawīlli sosoltik tlimekaketskētl",
  "block.minecraft.weathered_chiseled_copper": "Sosoltik tlamāchihchīwalli amochitl",
  "block.minecraft.weathered_copper": "Sosoltik amochitl",
  "block.minecraft.weathered_copper_bars": "Sosoltik amochiwitsōktli",
  "block.minecraft.weathered_copper_bulb": "Sosoltik amochitlāwīlli",
  "block.minecraft.weathered_copper_chain": "Sosoltik amochimekatl",
  "block.minecraft.weathered_copper_chest": "Sosoltik amochipetlakalli",
  "block.minecraft.weathered_copper_door": "Sosoltik amochikaltēntli",
  "block.minecraft.weathered_copper_golem_statue": "Sosoltik amochigolemkwakwilli",
  "block.minecraft.weathered_copper_grate": "Sosoltik amochirehiyah",
  "block.minecraft.weathered_copper_lantern": "Sosoltik amochikāntīl",
  "block.minecraft.weathered_copper_trapdoor": "Sosoltik amochitlaketstēntli",
  "block.minecraft.weathered_cut_copper": "Sosoltik tehtekki amochitl",
  "block.minecraft.weathered_cut_copper_slab": "Sosoltik tehtekki amochiitstapalli",
  "block.minecraft.weathered_cut_copper_stairs": "Sosoltik tehtekki amochitlehkōlli",
  "block.minecraft.weathered_lightning_rod": "Sosoltik tlimekaketskētl",
  "block.minecraft.weeping_vines": "Mekatl chōkani",
  "block.minecraft.weeping_vines_plant": "Mekaxiwitl chōkani",
  "block.minecraft.wet_sponge": "Ātēkilli tlatesowilistli",
  "block.minecraft.wheat": "Kaxlan tlayōlēlīltilistli",
  "block.minecraft.white_banner": "Chipāwak kwachpāmitl",
  "block.minecraft.white_bed": "Chipāwak tlapechtli",
  "block.minecraft.white_candle": "Chipāwak kantēlah",
  "block.minecraft.white_candle_cake": "Tlaoyotlaxkalli īka chipāwak kantēlah",
  "block.minecraft.white_carpet": "Chipāwak tilmahpepechtōntli",
  "block.minecraft.white_concrete": "Chipāwak tenextetl",
  "block.minecraft.white_concrete_powder": "Chipāwak sementoh",
  "block.minecraft.white_glazed_terracotta": "Chipāwak tlamahsiltetl",
  "block.minecraft.white_shulker_box": "Chipāwak shulker-kāxah",
  "block.minecraft.white_stained_glass": "Chipāwak tewilōtl",
  "block.minecraft.white_stained_glass_pane": "Chipāwak tewilōpanel",
  "block.minecraft.white_terracotta": "Chipāwak wiksika tlālkōstli",
  "block.minecraft.white_tulip": "Chipāwak tolipan",
  "block.minecraft.white_wool": "Chipāwak tomitl",
  "block.minecraft.wildflowers": "Kwatitlan xōchitl",
  "block.minecraft.wither_rose": "Wither īrosah",
  "block.minecraft.wither_skeleton_skull": "Wither īkwāomiyo",
  "block.minecraft.wither_skeleton_wall_skull": "Wither īkwāomiyo īpan tepantli",
  "block.minecraft.yellow_banner": "Kōstik kwachpāmitl",
  "block.minecraft.yellow_bed": "Kōstik tlapechtli",
  "block.minecraft.yellow_candle": "Kōstik kantēlah",
  "block.minecraft.yellow_candle_cake": "Tlaoyotlaxkalli īka kōstik kantēlah",
  "block.minecraft.yellow_carpet": "Kōstik tilmahpepechtōntli",
  "block.minecraft.yellow_concrete": "Kōstik tenextetl",
  "block.minecraft.yellow_concrete_powder": "Kōstik sementoh",
  "block.minecraft.yellow_glazed_terracotta": "Kōstik tlamahsiltetl",
  "block.minecraft.yellow_shulker_box": "Kōstik shulker-kāxah",
  "block.minecraft.yellow_stained_glass": "Kōstik tewilōtl",
  "block.minecraft.yellow_stained_glass_pane": "Kōstik tewilōpanel",
  "block.minecraft.yellow_terracotta": "Kōstik wiksika tlālkōstli",
  "block.minecraft.yellow_wool": "Kōstik tomitl",
  "block.minecraft.zombie_head": "Kokoxki ītsontekōn",
  "block.minecraft.zombie_wall_head": "Kokoxki ītsontekōn īpan tepantli",
  "item.minecraft.acacia_boat": "Akasiahākalli",
  "item.minecraft.acacia_chest_boat": "Akasiahākalli īka kwapetlakalli",
  "item.minecraft.allay_spawn_egg": "Tēpalēwihkānēxtihkētl",
  "item.minecraft.amethyst_shard": "Ayohpāltewilōachiyōtl",
  "item.minecraft.angler_pottery_shard": "Michitskihkāxālxiwtapalkaachiyōtl",
  "item.minecraft.angler_pottery_sherd": "Michitskihkātapalkaachiyōtl",
  "item.minecraft.apple": "Mantsanatl",
  "item.minecraft.archer_pottery_shard": "Tlamīnkāxālxiwtapalkaachiyōtl",
  "item.minecraft.archer_pottery_sherd": "Tlamīnkātapalkaachiyōtl",
  "item.minecraft.armadillo_scute": "Āyōtōchtotominyōtl",
  "item.minecraft.armadillo_spawn_egg": "Āyōtōchnēxtihkētl",
  "item.minecraft.armor_stand": "Yāōwīpīlmanikih",
  "item.minecraft.arms_up_pottery_shard": "Siloetahxālxiwtapalkaachiyōtl",
  "item.minecraft.arms_up_pottery_sherd": "Siloetahtapalkaachiyōtl",
  "item.minecraft.arrow": "Mītl",
  "item.minecraft.axolotl_bucket": "Kobetah īka āxōlōtl",
  "item.minecraft.axolotl_spawn_egg": "Āxōlōnēxtihkētl",
  "item.minecraft.baked_potato": "Wiksika tlakwaltetl",
  "item.minecraft.bamboo_chest_raft": "Chīmalākapechtli īka kwapetlakalli",
  "item.minecraft.bamboo_raft": "Chīmalākapechtli",
  "item.minecraft.bat_spawn_egg": "Tsotsonēxtihkētl",
  "item.minecraft.bee_spawn_egg": "Newktsinnēxtihkētl",
  "item.minecraft.beef": "Xoxoktik kwākwawehnakatl",
  "item.minecraft.beetroot": "Remolachah",
  "item.minecraft.beetroot_seeds": "Remolachahkwayōllōtinih",
  "item.minecraft.beetroot_soup": "Remolachahāyōtl",
  "item.minecraft.birch_boat": "Aitiākalli",
  "item.minecraft.birch_chest_boat": "Aitiākalli īka kwapetlakalli",
  "item.minecraft.black_bundle": "Yāyāwik fōlsah",
  "item.minecraft.black_dye": "Yāyāwik tlapālōni",
  "item.minecraft.black_harness": "Yāyāwik kechkwayohtli",
  "item.minecraft.blade_pottery_shard": "Teposmākwawxālxiwtapalkaachiyōtl",
  "item.minecraft.blade_pottery_sherd": "Teposmākwawtapalkaachiyōtl",
  "item.minecraft.blaze_powder": "Tliwahpotektli",
  "item.minecraft.blaze_rod": "Tliwahkwawitl",
  "item.minecraft.blaze_spawn_egg": "Tliwahnēxtihkētl",
  "item.minecraft.blue_bundle": "Āsoltik fōlsah",
  "item.minecraft.blue_dye": "Āsoltik tlapālōni",
  "item.minecraft.blue_egg": "Xoxōwik tēksistli",
  "item.minecraft.blue_harness": "Āsoltik kechkwayohtli",
  "item.minecraft.bogged_spawn_egg": "Āchawitēkanēxtihkētl",
  "item.minecraft.bolt_armor_trim_smithing_template": "Teposolisplantiyah",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "Tlimekaornamentoh",
  "item.minecraft.bone": "Omitl",
  "item.minecraft.bone_meal": "Omimōlli",
  "item.minecraft.book": "Āmoxtli",
  "item.minecraft.bordure_indented_banner_pattern": "Tsitsikiltik tēnyōkwachpāminēxtilissōtl",
  "item.minecraft.bow": "Tlahwītōlli",
  "item.minecraft.bowl": "Kwawkaxitl",
  "item.minecraft.bread": "Pān",
  "item.minecraft.breeze_rod": "Ehēkawahkwawitl",
  "item.minecraft.breeze_spawn_egg": "Ehēkawahnēxtihkētl",
  "item.minecraft.brewer_pottery_shard": "Posionxālxiwtapalkaachiyōtl",
  "item.minecraft.brewer_pottery_sherd": "Posiontapalkaachiyōtl",
  "item.minecraft.brewing_stand": "Tlatsehtselohkētl",
  "item.minecraft.brick": "Xamixtli",
  "item.minecraft.brown_bundle": "Kafēntik fōlsah",
  "item.minecraft.brown_dye": "Kafēntik tlapālōni",
  "item.minecraft.brown_egg": "Kafēntik tēksistli",
  "item.minecraft.brown_harness": "Kafēntik kechkwayohtli",
  "item.minecraft.brush": "Xilwāstli",
  "item.minecraft.bucket": "Kobetah",
  "item.minecraft.bundle": "Fōlsah",
  "item.minecraft.bundle.empty": "Ihtikakawatik",
  "item.minecraft.bundle.empty.description": "Weli kipiya sē tlapīwilli tlanechikolli tlen tlamantli",
  "item.minecraft.bundle.full": "Tlatēmītilli",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "Tlixālxiwtapalkaachiyōtl",
  "item.minecraft.burn_pottery_sherd": "Tlitapalkaachiyōtl",
  "item.minecraft.camel_husk_spawn_egg": "Īxtsayānki trometariohnēxtihkētl",
  "item.minecraft.camel_spawn_egg": "Ārabekameyohnēxtihkētl",
  "item.minecraft.carrot": "Xōchikamohtli",
  "item.minecraft.carrot_on_a_stick": "Koyolākatl īka xōchikamohtli",
  "item.minecraft.cat_spawn_egg": "Mistōnnēxtihkētl",
  "item.minecraft.cauldron": "Teposāpastli",
  "item.minecraft.cave_spider_spawn_egg": "Ōstōktokanēxtihkētl",
  "item.minecraft.chainmail_boots": "Teposmātlatekaktli",
  "item.minecraft.chainmail_chestplate": "Teposmātlakakallōtl",
  "item.minecraft.chainmail_helmet": "Teposmātlakwākalahtli",
  "item.minecraft.chainmail_leggings": "Kwetlaxpantalon",
  "item.minecraft.charcoal": "Kwawtlīlli",
  "item.minecraft.cherry_boat": "Kapolkwawākalli",
  "item.minecraft.cherry_chest_boat": "Kapilwawākalli īka kwapetlakalli",
  "item.minecraft.chest_minecart": "Bagonetah īka kwapetlakalli",
  "item.minecraft.chicken": "Xoxoktik piyōnakatl",
  "item.minecraft.chicken_spawn_egg": "Piyōnēxtihkētl",
  "item.minecraft.chorus_fruit": "Chorosxōchitlakwalli",
  "item.minecraft.clay_ball": "Tepaololli",
  "item.minecraft.clock": "Relōk",
  "item.minecraft.coal": "Tlīlli",
  "item.minecraft.coast_armor_trim_smithing_template": "Teposolisplantiyah",
  "item.minecraft.coast_armor_trim_smithing_template.new": "Ilwikaātēnornamentoh",
  "item.minecraft.cocoa_beans": "Kakawāchtli",
  "item.minecraft.cod": "Xoxoktik kōsmichnakatl",
  "item.minecraft.cod_bucket": "Kobetah īka kōsmichin",
  "item.minecraft.cod_spawn_egg": "Kōsmichnēxtihkētl",
  "item.minecraft.command_block_minecart": "Bagonetah īka tlanawatilisxamixtli",
  "item.minecraft.compass": "Tepostlayōllōānālōni",
  "item.minecraft.cooked_beef": "Tlatsoyōnilli nakatl",
  "item.minecraft.cooked_chicken": "Ikosik piyōnakatl",
  "item.minecraft.cooked_cod": "Ikosik kōsmichin",
  "item.minecraft.cooked_mutton": "Ikosik ichkanakatl",
  "item.minecraft.cooked_porkchop": "Ikosik pitsonakatl",
  "item.minecraft.cooked_rabbit": "Ikosik kwatōchnakatl",
  "item.minecraft.cooked_salmon": "Ikosik xōchimichin",
  "item.minecraft.cookie": "Pīlpāntsin",
  "item.minecraft.copper_axe": "Amochitlatekōni",
  "item.minecraft.copper_boots": "Amochitekaktli",
  "item.minecraft.copper_chestplate": "Amochikakallōtl",
  "item.minecraft.copper_golem_spawn_egg": "Amochigolemnēxtihkētl",
  "item.minecraft.copper_helmet": "Amochikwākalahtli",
  "item.minecraft.copper_hoe": "Amochiasadon",
  "item.minecraft.copper_horse_armor": "Amochiwīpīlli inik kawayoh",
  "item.minecraft.copper_ingot": "Amochilinkoteh",
  "item.minecraft.copper_leggings": "Amochipantalon",
  "item.minecraft.copper_nautilus_armor": "Amochiwīpīlli inik naotiloh",
  "item.minecraft.copper_nugget": "Amochipepitah",
  "item.minecraft.copper_pickaxe": "Amochitlāltepōskwapinmomolotsalli",
  "item.minecraft.copper_shovel": "Amochitlaakanōni",
  "item.minecraft.copper_spear": "Amochitōpīlli",
  "item.minecraft.copper_sword": "Amochimākwawitl",
  "item.minecraft.cow_spawn_egg": "Wākaxnēxtihkētl",
  "item.minecraft.creaking_spawn_egg": "Xaxamakakānēxtihkētl",
  "item.minecraft.creeper_banner_pattern": "Kwachpāminēxtilissōtl",
  "item.minecraft.creeper_banner_pattern.desc": "Creeper",
  "item.minecraft.creeper_banner_pattern.new": "Tlamāchihchīwalli tlen creeper",
  "item.minecraft.creeper_spawn_egg": "Creeper-nēxtihkētl",
  "item.minecraft.crossbow": "Tepostlahwītōlli",
  "item.minecraft.crossbow.projectile": "Teposmītl:",
  "item.minecraft.crossbow.projectile.multiple": "Teposmītl: %s x %s",
  "item.minecraft.crossbow.projectile.single": "Teposmītl: %s",
  "item.minecraft.cyan_bundle": "Xiwtik fōlsah",
  "item.minecraft.cyan_dye": "Xiwtik tlapālōni",
  "item.minecraft.cyan_harness": "Xiwtik kechkwayohtli",
  "item.minecraft.danger_pottery_shard": "Tēmahmawtihkāyōxālxiwtapalkaachiyōtl",
  "item.minecraft.danger_pottery_sherd": "Tēmahmawtihkāyōtapalkaachiyōtl",
  "item.minecraft.dark_oak_boat": "Yāyaktik āwaākalli",
  "item.minecraft.dark_oak_chest_boat": "Yāyaktik āwaākalli īka kwapetlakalli",
  "item.minecraft.debug_stick": "Tlapohpōwaliskwawitl",
  "item.minecraft.debug_stick.empty": "%s axkipiya āxkāitl",
  "item.minecraft.debug_stick.select": "kitlapehpenih \"%s\" (%s)",
  "item.minecraft.debug_stick.update": "\"%s\" mopatlak īka %s",
  "item.minecraft.diamond": "Tlakwawak tekpatl",
  "item.minecraft.diamond_axe": "Tlakwawak tekpatlatekōni",
  "item.minecraft.diamond_boots": "Tlakwawak tekpatekaktli",
  "item.minecraft.diamond_chestplate": "Tlakwawak tekpakakallōtl",
  "item.minecraft.diamond_helmet": "Tlakwawak tekpakwākalahtli",
  "item.minecraft.diamond_hoe": "Tlakwawak tekpaasadon",
  "item.minecraft.diamond_horse_armor": "Tlakwawak tekpawīpīlli Inik kawayoh",
  "item.minecraft.diamond_leggings": "Tlakwawak tekpapantalon",
  "item.minecraft.diamond_nautilus_armor": "Tlakwawak tekpawīpīlli inik naotiloh",
  "item.minecraft.diamond_pickaxe": "Tlakwawak tekpatlālteposkwapinmomolotsalli",
  "item.minecraft.diamond_shovel": "Tlakwawak tekpatlaakanōni",
  "item.minecraft.diamond_spear": "Tlakwawak tekpatōpīlli",
  "item.minecraft.diamond_sword": "Tlakwawak tekpamākkwawitl",
  "item.minecraft.disc_fragment_5": "Dīskohachiyōtl",
  "item.minecraft.disc_fragment_5.desc": "Dīskoh: 5",
  "item.minecraft.dolphin_spawn_egg": "Chichimichnēxtihkētl",
  "item.minecraft.donkey_spawn_egg": "Pōlokohnēxtihkētl",
  "item.minecraft.dragon_breath": "Ketsalkwetspalkamaihyōtl",
  "item.minecraft.dried_kelp": "Wākki ākwawtōntli",
  "item.minecraft.drowned_spawn_egg": "Āpilohkānēxtihkētl",
  "item.minecraft.dune_armor_trim_smithing_template": "Teposolisplantiyah",
  "item.minecraft.dune_armor_trim_smithing_template.new": "Donahornamentoh",
  "item.minecraft.echo_shard": "Achiyōtl tsilīnkētl",
  "item.minecraft.egg": "Piyōtēksistli",
  "item.minecraft.elder_guardian_spawn_egg": "Wēwēhtlapīxkānēxtihkētl",
  "item.minecraft.elytra": "End ēltlapalli",
  "item.minecraft.emerald": "Chalchiwitl",
  "item.minecraft.enchanted_book": "Tlaxōchiwilli āmoxtli",
  "item.minecraft.enchanted_golden_apple": "Tlaxōchiwilli teōkwitlamantsanatl",
  "item.minecraft.end_crystal": "End tewilōtl",
  "item.minecraft.ender_dragon_spawn_egg": "Ketsalkwetspalnēxtihkētl",
  "item.minecraft.ender_eye": "End īxtiyōl",
  "item.minecraft.ender_pearl": "Ender wītsitsilyepyōllohtli",
  "item.minecraft.enderman_spawn_egg": "Endermannēxtihkētl",
  "item.minecraft.endermite_spawn_egg": "Endermite-nēxtihkētl",
  "item.minecraft.evoker_spawn_egg": "Tlatlātlawtihkānēxtihkētl",
  "item.minecraft.experience_bottle": "Lemeteh īka yōltlamantli",
  "item.minecraft.explorer_pottery_shard": "Ohtokakāxālxiwtapalkaachiyōtl",
  "item.minecraft.explorer_pottery_sherd": "Ohtokakātapalkaachiyōtl",
  "item.minecraft.eye_armor_trim_smithing_template": "Teposolisplantiyah",
  "item.minecraft.eye_armor_trim_smithing_template.new": "Īxtiyōlornamentoh",
  "item.minecraft.feather": "Iwitl",
  "item.minecraft.fermented_spider_eye": "Oktik tokaīxtiyōlli",
  "item.minecraft.field_masoned_banner_pattern": "Kalxamixxōtlamāchihchīwalli",
  "item.minecraft.filled_map": "Tlālīxnēskāyōtl",
  "item.minecraft.fire_charge": "Tlinechikolistli",
  "item.minecraft.firework_rocket": "Kohetesahkomahkāwkētl",
  "item.minecraft.firework_rocket.flight": "Patlāniliswahkāwalistli:",
  "item.minecraft.firework_rocket.multiple_stars": "%s x %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "Kohetestlikikistlālli",
  "item.minecraft.firework_star.black": "Yāyāwik",
  "item.minecraft.firework_star.blue": "Āsoltik",
  "item.minecraft.firework_star.brown": "Kafēntik",
  "item.minecraft.firework_star.custom_color": "Tlayankwīkachihchīwalli",
  "item.minecraft.firework_star.cyan": "Xiwtik",
  "item.minecraft.firework_star.fade_to": "Mochīwa",
  "item.minecraft.firework_star.flicker": "Popoyoka",
  "item.minecraft.firework_star.gray": "Tenextik",
  "item.minecraft.firework_star.green": "Xoxoktik",
  "item.minecraft.firework_star.light_blue": "Tsiktik",
  "item.minecraft.firework_star.light_gray": "Ātenextik",
  "item.minecraft.firework_star.lime": "Xoxōwik",
  "item.minecraft.firework_star.magenta": "Ayohpāltik",
  "item.minecraft.firework_star.orange": "Chīlkōstik",
  "item.minecraft.firework_star.pink": "Iselik",
  "item.minecraft.firework_star.purple": "Kamohtik",
  "item.minecraft.firework_star.red": "Chīltik",
  "item.minecraft.firework_star.shape": "Axtlaīxmatilli iwkāyōtl",
  "item.minecraft.firework_star.shape.burst": "Tlikwepōnilistli",
  "item.minecraft.firework_star.shape.creeper": "Kēnwak creeper",
  "item.minecraft.firework_star.shape.large_ball": "Wēyi ololli",
  "item.minecraft.firework_star.shape.small_ball": "Kwekwētstsin ololli",
  "item.minecraft.firework_star.shape.star": "Kēnwak sītlalin",
  "item.minecraft.firework_star.trail": "Tlatlanekwilistli",
  "item.minecraft.firework_star.white": "Chipāwak",
  "item.minecraft.firework_star.yellow": "Kōstik",
  "item.minecraft.fishing_rod": "Āchihkōlwāstli",
  "item.minecraft.flint": "Tekpatl",
  "item.minecraft.flint_and_steel": "Tlanāmiktihkētl",
  "item.minecraft.flow_armor_trim_smithing_template": "Teposolisplantiyah",
  "item.minecraft.flow_armor_trim_smithing_template.new": "Āyōornamentoh",
  "item.minecraft.flow_banner_pattern": "Kwachpāmitlamāchihchīwalli",
  "item.minecraft.flow_banner_pattern.desc": "Āyōtl",
  "item.minecraft.flow_banner_pattern.new": "Āyōtlamāchichīwalli",
  "item.minecraft.flow_pottery_sherd": "Āyōtapalkaachiyōtl",
  "item.minecraft.flower_banner_pattern": "Kwachpāmitlamāchihchīwalli",
  "item.minecraft.flower_banner_pattern.desc": "Xōchitl",
  "item.minecraft.flower_banner_pattern.new": "Xōchitlamāchihchīwalli",
  "item.minecraft.flower_pot": "Masetah",
  "item.minecraft.fox_spawn_egg": "Ōstōnēxtihkētl",
  "item.minecraft.friend_pottery_shard": "Wānpohxālxiwtapalkaachiyōtl",
  "item.minecraft.friend_pottery_sherd": "Wānpohtapalkaachiyōtl",
  "item.minecraft.frog_spawn_egg": "Pechpechnēxtihkētl",
  "item.minecraft.furnace_minecart": "Bagonetah īka ornoh",
  "item.minecraft.ghast_spawn_egg": "Ghast-nēxtihkētl",
  "item.minecraft.ghast_tear": "Ghast-īxāyōtl",
  "item.minecraft.glass_bottle": "Lemeteh",
  "item.minecraft.glistering_melon_slice": "Tlāwīlsantiahyayamatsalistli",
  "item.minecraft.globe_banner_pattern": "Kwachpāmitlamāchihchīwalli",
  "item.minecraft.globe_banner_pattern.desc": "Ilwikatlayōlli",
  "item.minecraft.globe_banner_pattern.new": "Ilwikatlayōltlamāchihchīwalli",
  "item.minecraft.glow_berries": "Tlāwīlāmakapolin",
  "item.minecraft.glow_ink_sac": "Tlāwīltlīltlamāmālxikipilli",
  "item.minecraft.glow_item_frame": "Tlāwīlmarkoh",
  "item.minecraft.glow_squid_spawn_egg": "Tāwīlwēyātokanēxtihkētl",
  "item.minecraft.glowstone_dust": "Tlāwīltepotektli",
  "item.minecraft.goat_horn": "Chitokwākwawitl",
  "item.minecraft.goat_spawn_egg": "Chitonēxtihkētl",
  "item.minecraft.gold_ingot": "Tiōkwitlalinkoteh",
  "item.minecraft.gold_nugget": "Tiōkwitlapepitah",
  "item.minecraft.golden_apple": "Tiōkwitlamantsanatl",
  "item.minecraft.golden_axe": "Tiōkwitlatlatekōni",
  "item.minecraft.golden_boots": "Tiōkwitlatekaktli",
  "item.minecraft.golden_carrot": "Tiōkwitlatik xōchikamohtli",
  "item.minecraft.golden_chestplate": "Tiōkwitlakakallōtl",
  "item.minecraft.golden_helmet": "Tiōkwitlakwākalahtli",
  "item.minecraft.golden_hoe": "Teōkwitlaasadon",
  "item.minecraft.golden_horse_armor": "Tiōkwitlawīpīlli inik kawayoh",
  "item.minecraft.golden_leggings": "Tiōkwitlapantalon",
  "item.minecraft.golden_nautilus_armor": "Teōkwitlawīpīlli inik naotiloh",
  "item.minecraft.golden_pickaxe": "Tiōkwitlatlāltepōskwapinmomolotsalli",
  "item.minecraft.golden_shovel": "Tiōkwitlatlaakanōni",
  "item.minecraft.golden_spear": "Teōkwitlatōpīlli",
  "item.minecraft.golden_sword": "Tiōkwitlamākkwawitl",
  "item.minecraft.gray_bundle": "Tenextik fōlsah",
  "item.minecraft.gray_dye": "Tenextik tlapālōni",
  "item.minecraft.gray_harness": "Tenextik kechkwayohtli",
  "item.minecraft.green_bundle": "Xoxoktik fōlsah",
  "item.minecraft.green_dye": "Xoxoktik tlapālōni",
  "item.minecraft.green_harness": "Xoxoktik kechkwayohtli",
  "item.minecraft.guardian_spawn_egg": "Tlapīxkānēxtihkētl",
  "item.minecraft.gunpowder": "Pōlforah",
  "item.minecraft.guster_banner_pattern": "Kwachpāmitlamāchihchīwalli",
  "item.minecraft.guster_banner_pattern.desc": "Ehēkalistli",
  "item.minecraft.guster_banner_pattern.new": "Ehēkalistlamāchihchīwalli",
  "item.minecraft.guster_pottery_sherd": "Ehēkalistapalkaachiyōtl",
  "item.minecraft.happy_ghast_spawn_egg": "Pākki ghast-nēxtihkētl",
  "item.minecraft.harness": "Kechkwayohtli",
  "item.minecraft.heart_of_the_sea": "Wēyātl īyōllo",
  "item.minecraft.heart_pottery_shard": "Yōllōxālxiwtapalkaachiyōtl",
  "item.minecraft.heart_pottery_sherd": "Yōllōtapalkaachiyōtl",
  "item.minecraft.heartbreak_pottery_shard": "Tlapānyōllōxālxiwtapalkaachiyōtl",
  "item.minecraft.heartbreak_pottery_sherd": "Tlapānyōllōtapalkaachiyōtl",
  "item.minecraft.hoglin_spawn_egg": "Hoglinnēxtihkētl",
  "item.minecraft.honey_bottle": "Lemeteh īka newktli",
  "item.minecraft.honeycomb": "Pānalli",
  "item.minecraft.hopper_minecart": "Bagonetah īka tolbah",
  "item.minecraft.horse_spawn_egg": "Kawāyohnēxtihkētl",
  "item.minecraft.host_armor_trim_smithing_template": "Teposolisplantiyah",
  "item.minecraft.host_armor_trim_smithing_template.new": "Tēnōtskāornamentoh",
  "item.minecraft.howl_pottery_shard": "Kwayōchōkalisxālxiwtapalkaachiyōtl",
  "item.minecraft.howl_pottery_sherd": "Kwayōchōkalistapalkaachiyōtl",
  "item.minecraft.husk_spawn_egg": "Īxtsayānkānēxtihkētl",
  "item.minecraft.ink_sac": "Tlīlxikipilli",
  "item.minecraft.iron_axe": "Tepostlatekōni",
  "item.minecraft.iron_boots": "Tepostekaktli",
  "item.minecraft.iron_chestplate": "Teposkakallōtl",
  "item.minecraft.iron_golem_spawn_egg": "Teposgolemnēxtihkētl",
  "item.minecraft.iron_helmet": "Teposkwākalahtli",
  "item.minecraft.iron_hoe": "Asadon",
  "item.minecraft.iron_horse_armor": "Teposwīpīlli inik kawayoh",
  "item.minecraft.iron_ingot": "Teposlinkoteh",
  "item.minecraft.iron_leggings": "Tepospantalon",
  "item.minecraft.iron_nautilus_armor": "Teposwīpīlli inik naotiloh",
  "item.minecraft.iron_nugget": "Tepospepitah",
  "item.minecraft.iron_pickaxe": "Tlālteposkwapinmomolotsalli",
  "item.minecraft.iron_shovel": "Tepostlaakanōni",
  "item.minecraft.iron_spear": "Tepostōpīlli",
  "item.minecraft.iron_sword": "Teposmākkwawitl",
  "item.minecraft.item_frame": "Markoh",
  "item.minecraft.jungle_boat": "Āchipiko ākalli",
  "item.minecraft.jungle_chest_boat": "Āchipiko ākalli īka kwapetlakalli",
  "item.minecraft.knowledge_book": "Sēntlamatilisāmoxtli",
  "item.minecraft.lapis_lazuli": "Lapislasolih",
  "item.minecraft.lava_bucket": "Kobetah īka pōposōnilli",
  "item.minecraft.lead": "Mekatl",
  "item.minecraft.leather": "Kwetlaxtli",
  "item.minecraft.leather_boots": "Kwetlaxtekaktli",
  "item.minecraft.leather_chestplate": "Kwetlaxxāyohtli",
  "item.minecraft.leather_helmet": "Kwetlaxkwātsawkkētl",
  "item.minecraft.leather_horse_armor": "Kwetlaxwīpīlli inik kawayoh",
  "item.minecraft.leather_leggings": "Kwetlaxpantalon",
  "item.minecraft.light_blue_bundle": "Tsiktik fōlsah",
  "item.minecraft.light_blue_dye": "Tsiktik tlapālōni",
  "item.minecraft.light_blue_harness": "Tsiktik kechkwayohtli",
  "item.minecraft.light_gray_bundle": "Ātenextik fōlsah",
  "item.minecraft.light_gray_dye": "Ātenextik tlapālōni",
  "item.minecraft.light_gray_harness": "Ātenextik kechkwayohtli",
  "item.minecraft.lime_bundle": "Xoxōwik fōlsah",
  "item.minecraft.lime_dye": "Xoxōwik tlapālōni",
  "item.minecraft.lime_harness": "Xoxōwik kechkwayohtli",
  "item.minecraft.lingering_potion": "Pahtli tlapanowilihkētl",
  "item.minecraft.lingering_potion.effect.awkward": "Kehnipatik pahtli tlapanowilihkētl",
  "item.minecraft.lingering_potion.effect.empty": "Pahtli tlapanowilihkētl axchihchīwalōni",
  "item.minecraft.lingering_potion.effect.fire_resistance": "Tlitlatlaxoktlalisposion tlapanowilihkētl",
  "item.minecraft.lingering_potion.effect.harming": "Pahtli tlapanowilihkētl tlen tlakokolistli",
  "item.minecraft.lingering_potion.effect.healing": "Pahtli tlapanowilihkētl tlen kwaltilistli",
  "item.minecraft.lingering_potion.effect.infested": "Pahtli tlapanowilihkētl tlen chipohyohkāyōtl",
  "item.minecraft.lingering_potion.effect.invisibility": "Pahtli tlapanowilihkētl tlen axtlachiyalissōtl",
  "item.minecraft.lingering_potion.effect.leaping": "Pahtli tlapanowilihkētl tlen witōnilistli",
  "item.minecraft.lingering_potion.effect.levitation": "Pahtli tlapanowilihkētl tlen patlānilistli",
  "item.minecraft.lingering_potion.effect.luck": "Pahtli tlapanowilihkētl tlen tōnalli",
  "item.minecraft.lingering_potion.effect.mundane": "Axkwaltsin pahtli tlapanowilihkētl",
  "item.minecraft.lingering_potion.effect.night_vision": "Pahtli tlapanowilihkētl tlen yowaltlachiyalistli",
  "item.minecraft.lingering_potion.effect.oozing": "Pahtli tlapanowilihkētl tlen yakakwitlayōtl",
  "item.minecraft.lingering_potion.effect.poison": "Pahtli tlapanowilihkētl",
  "item.minecraft.lingering_potion.effect.regeneration": "Pahtli tlapanowilihkētl tlen tlapahtilistli",
  "item.minecraft.lingering_potion.effect.slow_falling": "Pahtli tlapanowilihkētl tlen yōlik wetsilistli",
  "item.minecraft.lingering_potion.effect.slowness": "Pahtli tlapanowilihkētl tlen yōlikāyōtl",
  "item.minecraft.lingering_potion.effect.strength": "Pahtli tlapanowilihkētl tlen chikāwakāyōtl",
  "item.minecraft.lingering_potion.effect.swiftness": "Pahtli tlapanowilihkētl tlen isiwkakāyōtl",
  "item.minecraft.lingering_potion.effect.thick": "Ātōltik pahtli tlapanowilihkētl",
  "item.minecraft.lingering_potion.effect.turtle_master": "Pahtli tlapanowilihkētl tlen Tlamachtihkētl Āyōtl",
  "item.minecraft.lingering_potion.effect.water": "Lemeteh īka ātl tlapanowilihkētl",
  "item.minecraft.lingering_potion.effect.water_breathing": "Pahtli tlapanowilihkētl tlen āmihyōkwilistli",
  "item.minecraft.lingering_potion.effect.weakness": "Pahtli tlapanowilihkētl tlen axchikāwakāyōtl",
  "item.minecraft.lingering_potion.effect.weaving": "Pahtli tlapanowilihkētl tlen tlatsāwalistli",
  "item.minecraft.lingering_potion.effect.wind_charged": "Pahtli tlapanowilihkētl tlen ehēkalistli",
  "item.minecraft.llama_spawn_egg": "Pelōnichkanēxtihkētl",
  "item.minecraft.lodestone_compass": "Maknetitahyoh tepostlayōllōānālōni",
  "item.minecraft.mace": "Kwawololli",
  "item.minecraft.magenta_bundle": "Ayohpāltik fōlsah",
  "item.minecraft.magenta_dye": "Ayohpāltik tlapālōni",
  "item.minecraft.magenta_harness": "Ayohpāltik kechkwayohtli",
  "item.minecraft.magma_cream": "Tliyakakwitlatl",
  "item.minecraft.magma_cube_spawn_egg": "Tliyakakwitlehnēxtihkētl",
  "item.minecraft.mangrove_boat": "Āwihkolkwawākalli",
  "item.minecraft.mangrove_chest_boat": "Āwihkolkwawākalli īka kwapetlakalli",
  "item.minecraft.map": "Ihtikakawatik tlālīxnēskāyōtl",
  "item.minecraft.melon_seeds": "Santiahkwayōllōtl",
  "item.minecraft.melon_slice": "Santiahyayamatsalistli",
  "item.minecraft.milk_bucket": "Kobetah īka lechih",
  "item.minecraft.minecart": "Bagonetah",
  "item.minecraft.miner_pottery_shard": "Teposkīxtihkāxālxiwtapalkaachiyōtl",
  "item.minecraft.miner_pottery_sherd": "Teposkīxtihkātapalkaachiyōtl",
  "item.minecraft.mojang_banner_pattern": "Kwachpāmitlamāchihchīwalli",
  "item.minecraft.mojang_banner_pattern.desc": "Tlamantli",
  "item.minecraft.mojang_banner_pattern.new": "Tlamantlamāchihchīwalli",
  "item.minecraft.mooshroom_spawn_egg": "Mooshroom-nēxtihkētl",
  "item.minecraft.mourner_pottery_shard": "Mokokohkāxālxiwtapalkaachiyōtl",
  "item.minecraft.mourner_pottery_sherd": "Mokokohkātapalkaachiyōtl",
  "item.minecraft.mule_spawn_egg": "Molanēxtihkētl",
  "item.minecraft.mushroom_stew": "Nanakamōlli",
  "item.minecraft.music_disc_11": "Dīskoh",
  "item.minecraft.music_disc_11.desc": "C418 - 11",
  "item.minecraft.music_disc_13": "Dīskoh",
  "item.minecraft.music_disc_13.desc": "C418 - 13",
  "item.minecraft.music_disc_5": "Dīskoh",
  "item.minecraft.music_disc_5.desc": "Samuel Åberg: 5",
  "item.minecraft.music_disc_blocks": "Dīskoh",
  "item.minecraft.music_disc_blocks.desc": "C418 - blocks",
  "item.minecraft.music_disc_cat": "Dīskoh",
  "item.minecraft.music_disc_cat.desc": "C418 - cat",
  "item.minecraft.music_disc_chirp": "Dīskoh",
  "item.minecraft.music_disc_chirp.desc": "C418 - chirp",
  "item.minecraft.music_disc_creator": "Dīskoh",
  "item.minecraft.music_disc_creator.desc": "Lena Raine - Creator",
  "item.minecraft.music_disc_creator_music_box": "Dīskoh",
  "item.minecraft.music_disc_creator_music_box.desc": "Lena Raine - Creator (Music Box)",
  "item.minecraft.music_disc_far": "Dīskoh",
  "item.minecraft.music_disc_far.desc": "C418 - far",
  "item.minecraft.music_disc_lava_chicken": "Dīskoh",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions - Lava Chicken",
  "item.minecraft.music_disc_mall": "Dīskoh",
  "item.minecraft.music_disc_mall.desc": "C418 - mall",
  "item.minecraft.music_disc_mellohi": "Dīskoh",
  "item.minecraft.music_disc_mellohi.desc": "C418 - mellohi",
  "item.minecraft.music_disc_otherside": "Dīskoh",
  "item.minecraft.music_disc_otherside.desc": "Lena Raine - otherside",
  "item.minecraft.music_disc_pigstep": "Dīskoh",
  "item.minecraft.music_disc_pigstep.desc": "Lena Raine - Pigstep",
  "item.minecraft.music_disc_precipice": "Dīskoh",
  "item.minecraft.music_disc_precipice.desc": "Aaron Cherof - Precipice",
  "item.minecraft.music_disc_relic": "Dīskoh",
  "item.minecraft.music_disc_relic.desc": "Aaron Cherof - Relic",
  "item.minecraft.music_disc_stal": "Dīskoh",
  "item.minecraft.music_disc_stal.desc": "C418 - stal",
  "item.minecraft.music_disc_strad": "Dīskoh",
  "item.minecraft.music_disc_strad.desc": "C418 - strad",
  "item.minecraft.music_disc_tears": "Dīskoh",
  "item.minecraft.music_disc_tears.desc": "Amos Roddy - Tears",
  "item.minecraft.music_disc_wait": "Dīskoh",
  "item.minecraft.music_disc_wait.desc": "C418 - wait",
  "item.minecraft.music_disc_ward": "Dīskoh",
  "item.minecraft.music_disc_ward.desc": "C418 - ward",
  "item.minecraft.mutton": "Xoxoktik ichkanakatl",
  "item.minecraft.name_tag": "Pīlmachiyōtsin",
  "item.minecraft.nautilus_shell": "Naotilohkakallōtl",
  "item.minecraft.nautilus_spawn_egg": "Naotilohnēxtihkētl",
  "item.minecraft.nether_brick": "Nether kalxamixtli",
  "item.minecraft.nether_star": "Nether sītlalin",
  "item.minecraft.nether_wart": "Nether tsokaxiwitl",
  "item.minecraft.netherite_axe": "Nethertetlatekōni",
  "item.minecraft.netherite_boots": "Nethertetekaktli",
  "item.minecraft.netherite_chestplate": "Nethertekakallōtl",
  "item.minecraft.netherite_helmet": "Nethertekwākalahtli",
  "item.minecraft.netherite_hoe": "Netherteasadon",
  "item.minecraft.netherite_horse_armor": "Neteritahwīpīlli inik kawayoh",
  "item.minecraft.netherite_ingot": "Nethertelinkoteh",
  "item.minecraft.netherite_leggings": "Nethertepantalon",
  "item.minecraft.netherite_nautilus_armor": "Nethertewīpīlli inik naotiloh",
  "item.minecraft.netherite_pickaxe": "Nethertetlālteposkwapinmomolotsalli",
  "item.minecraft.netherite_scrap": "Netherteahachiyōtl",
  "item.minecraft.netherite_shovel": "Nethertetlaakanōni",
  "item.minecraft.netherite_spear": "Nethertetōpīlli",
  "item.minecraft.netherite_sword": "Nethertemākkwawitl",
  "item.minecraft.netherite_upgrade_smithing_template": "Teposolisplantiyah",
  "item.minecraft.netherite_upgrade_smithing_template.new": "Nethertetlaīxkwalchīwalistli",
  "item.minecraft.oak_boat": "Āwaākalli",
  "item.minecraft.oak_chest_boat": "Āwaākalli īka kwapetlakalli",
  "item.minecraft.ocelot_spawn_egg": "Tlālōsēlōnēxtihkētl",
  "item.minecraft.ominous_bottle": "Axkwalli lemeteh",
  "item.minecraft.ominous_trial_key": "Axkwalli owihkāyōtlatlapōlli",
  "item.minecraft.orange_bundle": "Chīlkōstik fōlsah",
  "item.minecraft.orange_dye": "Chīlkōstik tlapālōni",
  "item.minecraft.orange_harness": "Chīlkōstik kechkwayohtli",
  "item.minecraft.painting": "Tlapāllōtl",
  "item.minecraft.pale_oak_boat": "Istāltik āwaākalli",
  "item.minecraft.pale_oak_chest_boat": "Istāltik āwaākalli īka kwapetlakalli",
  "item.minecraft.panda_spawn_egg": "Chīnahtlākamāyehnēxtihkētl",
  "item.minecraft.paper": "Āmatl",
  "item.minecraft.parched_spawn_egg": "Tlakaliwkānēxtihkētl",
  "item.minecraft.parrot_spawn_egg": "Kochonēxtihkētl",
  "item.minecraft.phantom_membrane": "Wēyitsotsokwātexkimiliwkāyōtl",
  "item.minecraft.phantom_spawn_egg": "Wēyitsotsonēxtihkētl",
  "item.minecraft.pig_spawn_egg": "Pitsonēxtihkētl",
  "item.minecraft.piglin_banner_pattern": "Kwachpāmitlamāchihchīwalli",
  "item.minecraft.piglin_banner_pattern.desc": "Piglinkamaktli",
  "item.minecraft.piglin_banner_pattern.new": "Piglinkamaktlamāchihchīwalli",
  "item.minecraft.piglin_brute_spawn_egg": "Tēmawmawtih piglinnēxtihkētl",
  "item.minecraft.piglin_spawn_egg": "Piglinnēxtihkētl",
  "item.minecraft.pillager_spawn_egg": "Koyōnēxtihkētl",
  "item.minecraft.pink_bundle": "Iselik fōlsah",
  "item.minecraft.pink_dye": "Iselik tlapālōni",
  "item.minecraft.pink_harness": "Iselik kechkwayohtli",
  "item.minecraft.pitcher_plant": "Kōnxiwitl",
  "item.minecraft.pitcher_pod": "Kōnxiwiespigah",
  "item.minecraft.plenty_pottery_shard": "Tlasēnkīsalisxālxiwtapalkaachiyōtl",
  "item.minecraft.plenty_pottery_sherd": "Tlasēnkīsalistapalkaachiyōtl",
  "item.minecraft.poisonous_potato": "Pahyoh tlakwaltetl",
  "item.minecraft.polar_bear_spawn_egg": "Ātlākamāyehnēxtihkētl",
  "item.minecraft.popped_chorus_fruit": "Tlatsoyōnilli chorosxōchikwalli",
  "item.minecraft.porkchop": "Xoxoktik pitsonakatl",
  "item.minecraft.potato": "Tlakwaltetl",
  "item.minecraft.potion": "Pahtli",
  "item.minecraft.potion.effect.awkward": "Kehnipatik pahtli",
  "item.minecraft.potion.effect.empty": "Pahtli axchihchīwalōni",
  "item.minecraft.potion.effect.fire_resistance": "Pahtli tlen tliihyōwilistli",
  "item.minecraft.potion.effect.harming": "Pahtli tlen tlakokolistli",
  "item.minecraft.potion.effect.healing": "Pahtli tlen kwaltilistli",
  "item.minecraft.potion.effect.infested": "Pahtli tlen chipohyohkāyōtl",
  "item.minecraft.potion.effect.invisibility": "Pahtli tlen axtlachiyalissōtl",
  "item.minecraft.potion.effect.leaping": "Pahtli tlen witōnilistli",
  "item.minecraft.potion.effect.levitation": "Pahtli tlen patlānilistli",
  "item.minecraft.potion.effect.luck": "Pahtli tlen tōnalli",
  "item.minecraft.potion.effect.mundane": "Axkwaltsin pahtli",
  "item.minecraft.potion.effect.night_vision": "Pahtli tlen yowaltlachiyalistli",
  "item.minecraft.potion.effect.oozing": "Pahtli tlen yakakwitlayōtl",
  "item.minecraft.potion.effect.poison": "Pahtli",
  "item.minecraft.potion.effect.regeneration": "Pahtli tlen tlapahtilistli",
  "item.minecraft.potion.effect.slow_falling": "Pahtli tlen yōlik wetsilistli",
  "item.minecraft.potion.effect.slowness": "Pahtli tlen yōlikāyōtl",
  "item.minecraft.potion.effect.strength": "Pahtli tlen chikāwakāyōtl",
  "item.minecraft.potion.effect.swiftness": "Pahtli tlen isiwkakāyōtl",
  "item.minecraft.potion.effect.thick": "Ātōltik pahtli",
  "item.minecraft.potion.effect.turtle_master": "Pahtli tlen Tlamachtihkētl Āyōtl",
  "item.minecraft.potion.effect.water": "Lemeteh īka ātl",
  "item.minecraft.potion.effect.water_breathing": "Pahtli tlen āmihyōkwilistli",
  "item.minecraft.potion.effect.weakness": "Pahtli tlen axchikāwakāyōtl",
  "item.minecraft.potion.effect.weaving": "Pahtli tlen tlatsāwalistli",
  "item.minecraft.potion.effect.wind_charged": "Pahtli tlen ehēkalistli",
  "item.minecraft.pottery_shard_archer": "Tlamīnkāxālxiwtapalkaachiyōtl",
  "item.minecraft.pottery_shard_arms_up": "Siloetahxālxiwtapalkaachiyōtl",
  "item.minecraft.pottery_shard_prize": "Tlatlānilisxālxiwtapalkaachiyōtl",
  "item.minecraft.pottery_shard_skull": "Kwāomiyōxālxiwtapalkaachiyōtl",
  "item.minecraft.powder_snow_bucket": "Kobetah īka poteksepayawitl",
  "item.minecraft.prismarine_crystals": "Prismarinahtewilōtl",
  "item.minecraft.prismarine_shard": "Prismarinahachiyōtl",
  "item.minecraft.prize_pottery_shard": "Tiōkwitlatlatlālilxālxiwtapalkaachiyōtl",
  "item.minecraft.prize_pottery_sherd": "Tiōkwitlatlatlāliltapalkaachiyōtl",
  "item.minecraft.pufferfish": "Bōnbahmichin",
  "item.minecraft.pufferfish_bucket": "Kobetah īka bōnbahmichin",
  "item.minecraft.pufferfish_spawn_egg": "Bōnbahmichnēxtihkētl",
  "item.minecraft.pumpkin_pie": "Ayohtlaoyotlaxkalli",
  "item.minecraft.pumpkin_seeds": "Ayohkwayōllōtl",
  "item.minecraft.purple_bundle": "Kamohtik fōlsah",
  "item.minecraft.purple_dye": "Kamohtik tlapālōni",
  "item.minecraft.purple_harness": "Kamohtik kechkwayohtli",
  "item.minecraft.quartz": "Nether chawatetl",
  "item.minecraft.rabbit": "Xoxoktik kwatōchnakatl",
  "item.minecraft.rabbit_foot": "Kwatōchikxitl",
  "item.minecraft.rabbit_hide": "Kwatōchkwetlaxtli",
  "item.minecraft.rabbit_spawn_egg": "Kwatōchnēxtihkētl",
  "item.minecraft.rabbit_stew": "Kwatōchmōlli",
  "item.minecraft.raiser_armor_trim_smithing_template": "Teposolisplantiyah",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "Toktlasalisornamentoh",
  "item.minecraft.ravager_spawn_egg": "Tlapopolohkānēxtihkētl",
  "item.minecraft.raw_copper": "Xoxoktik amochitl",
  "item.minecraft.raw_gold": "Xoxoktik tiōkwitlatl",
  "item.minecraft.raw_iron": "Xoxoktik tepostli",
  "item.minecraft.recovery_compass": "Tlakwaltililistepostlayōllōānālōni",
  "item.minecraft.red_bundle": "Chīltik fōlsah",
  "item.minecraft.red_dye": "Chīltik tlapālōni",
  "item.minecraft.red_harness": "Chīltik kechkwayohtli",
  "item.minecraft.redstone": "Redstone-potektli",
  "item.minecraft.resin_brick": "Ohxikalxamixtli",
  "item.minecraft.resin_clump": "Ohxitl",
  "item.minecraft.rib_armor_trim_smithing_template": "Teposolisplantiyah",
  "item.minecraft.rib_armor_trim_smithing_template.new": "Ēlchikiwornamentoh",
  "item.minecraft.rotten_flesh": "Palaxtik nakatl",
  "item.minecraft.saddle": "Siyah",
  "item.minecraft.salmon": "Xoxoktik xōchimichnakatl",
  "item.minecraft.salmon_bucket": "Kobetah īka xōchimichin",
  "item.minecraft.salmon_spawn_egg": "Xōchimichnēxtihkētl",
  "item.minecraft.scrape_pottery_sherd": "Tlaxīmaltepostapalkaachiyōtl",
  "item.minecraft.scute": "Totominyōtl",
  "item.minecraft.sentry_armor_trim_smithing_template": "Teposolisplantiyah",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "Yāōtlachīxkāornamentoh",
  "item.minecraft.shaper_armor_trim_smithing_template": "Teposolisplantiyah",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "Tlahmatkāornamentoh",
  "item.minecraft.sheaf_pottery_shard": "Kaxtīllān tlayōlxālxiwtapalkaachiyōtl",
  "item.minecraft.sheaf_pottery_sherd": "Kaxtīllān tlayōltapalkaachiyōtl",
  "item.minecraft.shears": "Tiheras",
  "item.minecraft.sheep_spawn_egg": "Ichkanēxtihkētl",
  "item.minecraft.shelter_pottery_shard": "Kalxālxiwtapalkaachiyōtl",
  "item.minecraft.shelter_pottery_sherd": "Kaltapalkaachiyōtl",
  "item.minecraft.shield": "Chīmalli",
  "item.minecraft.shield.black": "Yāyāwik chīmalli",
  "item.minecraft.shield.blue": "Āsoltik chīmalli",
  "item.minecraft.shield.brown": "Kafēntik chīmalli",
  "item.minecraft.shield.cyan": "Xiwtik chīmalli",
  "item.minecraft.shield.gray": "Tenextik chīmalli",
  "item.minecraft.shield.green": "Xoxoktik chīmalli",
  "item.minecraft.shield.light_blue": "Tsiktik chīmalli",
  "item.minecraft.shield.light_gray": "Ātenextik chīmalli",
  "item.minecraft.shield.lime": "Xoxōwik chīmalli",
  "item.minecraft.shield.magenta": "Ayohpāltik chīmalli",
  "item.minecraft.shield.orange": "Chīlkōstik chīmalli",
  "item.minecraft.shield.pink": "Iselik chīmalli",
  "item.minecraft.shield.purple": "Kamohtik chīmalli",
  "item.minecraft.shield.red": "Chīltik chīmalli",
  "item.minecraft.shield.white": "Chipāwak chīmalli",
  "item.minecraft.shield.yellow": "Kōstik chīmalli",
  "item.minecraft.shulker_shell": "Shulker-kakallōtl",
  "item.minecraft.shulker_spawn_egg": "Shulker-nēxtihkētl",
  "item.minecraft.sign": "Kwatlahkwilōlli",
  "item.minecraft.silence_armor_trim_smithing_template": "Teposolisplantiyah",
  "item.minecraft.silence_armor_trim_smithing_template.new": "Tlatsitsikalisornamentoh",
  "item.minecraft.silverfish_spawn_egg": "Istāteōkwitlamichnēxtihkētl",
  "item.minecraft.skeleton_horse_spawn_egg": "Āpīsmikki kawayohnēxtihkētl",
  "item.minecraft.skeleton_spawn_egg": "Āpīsmikkānēxtihkētl",
  "item.minecraft.skull_banner_pattern": "Kwachpāmitlamāchihchīwalli",
  "item.minecraft.skull_banner_pattern.desc": "Kwāomiyōtl",
  "item.minecraft.skull_banner_pattern.new": "Kwāomiyōtlamāchihchīwalli",
  "item.minecraft.skull_pottery_shard": "Kwāomiyōxālxiwtapalkaachiyōtl",
  "item.minecraft.skull_pottery_sherd": "Kwāomiyōtapalkaachiyōtl",
  "item.minecraft.slime_ball": "Yakakwitlaololli",
  "item.minecraft.slime_spawn_egg": "Yakakwitlehnēxtihkētl",
  "item.minecraft.smithing_template": "Teposolisplantiyah",
  "item.minecraft.smithing_template.applies_to": "Mochīwāltilia:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "Xikpīwi linkoteh so tewilōtl",
  "item.minecraft.smithing_template.armor_trim.applies_to": "Yāōwīpīlli",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "Xikpīwi sē īachiyo yāōwīpīlli",
  "item.minecraft.smithing_template.armor_trim.ingredients": "Linkoteh īwān tewilōtl",
  "item.minecraft.smithing_template.ingredients": "Tlakwalchihchīwkētl:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "Xikpīwi nethertelinkoteh",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "Tlakwawak tekpatlatkitl",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "Xiktlāli sē yāōwīpīlli, tepostlatopōntli so tepostli tlachīwalli īka tlakwawak tekpatl",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "Nethertelinkoteh",
  "item.minecraft.smithing_template.upgrade": "Kiyankwilīs: ",
  "item.minecraft.sniffer_spawn_egg": "Tlahnewkkānēxtihkētl",
  "item.minecraft.snort_pottery_shard": "Tlahnewkkāxālxiwtapalkaachiyōtl",
  "item.minecraft.snort_pottery_sherd": "Tlahnewkkātapalkaachiyōtl",
  "item.minecraft.snout_armor_trim_smithing_template": "Teposolisplantiyah",
  "item.minecraft.snout_armor_trim_smithing_template.new": "Kamakornamentoh",
  "item.minecraft.snow_golem_spawn_egg": "Sepayawgolemnēxtihkētl",
  "item.minecraft.snowball": "Sepayawololli",
  "item.minecraft.spectral_arrow": "Neiyanelli mītl",
  "item.minecraft.spider_eye": "Tokaīxtiyōlli",
  "item.minecraft.spider_spawn_egg": "Tokanēxtihkētl",
  "item.minecraft.spire_armor_trim_smithing_template": "Teposolisplantiyah",
  "item.minecraft.spire_armor_trim_smithing_template.new": "Ākoxahornamentoh",
  "item.minecraft.splash_potion": "Pahtli ahkomahkāwalōni",
  "item.minecraft.splash_potion.effect.awkward": "Kehnipatik pahtli ahkomahkāwalōni",
  "item.minecraft.splash_potion.effect.empty": "Pahtli axchihchīwalōni ahkomahkāwalōni",
  "item.minecraft.splash_potion.effect.fire_resistance": "Pahtli ahkomahkāwalōni tlen tliihyōwilistli",
  "item.minecraft.splash_potion.effect.harming": "Pahtli ahkomahkāwalōni tlen tlakokolistli",
  "item.minecraft.splash_potion.effect.healing": "Pahtli ahkomahkāwalōni tlen kwaltilistli",
  "item.minecraft.splash_potion.effect.infested": "Pahtli ahkomahkāwalōni tlen chipohyohkāyōtl",
  "item.minecraft.splash_potion.effect.invisibility": "Pahtli ahkomahkāwalōni tlen axtlachiyalissōtl",
  "item.minecraft.splash_potion.effect.leaping": "Pahtli ahkomahkāwalōni tlen witōnilistli",
  "item.minecraft.splash_potion.effect.levitation": "Pahtli ahkomahkāwalōni tlen patlānilistli",
  "item.minecraft.splash_potion.effect.luck": "Pahtli ahkomahkāwalōni tlen tōnalli",
  "item.minecraft.splash_potion.effect.mundane": "Axkwaltsin pahtli ahkomahkāwalōni",
  "item.minecraft.splash_potion.effect.night_vision": "Pahtli ahkomahkāwalōni tlen yowaltlachiyalistli",
  "item.minecraft.splash_potion.effect.oozing": "Pahtli ahkomahkāwalōni tlen yakakwitlayōtl",
  "item.minecraft.splash_potion.effect.poison": "Pahtli ahkomahkāwalōni",
  "item.minecraft.splash_potion.effect.regeneration": "Pahtli ahkomahkāwalōni tlen tlapahtilistli",
  "item.minecraft.splash_potion.effect.slow_falling": "Pahtli ahkomahkāwalōni tlen yōlik wetsilistli",
  "item.minecraft.splash_potion.effect.slowness": "Pahtli ahkomahkāwalōni tlen yōlikāyōtl",
  "item.minecraft.splash_potion.effect.strength": "Pahtli ahkomahkāwalōni tlen chikāwakāyōtl",
  "item.minecraft.splash_potion.effect.swiftness": "Pahtli ahkomahkāwalōni tlen isiwkakāyōtl",
  "item.minecraft.splash_potion.effect.thick": "Ātōltik pahtli ahkomahkāwalōni",
  "item.minecraft.splash_potion.effect.turtle_master": "Pahtli ahkomahkāwalōni tlen Tlamachtihkētl Āyōtl",
  "item.minecraft.splash_potion.effect.water": "Lemeteh ahkomahkāwalōni īka ātl",
  "item.minecraft.splash_potion.effect.water_breathing": "Pahtli ahkomahkāwalōni tlen āmihyōkwilistli",
  "item.minecraft.splash_potion.effect.weakness": "Pahtli ahkomahkāwalōni tlen axchikāwakāyōtl",
  "item.minecraft.splash_potion.effect.weaving": "Pahtli ahkomahkāwalōni tlen tlatsāwalistli",
  "item.minecraft.splash_potion.effect.wind_charged": "Pahtli ahkomahkāwalōni tlen ehēkalistli",
  "item.minecraft.spruce_boat": "Okoākalli",
  "item.minecraft.spruce_chest_boat": "Okoākalli īka kwapetlakalli",
  "item.minecraft.spyglass": "Katalehoh",
  "item.minecraft.squid_spawn_egg": "Ātokanēxtihkētl",
  "item.minecraft.stick": "Kwawitl",
  "item.minecraft.stone_axe": "Tetlatekōni",
  "item.minecraft.stone_hoe": "Teasadon",
  "item.minecraft.stone_pickaxe": "Tetlālteposkwapinmomolotsalli",
  "item.minecraft.stone_shovel": "Tetlaakanōni",
  "item.minecraft.stone_spear": "Tetōpīlli",
  "item.minecraft.stone_sword": "Temākkwawitl",
  "item.minecraft.stray_spawn_egg": "Wahkakīskānēxtihkētl",
  "item.minecraft.strider_spawn_egg": "Tliānehnenkānēxtihkētl",
  "item.minecraft.string": "Īloh",
  "item.minecraft.sugar": "Tlatsopēlihkētl",
  "item.minecraft.suspicious_stew": "Kehnipatik āyōtl",
  "item.minecraft.sweet_berries": "Tsopēlik āmakapolin",
  "item.minecraft.tadpole_bucket": "Kobetah īka axkalatl",
  "item.minecraft.tadpole_spawn_egg": "Axkalanēxtihkētl",
  "item.minecraft.tide_armor_trim_smithing_template": "Teposolisplantiyah",
  "item.minecraft.tide_armor_trim_smithing_template.new": "Wēyāehēkaornamentoh",
  "item.minecraft.tipped_arrow": "Mītl īka pahyōtl",
  "item.minecraft.tipped_arrow.effect.awkward": "Mītl īka pahyōtl",
  "item.minecraft.tipped_arrow.effect.empty": "Mītl īka pahyōtl axchihchīwalōni",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "Mītl tlen tliihyōwilistli",
  "item.minecraft.tipped_arrow.effect.harming": "Mītl tlen tlakokolistli",
  "item.minecraft.tipped_arrow.effect.healing": "Mītl tlen kwaltilistli",
  "item.minecraft.tipped_arrow.effect.infested": "Mītl tlen chipohyohkāyōtl",
  "item.minecraft.tipped_arrow.effect.invisibility": "Mītl tlen axtlachiyalissōtl",
  "item.minecraft.tipped_arrow.effect.leaping": "Mītl tlen witōnilistli",
  "item.minecraft.tipped_arrow.effect.levitation": "Mītl tlen patlānilistli",
  "item.minecraft.tipped_arrow.effect.luck": "Mītl tlen tōnalli",
  "item.minecraft.tipped_arrow.effect.mundane": "Mītl īka pahyōtl",
  "item.minecraft.tipped_arrow.effect.night_vision": "Mītl tlen yowaltlachiyalistli",
  "item.minecraft.tipped_arrow.effect.oozing": "Mītl tlen yakakwitlayōtl",
  "item.minecraft.tipped_arrow.effect.poison": "Mītl tlen pahtli",
  "item.minecraft.tipped_arrow.effect.regeneration": "Mītl tlen tlapahtilistli",
  "item.minecraft.tipped_arrow.effect.slow_falling": "Mītl tlen yōlik wetsilistli",
  "item.minecraft.tipped_arrow.effect.slowness": "Mītl tlen yōlikāyōtl",
  "item.minecraft.tipped_arrow.effect.strength": "Mītl tlen chikāwakāyōtl",
  "item.minecraft.tipped_arrow.effect.swiftness": "Mītl tlen isiwkakāyōtl",
  "item.minecraft.tipped_arrow.effect.thick": "Mītl īka pahyōtl",
  "item.minecraft.tipped_arrow.effect.turtle_master": "Tlamachtihkētl Āyōtl īmīw",
  "item.minecraft.tipped_arrow.effect.water": "Mītl tētsitsikwitswilihkētl",
  "item.minecraft.tipped_arrow.effect.water_breathing": "Mītl tlen āmihyōkwilistli",
  "item.minecraft.tipped_arrow.effect.weakness": "Mītl tlen axchikāwakāyōtl",
  "item.minecraft.tipped_arrow.effect.weaving": "Mītl tlen tlatsāwalistli",
  "item.minecraft.tipped_arrow.effect.wind_charged": "Mītl tlen ehēkalistli",
  "item.minecraft.tnt_minecart": "Bagonetah īka dinamitah",
  "item.minecraft.torchflower_seeds": "Tlāwilikōxōchikwayōllōtl",
  "item.minecraft.totem_of_undying": "Totem tlen axmikilissōtl",
  "item.minecraft.trader_llama_spawn_egg": "Pochtēkapelōnichkanēxtihkētl",
  "item.minecraft.trial_key": "Owihkāyōtlapōlli",
  "item.minecraft.trident": "Mīnakachalli",
  "item.minecraft.tropical_fish": "Āwakwawtlan michin",
  "item.minecraft.tropical_fish_bucket": "Kobetah īka āwakwawtlan michin",
  "item.minecraft.tropical_fish_spawn_egg": "Āwakwawtlan michnēxtihkētl",
  "item.minecraft.turtle_helmet": "Pankahkallōtl",
  "item.minecraft.turtle_scute": "Āyōtotominyōtl",
  "item.minecraft.turtle_spawn_egg": "Āyōnēxtihkētl",
  "item.minecraft.vex_armor_trim_smithing_template": "Teposolisplantiyah",
  "item.minecraft.vex_armor_trim_smithing_template.new": "Tēkwātotōnihkāornamentoh",
  "item.minecraft.vex_spawn_egg": "Tēkwātotōnihkānēxtihkētl",
  "item.minecraft.villager_spawn_egg": "Māsēwalnēxtihkētl",
  "item.minecraft.vindicator_spawn_egg": "Tēyēktilihkānēxtihkētl",
  "item.minecraft.wandering_trader_spawn_egg": "Pochtēkanēxtihkētl nehnēnkētl",
  "item.minecraft.ward_armor_trim_smithing_template": "Teposolisplantiyah",
  "item.minecraft.ward_armor_trim_smithing_template.new": "Tlapīxkāornamentoh",
  "item.minecraft.warden_spawn_egg": "Ōstōkpīxkānēxtihkētl",
  "item.minecraft.warped_fungus_on_a_stick": "Kwawitl īka koltik nanakatl",
  "item.minecraft.water_bucket": "Kobetah īka ātl",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "Teposolisplantiyah",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "Ohtēmohkāornamentoh",
  "item.minecraft.wheat": "Kaxtīllān tlayōlli",
  "item.minecraft.wheat_seeds": "Kaxtīllān tlayōlkwayōllōtl",
  "item.minecraft.white_bundle": "Chipāwak fōlsah",
  "item.minecraft.white_dye": "Chipāwak tlapālōni",
  "item.minecraft.white_harness": "Chipāwak kechkwayohtli",
  "item.minecraft.wild_armor_trim_smithing_template": "Teposolisplantiyah",
  "item.minecraft.wild_armor_trim_smithing_template.new": "Kwawtlan ornamentoh",
  "item.minecraft.wind_charge": "Ehēkanechikolistli",
  "item.minecraft.witch_spawn_egg": "Siwātlaīxkahkayāwkānēxtihkētl",
  "item.minecraft.wither_skeleton_spawn_egg": "Āpīsmikkānēxtihkētl īāxkā Wither",
  "item.minecraft.wither_spawn_egg": "Wither-nēxtihkētl",
  "item.minecraft.wolf_armor": "Yāōwīpīlli inik tenexkoyōtl",
  "item.minecraft.wolf_spawn_egg": "Tenexkoyōnēxtihkētl",
  "item.minecraft.wooden_axe": "Kwatlatekōni",
  "item.minecraft.wooden_hoe": "Kwaasadon",
  "item.minecraft.wooden_pickaxe": "Kwatlālteposkwapinmomolotsalli",
  "item.minecraft.wooden_shovel": "Kwatlaakanōni",
  "item.minecraft.wooden_spear": "Kwatōpīlli",
  "item.minecraft.wooden_sword": "Mākkwawitl",
  "item.minecraft.writable_book": "Āmoxtli īwān tlikolli",
  "item.minecraft.written_book": "Tlatekiwilli āmoxtli",
  "item.minecraft.yellow_bundle": "Kōstik fōlsah",
  "item.minecraft.yellow_dye": "Kōstik tlapālōni",
  "item.minecraft.yellow_harness": "Kōstik kechkwayohtli",
  "item.minecraft.zoglin_spawn_egg": "Zoglin-nēxtihkētl",
  "item.minecraft.zombie_horse_spawn_egg": "Kokoxki kawāyohnēxtihkētl",
  "item.minecraft.zombie_nautilus_spawn_egg": "Kokōxki naotilohnēxtihkētl",
  "item.minecraft.zombie_spawn_egg": "Kokoxkānēxtihkētl",
  "item.minecraft.zombie_villager_spawn_egg": "Kokoxki māsēwalnēxtihkētl",
  "item.minecraft.zombified_piglin_spawn_egg": "Kokoxki piglinnēxtihkētl"
}
export const nah = items; 
